export const dataPrismic = {
    "values": [{
        "label": "Si",
        "value": "si",
        "shortcut": ""
    },
    {
        "label": "No",
        "value": "no",
        "shortcut": ""
    }
    ],
    "id": "YYwfzBEAACMAExyt",
    "uid": "plan-vive",
    "url": null,
    "type": "flujo_cotizacion_v2",
    "href": "https://cotizadores-suramex-qa.cdn.prismic.io/api/v2/documents/search?ref=YecEgxEAACAAoY1i&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22YYwfzBEAACMAExyt%22%29+%5D%5D",
    "tags": [],
    "first_publication_date": "2021-11-10T19:41:26+0000",
    "last_publication_date": "2022-01-18T18:18:43+0000",
    "slugs": [
        "hola-para-iniciar-ingresa-algunos-datos-personales"
    ],
    "linked_documents": [],
    "lang": "es-mx",
    "alternate_languages": [],
    "data": {
        "showhomepage": true,
        "email_info": [{
            "type": "paragraph",
            "text": "Si lo deseas puedes solicitar el cambio de beneficiarios al correo mxmesadecontrolcec@segurossura.com.mc",
            "spans": [{
                "start": 67,
                "end": 104,
                "type": "hyperlink",
                "data": {
                    "link_type": "Web",
                    "url": "mailto:mxmesadecontrolcec@segurossura.com.mc"
                }
            }]
        }],
        "body": [{
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "fechaNacimiento"
            },
            {
                "fieldkey": "claveOcupacion"
            },
            {
                "fieldkey": "peso"
            },
            {
                "fieldkey": "talla"
            },
            {
                "fieldkey": "imc"
            },
            {
                "fieldkey": "esFumador"
            },
            {
                "fieldkey": "claveAliado"
            },
            {
                "fieldkey": "status"
            },
            {
                "fieldkey": "urlCuestionariosMedicos"
            },
            {
                "fieldkey": "folio"
            },
            {
                "fieldkey": "beneficiarios"
            }
            ],
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Hola, para iniciar ingresa algunos datos personales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "No",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "80-20",
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/validaciones/suscripciones-previas?fechaNacimiento=value&peso=value&talla=value&claveOcupacion=value\",\n  \"method\": \"GET\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "genero"
            }],
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Selecciona tu género",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "claveTipoFamilia"
            },
            {
                "fieldkey": "incluyeMascotas"
            }
            ],
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "¿Cómo es tu familia?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "mascotas"
            }],
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "¿Qué tipo de mascota tienes?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "atrTipoTemporalidad"
            },
            {
                "fieldkey": "monedaId"
            }
            ],
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Selecciona la temporalidad y moneda de tu póliza:",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "50-50",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "coberturas"
            }],
            "primary": {
                "associated_group": "step_configura_tu_poliza",
                "title": [{
                    "type": "heading6",
                    "text": "Elige tus coberturas y sumas aseguradas",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "coberturasAdicionales"
            }],
            "primary": {
                "associated_group": "step_configura_tu_poliza",
                "title": [{
                    "type": "heading6",
                    "text": "¿Te gustaría personalizar tu experiencia con estas coberturas adicionales?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "nombre"
            },
            {
                "fieldkey": "email"
            },
            {
                "fieldkey": "telefono"
            },
            {
                "fieldkey": "noSoyUnRobot"
            },
            {
                "fieldkey": "avisoPrivacidad"
            }
            ],
            "primary": {
                "associated_group": "step_cotizacion",
                "title": [],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "50-50",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "planes"
            }],
            "primary": {
                "associated_group": "step_cotizacion",
                "title": [{
                    "type": "heading6",
                    "text": "Planes",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "No",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "identificadorPersona"
            },
            {
                "fieldkey": "validarRfc"
            },
            {
                "fieldkey": "fakeField"
            },
            {
                "fieldkey": "primerNombre"
            },
            {
                "fieldkey": "primerApellido"
            },
            {
                "fieldkey": "segundoApellido"
            },
            {
                "fieldkey": "curp"
            },
            {
                "fieldkey": "sexo"
            },
            {
                "fieldkey": "fechaDeNacimientoAsegurado"
            },
            {
                "fieldkey": "estadoCivil"
            },
            {
                "fieldkey": "pais"
            },
            {
                "fieldkey": "lugarNacimiento"
            },
            {
                "fieldkey": "nacionalidad"
            },
            {
                "fieldkey": "ocupacionProfesion"
            },
            {
                "fieldkey": "ingresosMensuales"
            },
            {
                "fieldkey": "email1"
            },
            {
                "fieldkey": "telefonoCelular"
            },
            {
                "fieldkey": "tipoDeIdentificacionEntregada"
            },
            {
                "fieldkey": "folioDeIdentificacionEntregada"
            },
            {
                "fieldkey": "residenteFiscalExtranjero"
            },
            {
                "fieldkey": "paisResidenteFiscal"
            },
            {
                "fieldkey": "nIdentificacionEnElExtranjero"
            },
            {
                "fieldkey": "direccion"
            },
            {
                "fieldkey": "nExterior"
            },
            {
                "fieldkey": "nIterior"
            },
            {
                "fieldkey": "codigoPostal"
            },
            {
                "fieldkey": "estadoAsegurado"
            },
            {
                "fieldkey": "coloniaAsegurado"
            }
            ],
            "primary": {
                "associated_group": "step_emision_asegurado",
                "title": [{
                    "type": "heading6",
                    "text": "Información del asegurado titular",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "60-40",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "cuentaConOtroSeguroDeVidaContratadoDeFormaVoluntaria"
            },
            {
                "fieldkey": "leHanRechazadoLimitadoOExtraPrimadoAlgunaSolicitud"
            }
            ],
            "primary": {
                "associated_group": "step_emision_asegurado",
                "title": [{
                    "type": "heading6",
                    "text": "Identificación y conocimiento del cliente",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado"
            },
            {
                "fieldkey": "tipoDePersonaContratante"
            },
            {
                "fieldkey": "identificadorPersonaContratante"
            },
            {
                "fieldkey": "identificadorPersonaContratanteMoral"
            },
            {
                "fieldkey": "validarRfcContratante"
            },
            {
                "fieldkey": "fakeField"
            },
            {
                "fieldkey": "primerNombreContratante"
            },
            {
                "fieldkey": "primerApellidoContratante"
            },
            {
                "fieldkey": "segundoApellidoContratante"
            },
            {
                "fieldkey": "curpContratante"
            },
            {
                "fieldkey": "sexoContratante"
            },
            {
                "fieldkey": "fechaNacimientoContratante"
            },
            {
                "fieldkey": "estadoCivilContratante"
            },
            {
                "fieldkey": "paisNacimientoContratante"
            },
            {
                "fieldkey": "lugarNacimientoContratante"
            },
            {
                "fieldkey": "nacionalidadContratante"
            },
            {
                "fieldkey": "ocupacionProfesionContratante"
            },
            {
                "fieldkey": "ingresosMensualesContratante"
            },
            {
                "fieldkey": "emailContratante"
            },
            {
                "fieldkey": "telefonoCelularContratante"
            },
            {
                "fieldkey": "nombreDelApoderadoLegalContratante"
            },
            {
                "fieldkey": "fechaDeNacimientoDelApoderadoContratante"
            },
            {
                "fieldkey": "anadirApoderadoLegalContratante"
            },
            {
                "fieldkey": "tipoDeIdentificacionEntregadaContratante"
            },
            {
                "fieldkey": "folioDeIdentificacionEntregadaContratante"
            },
            {
                "fieldkey": "residenteFiscalExtranjeroContratante"
            },
            {
                "fieldkey": "paisResidenteFiscalContratante"
            },
            {
                "fieldkey": "nIdentificacionEnElExtranjeroContratante"
            },
            {
                "fieldkey": "direccionContratante"
            },
            {
                "fieldkey": "nExteriorContratante"
            },
            {
                "fieldkey": "nIteriorContratante"
            },
            {
                "fieldkey": "codigoPostalContratante"
            },
            {
                "fieldkey": "estadoContratante"
            },
            {
                "fieldkey": "coloniaContratante"
            },
            {
                "fieldkey": "razonSocialContratante"
            },
            {
                "fieldkey": "fechaDeConstitucionContratante"
            }
            ],
            "primary": {
                "associated_group": "step_emision_contratante",
                "title": [{
                    "type": "heading6",
                    "text": "Datos del contratante",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "50-50",
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/find-form-medical\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "asegurados"
            }],
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de los asegurados adicionales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "heading3",
                    "text": "Cobertura de gastos funerarios",
                    "spans": [{
                        "start": 0,
                        "end": 30,
                        "type": "strong"
                    }]
                },
                {
                    "type": "paragraph",
                    "text": "La designación de beneficiarios para esta cobertura es recíproca, es decir, en caso de fallecimiento del cónyuge, se entrega el 100% de la suma asegurada al titular.",
                    "spans": []
                }
                ],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "mascotas"
            }],
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de los asegurados adicionales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "heading3",
                    "text": "Asegurados adicionales para mascotas",
                    "spans": [{
                        "start": 0,
                        "end": 36,
                        "type": "strong"
                    }]
                },
                {
                    "type": "paragraph",
                    "text": "La designación de beneficiarios para esta cobertura es recíproca, es decir, en caso de fallecimiento del cónyuge, se entrega el 100% de la suma asegurada al titular.",
                    "spans": []
                }
                ],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "beneficiarios"
            },
            {
                "fieldkey": "mensajeErrorPorcentaje"
            }
            ],
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de el o los beneficiarios",
                    "spans": []
                }],
                "collapse_description": true,
                "description": [{
                    "type": "paragraph",
                    "text": "Si estás considerando renombrar a un menor de edad como beneficiario es importante que consideres la siguiente información.",
                    "spans": []
                }],
                "collapsable_text": [{
                    "type": "paragraph",
                    "text": "Al nombrar beneficiarios menores de edad no se debe señalar a un mayor de edad como representante del menor, para que en su representación cobre la indemnización; ya que la legislación señala la forma en que deben designarse tutores, albaceas u otros cargos similares y no consideran al contrato de seguro como el instrumento adecuando para tal designación. Si designas a un mayor de edad como representante del menor beneficiario durante su minoría de edad, legalmente puede implicar que se nombra como beneficiario al mayor de edad, quien solo tendrá una obligación moral, pues la designación que se hace de beneficiarios en un contrato de seguro le concede el derecho incondicionado de disponer de la suma asegurada.",
                    "spans": []
                }],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "estadoCuestionario"
            },
            {
                "fieldkey": "fakeField"
            },
            {
                "fieldkey": "fakeField"
            },
            {
                "fieldkey": "completarCuestionario"
            },
            {
                "fieldkey": "copiarEnlace"
            },
            {
                "fieldkey": "enviarEnlace"
            },
            {
                "fieldkey": "actualizar"
            },
            {
                "fieldkey": "mensajeModalElegibleConExtraprima"
            },
            {
                "fieldkey": "mensajeModalNoElegible"
            }
            ],
            "primary": {
                "associated_group": "step_cuestionario_medico",
                "title": [{
                    "type": "heading6",
                    "text": "Cuestionario Médico",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "paragraph",
                    "text": "Para continuar con la contratación del seguro de vida Plan Vive, es necesario completar un breve cuestionario de salud. Ten a mano tu identificación oficial.",
                    "spans": []
                }],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            }
        },
        {
            "slice_type": "step__grupopregunta",
            "slice_label": null,
            "items": [{
                "fieldkey": "periodicidadPagoId"
            },
            {
                "fieldkey": "pago"
            },
            {
                "fieldkey": "aceptOne"
            },
            {
                "fieldkey": "aceptTwo"
            }
            ],
            "primary": {
                "associated_group": "step_pasarela_pago",
                "title": [{
                    "type": "heading6",
                    "text": "Periodicidad de pago",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/emit-insurance\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n   },\n  \"body\": {}\n}",
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/check-payment-status?referencia={referencia}\",\n  \"method\": \"GET\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n   },\n  \"body\": {}\n}"
            }
        }
        ],
        "orderbysteps": [{
            "name": "Algunos datos",
            "key_step": "step_personales",
            "api_service": null
        },
        {
            "name": "Configura tu póliza",
            "key_step": "step_configura_tu_poliza",
            "api_service": null
        },
        {
            "name": "Cotización",
            "key_step": "step_cotizacion",
            "api_service": null
        },
        {
            "name": "Emisión Asegurado",
            "key_step": "step_emision_asegurado",
            "api_service": null
        },
        {
            "name": "Asegurados",
            "key_step": "step_asegurados",
            "api_service": null
        },
        {
            "name": "Emisión Contratante",
            "key_step": "step_emision_contratante",
            "api_service": null
        },
        {
            "name": "Cuestionario Médico",
            "key_step": "step_cuestionario_medico",
            "api_service": null
        },
        {
            "name": "Periodicidad de pago",
            "key_step": "step_pasarela_pago",
            "api_service": null
        }
        ]
    }
};
export const dataPrismicVidaGrupo = {
    "id": "YioG6hIAAC0AR2_e",
    "uid": "vida-grupo",
    "url": null,
    "type": "flujo_cotizacion_v2",
    "href": "https://portal-cotizacion-suramex.cdn.prismic.io/api/v2/documents/search?ref=Ynl60hIAACwAjDEu&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22YioG6hIAAC0AR2_e%22%29+%5D%5D",
    "tags": [],
    "first_publication_date": "2022-03-10T14:11:25+0000",
    "last_publication_date": "2022-05-07T00:17:42+0000",
    "slugs": [
        "modalidad",
        "hola-para-iniciar-ingresa-algunos-datos-personales"
    ],
    "linked_documents": [],
    "lang": "es-mx",
    "alternate_languages": [],
    "data": {
        "email_info": [
            {
                "type": "paragraph",
                "text": "Si lo deseas puedes solicitar el cambio de beneficiarios al correo mxmesadecontrolcec@segurossura.com.mc",
                "spans": [
                    {
                        "start": 67,
                        "end": 104,
                        "type": "hyperlink",
                        "data": {
                            "link_type": "Web",
                            "url": "mailto:mxmesadecontrolcec@segurossura.com.mc"
                        }
                    }
                ]
            }
        ],
        "recaptchakey": "6LcaxFAeAAAAAM_udMeSx9Ur_tHfq279l4t34ri3",
        "body": [
            {
                "primary": {
                    "associated_group": "step_etapas",
                    "title": [
                        {
                            "type": "heading6",
                            "text": "Modalidad",
                            "spans": []
                        }
                    ],
                    "collapse_description": false,
                    "description": [],
                    "collapsable_text": [],
                    "buttonnext": "No",
                    "returnbutton": "No",
                    "sidebar": "No",
                    "barrainfosuperior": "No",
                    "enable_email": "No",
                    "columns": "1",
                    "relationship_columns": "80-20",
                    "opciones_servicio": null,
                    "sidebar_service": null,
                    "service_btn": null,
                    "opciones_servicio_segundo_plano": null,
                    "finalmodal": null
                },
                "items": [
                    {
                        "fieldkey": "modalidad"
                    },
                    {
                        "fieldkey": "etapas"
                    }
                ],
                "slice_type": "step__grupopregunta",
                "slice_label": null
            },
            {
                "primary": {
                    "associated_group": "step_crear_planes",
                    "title": [
                        {
                            "type": "heading6",
                            "text": "",
                            "spans": []
                        }
                    ],
                    "collapse_description": false,
                    "description": [
                        {
                            "type": "paragraph",
                            "text": "",
                            "spans": []
                        }
                    ],
                    "collapsable_text": [],
                    "buttonnext": "Si",
                    "returnbutton": "Si",
                    "sidebar": "Si",
                    "barrainfosuperior": "Si",
                    "enable_email": "No",
                    "columns": "1",
                    "relationship_columns": null,
                    "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/vida-grupo/find-num-folio\",\n  \"method\": \"GET\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                    "sidebar_service": null,
                    "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n  \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                    "opciones_servicio_segundo_plano": null,
                    "finalmodal": null
                },
                "items": [
                    {
                        "fieldkey": "comision"
                    },
                    {
                        "fieldkey": "tabsCotizacion"
                    },
                    {
                        "fieldkey": "folio"
                    }
                ],
                "slice_type": "step__grupopregunta",
                "slice_label": null
            },
            {
                "primary": {
                    "associated_group": "step_formulario",
                    "title": [
                        {
                            "type": "heading6",
                            "text": "Información de la empresa",
                            "spans": []
                        }
                    ],
                    "collapse_description": false,
                    "description": [],
                    "collapsable_text": [],
                    "buttonnext": "Si",
                    "returnbutton": "Si",
                    "sidebar": "Si",
                    "barrainfosuperior": "No",
                    "enable_email": "No",
                    "columns": "3",
                    "relationship_columns": null,
                    "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/catalogos-dev/codigopostal?codigoPostal=value&catalogo=COLONIA\",\n  \"method\": \"GET\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"09e5ece8bcbf4ff4b1d099fb45e7b3bc\"\n  },\n  \"body\": {}\n}",
                    "sidebar_service": null,
                    "service_btn": null,
                    "opciones_servicio_segundo_plano": null,
                    "finalmodal": "{\n\t\"topTitle\": \"Descarga de formulario\",\n\t\"title\": \"Etapa 1 finalizada\",\n\t\"description\": \"Regrese al inicio para continuar con la etapa 2 o generar una nueva cotización\",\n\t\"icon\": \"fa-check-circle\",\n\t\"action\": \"reload\"\n}"
                },
                "items": [
                    {
                        "fieldkey": "nombre"
                    },
                    {
                        "fieldkey": "rfc"
                    },
                    {
                        "fieldkey": "giro"
                    },
                    {
                        "fieldkey": "codigoPostal"
                    },
                    {
                        "fieldkey": "email"
                    },
                    {
                        "fieldkey": "telefonoCelular"
                    },
                    {
                        "fieldkey": "inicioVigencia"
                    },
                    {
                        "fieldkey": "finVigencia"
                    }
                ],
                "slice_type": "step__grupopregunta",
                "slice_label": null
            },
            {
                "primary": {
                    "associated_group": "page4",
                    "title": [],
                    "collapse_description": false,
                    "description": [],
                    "collapsable_text": [],
                    "buttonnext": "Si",
                    "returnbutton": "Si",
                    "sidebar": "No",
                    "barrainfosuperior": "No",
                    "enable_email": "No",
                    "columns": "1",
                    "relationship_columns": null,
                    "opciones_servicio": null,
                    "sidebar_service": null,
                    "service_btn": null,
                    "opciones_servicio_segundo_plano": null,
                    "finalmodal": null
                },
                "items": [
                    {
                        "fieldkey": null
                    }
                ],
                "slice_type": "step__grupopregunta",
                "slice_label": null
            }
        ],
        "orderbysteps": [
            {
                "name": "Etapas",
                "key_step": "step_etapas",
                "api_service": null
            },
            {
                "name": "Crear Planes",
                "key_step": "step_crear_planes",
                "api_service": null
            },
            {
                "name": "Formulario",
                "key_step": "step_formulario",
                "api_service": null
            },
            {
                "name": "Form",
                "key_step": "page4",
                "api_service": null
            }
        ],
        "showhomepage": false,
        "logo": {
            "dimensions": {
                "width": 131,
                "height": 46
            },
            "alt": null,
            "copyright": null,
            "url": "https://images.prismic.io/portal-cotizacion-suramex/34f22ff2-b62d-4a12-ab54-6061c00a636a_logo.png?auto=compress,format"
        },
        "headermenulinks": [],
        "homepagecontent": []
    }
}

export const dataPrismicValues = {
    "label": "Cuénta con otro seguro de vida contratado de forma voluntaria?",
    "optionsLabelPosition": "right",
    "customClass": "radioText",
    "inline": false,
    "tableView": false,
    "values": [{
        "label": "Si",
        "value": "si",
        "shortcut": ""
    },
    {
        "label": "No",
        "value": "no",
        "shortcut": ""
    }
    ],
    "validate": {
        "required": true
    },
    "key": "cuentaConOtroSeguroDeVidaContratadoDeFormaVoluntaria",
    "type": "radio",
    "input": true
};

export const dataPrismicValuesRadioImage = {
    "label": "Genero",
    "optionsLabelPosition": "right",
    "customClass": "radioImage",
    "inline": false,
    "tableView": false,
    "values": [{
        "label": "Femenino",
        "value": "M",
        "shortcut": ""
    },
    {
        "label": "Masculino",
        "value": "H",
        "shortcut": ""
    }
    ],
    "validate": {
        "required": true
    },
    "key": "genero",
    "properties": {
        "H": "https://images.prismic.io/portal-cotizacion-suramex/0399ebf0-3ec8-4cf6-9f70-0f1105be2022_men.png?auto=compress,format",
        "M": "https://images.prismic.io/portal-cotizacion-suramex/4cb0207a-34b8-41c3-b8f0-1c94de47c94e_women.png?auto=compress,format"
    },
    "type": "radio",
    "input": true
};

export const dataPrismic123123 = {
    id: "YVdychEAACQArUyL",
    uid: "planvive",
    url: null,
    type: "flujo_cotizacion_v2",
    href: "https://portal-cotizacion-suramex.cdn.prismic.io/api/v2/documents/search?ref=YXxHkxEAACMADjR8&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22YVdychEAACQArUyL%22%29+%5D%5D",
    tags: [],
    first_publication_date: "2021-10-04T14:48:19+0000",
    last_publication_date: "2021-10-29T19:12:19+0000",
    slugs: ["hola-para-iniciar-ingresa-algunos-datos-personales"],
    linked_documents: [],
    lang: "es-mx",
    alternate_languages: [],
    data: {
        body: [{
            slice_type: "step__grupopregunta",
            slice_label: null,
            items: [{
                fieldkey: "fechaNacimiento",
            },
            {
                fieldkey: "claveOcupacion",
            },
            {
                fieldkey: "pesoKilogramos",
            },
            {
                fieldkey: "alturaEnMetros",
            },
            {
                fieldkey: "imc",
            },
            {
                fieldkey: "eresFumador",
            },
            {
                fieldkey: "claveAliado",
            },
            ],
            primary: {
                associated_group: "step_personales",
                title: [{
                    type: "heading6",
                    text: "Hola, para iniciar ingresa algunos datos personales",
                    spans: [],
                },],
                columns: "2",
                relationship_columns: "80-20",
                opciones_servicio: '{\n  "url": "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/validaciones/suscripciones-previas?fechaNacimiento=value&imc=value&claveOcupacion=value",\n  "method": "GET",\n  "headers": {\n    "Content-Type": "application/json",\n    "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"\n  },\n  "body": {}\n}',
            },
        },
        {
            slice_type: "step__grupopregunta",
            slice_label: null,
            items: [{
                fieldkey: "genero",
            },],
            primary: {
                associated_group: "step_personales",
                title: [{
                    type: "heading6",
                    text: "Selecciona tu género",
                    spans: [],
                },],
                columns: "1",
                relationship_columns: null,
                opciones_servicio: null,
            },
        },
        {
            slice_type: "step__grupopregunta",
            slice_label: null,
            items: [{
                fieldkey: "claveTipoFamilia",
            },
            {
                fieldkey: "incluyeMascotas",
            },
            ],
            primary: {
                associated_group: "step_personales",
                title: [{
                    type: "heading6",
                    text: "¿Cómo es tu familia?",
                    spans: [],
                },],
                columns: "2",
                relationship_columns: "80-20",
                opciones_servicio: null,
            },
        },
        {
            slice_type: "step__grupopregunta",
            slice_label: null,
            items: [{
                fieldkey: "mascotas",
            },],
            primary: {
                associated_group: "step_personales",
                title: [{
                    type: "heading6",
                    text: "¿Qué tipo de mascota tienes?",
                    spans: [],
                },],
                columns: "1",
                relationship_columns: null,
                opciones_servicio: null,
            },
        },
        {
            slice_type: "step__grupopregunta",
            slice_label: null,
            items: [{
                fieldkey: "tiempoContratoSeguro",
            },
            {
                fieldkey: "monedaCobertura",
            },
            ],
            primary: {
                associated_group: "step_personales",
                title: [{
                    type: "heading6",
                    text: "Selecciona la temporalidad y moneda de tu póliza:",
                    spans: [],
                },],
                columns: "2",
                relationship_columns: "50-50",
                opciones_servicio: null,
            },
        },
        {
            slice_type: "step__grupopregunta",
            slice_label: null,
            items: [{
                fieldkey: "coberturas",
            },],
            primary: {
                associated_group: "step_configura_tu_poliza",
                title: [{
                    type: "heading6",
                    text: "Elige tus coberturas y sumas aseguradas",
                    spans: [],
                },],
                columns: "1",
                relationship_columns: "80-20",
                opciones_servicio: null,
            },
        },
        {
            slice_type: "step__grupopregunta",
            slice_label: null,
            items: [{
                fieldkey: "coberturasAdicionales",
            },],
            primary: {
                associated_group: "step_configura_tu_poliza",
                title: [{
                    type: "heading6",
                    text: "¿Te gustaría personalizar tu experiencia con estas coberturas adicionales?",
                    spans: [],
                },],
                columns: "1",
                relationship_columns: "80-20",
                opciones_servicio: null,
            },
        },
        {
            slice_type: "step__grupopregunta",
            slice_label: null,
            items: [{
                fieldkey: "nombre",
            },
            {
                fieldkey: "correo",
            },
            {
                fieldkey: "telefonoCelular",
            },
            {
                fieldkey: "noSoyUnRobot",
            },
            {
                fieldkey: "avisoPrivacidad",
            },
            ],
            primary: {
                associated_group: "step_cotizacion",
                title: [],
                columns: "2",
                relationship_columns: "50-50",
                opciones_servicio: null,
            },
        },
        {
            slice_type: "step__grupopregunta",
            slice_label: null,
            items: [{
                fieldkey: "planes",
            },],
            primary: {
                associated_group: "step_cotizacion",
                title: [{
                    type: "heading6",
                    text: "Planes",
                    spans: [],
                },],
                columns: "1",
                relationship_columns: null,
                opciones_servicio: null,
            },
        },
        ],
        orderbysteps: [{
            name: "Algunos datos",
            key_step: "step_personales",
            api_service: null,
        },
        {
            name: "Configura tu póliza",
            key_step: "step_configura_tu_poliza",
            api_service: null,
        },
        {
            name: "Cotización",
            key_step: "step_cotizacion",
            api_service: null,
        },
        ],
    },
};

export const dataPrismicRadioText = {
    "id": "YVdychEAACQArUyL",
    "uid": "plan-vive",
    "url": null,
    "type": "flujo_cotizacion_v2",
    "href": "https://portal-cotizacion-suramex.cdn.prismic.io/api/v2/documents/search?ref=YecEBRIAACIAg68v&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22YVdychEAACQArUyL%22%29+%5D%5D",
    "tags": [],
    "first_publication_date": "2021-10-04T14:48:19+0000",
    "last_publication_date": "2022-01-18T18:16:37+0000",
    "slugs": [
        "hola-para-iniciar-ingresa-algunos-datos-personales"
    ],
    "linked_documents": [],
    "lang": "es-mx",
    "alternate_languages": [],
    "data": {
        "email_info": [{
            "type": "paragraph",
            "text": "Si lo deseas puedes solicitar el cambio de beneficiarios al correo mxmesadecontrolcec@segurossura.com.mc",
            "spans": [{
                "start": 67,
                "end": 104,
                "type": "hyperlink",
                "data": {
                    "link_type": "Web",
                    "url": "mailto:mxmesadecontrolcec@segurossura.com.mc"
                }
            }]
        }],
        "body": [{
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Hola, para iniciar ingresa algunos datos personales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "No",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "80-20",
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/validaciones/suscripciones-previas?fechaNacimiento=value&claveOcupacion=value&peso=value&talla=value\",\n  \"method\": \"GET\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"09e5ece8bcbf4ff4b1d099fb45e7b3bc\"\n  },\n  \"body\": {}\n}",
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "fechaNacimiento"
            },
            {
                "fieldkey": "claveOcupacion"
            },
            {
                "fieldkey": "peso"
            },
            {
                "fieldkey": "talla"
            },
            {
                "fieldkey": "imc"
            },
            {
                "fieldkey": "esFumador"
            },
            {
                "fieldkey": "claveAliado"
            },
            {
                "fieldkey": "status"
            },
            {
                "fieldkey": "urlCuestionariosMedicos"
            },
            {
                "fieldkey": "folio"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Selecciona tu género",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "genero"
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "¿Cómo es tu familia?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "claveTipoFamilia"
            },
            {
                "fieldkey": "incluyeMascotas"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "¿Qué tipo de mascota tienes?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "mascotas"
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Selecciona la temporalidad y moneda de tu póliza:",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "50-50",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "atrTipoTemporalidad"
            },
            {
                "fieldkey": "monedaId"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_configura_tu_poliza",
                "title": [{
                    "type": "heading6",
                    "text": "Elige tus coberturas y sumas aseguradas",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "coberturas"
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_configura_tu_poliza",
                "title": [{
                    "type": "heading6",
                    "text": "¿Te gustaría personalizar tu experiencia con estas coberturas adicionales?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "coberturasAdicionales"
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_cotizacion",
                "title": [],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "50-50",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "nombre"
            },
            {
                "fieldkey": "email"
            },
            {
                "fieldkey": "telefono"
            },
            {
                "fieldkey": "noSoyUnRobot"
            },
            {
                "fieldkey": "avisoPrivacidad"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_cotizacion",
                "title": [{
                    "type": "heading6",
                    "text": "Planes",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "No",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "planes"
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_emision_asegurado",
                "title": [{
                    "type": "heading6",
                    "text": "Información del asegurado titular",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "60-40",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "identificadorPersona"
            },
            {
                "fieldkey": "validarRfc"
            },
            {
                "fieldkey": "fakeField"
            },
            {
                "fieldkey": "primerNombre"
            },
            {
                "fieldkey": "primerApellido"
            },
            {
                "fieldkey": "segundoApellido"
            },
            {
                "fieldkey": "curp"
            },
            {
                "fieldkey": "sexo"
            },
            {
                "fieldkey": "fechaDeNacimientoAsegurado"
            },
            {
                "fieldkey": "estadoCivil"
            },
            {
                "fieldkey": "pais"
            },
            {
                "fieldkey": "lugarNacimiento"
            },
            {
                "fieldkey": "nacionalidad"
            },
            {
                "fieldkey": "ocupacionProfesion"
            },
            {
                "fieldkey": "ingresosMensuales"
            },
            {
                "fieldkey": "email1"
            },
            {
                "fieldkey": "telefonoCelular"
            },
            {
                "fieldkey": "tipoDeIdentificacionEntregada"
            },
            {
                "fieldkey": "folioDeIdentificacionEntregada"
            },
            {
                "fieldkey": "residenteFiscalExtranjero"
            },
            {
                "fieldkey": "paisResidenteFiscal"
            },
            {
                "fieldkey": "nIdentificacionEnElExtranjero"
            },
            {
                "fieldkey": "direccion"
            },
            {
                "fieldkey": "nExterior"
            },
            {
                "fieldkey": "nIterior"
            },
            {
                "fieldkey": "codigoPostal"
            },
            {
                "fieldkey": "estadoAsegurado"
            },
            {
                "fieldkey": "coloniaAsegurado"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_emision_asegurado",
                "title": [{
                    "type": "heading6",
                    "text": "Identificación y conocimiento del cliente",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "cuentaConOtroSeguroDeVidaContratadoDeFormaVoluntaria"
            },
            {
                "fieldkey": "leHanRechazadoLimitadoOExtraPrimadoAlgunaSolicitud"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_emision_contratante",
                "title": [{
                    "type": "heading6",
                    "text": "Datos del contratante",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "50-50",
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/find-form-medical\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"09e5ece8bcbf4ff4b1d099fb45e7b3bc\"\n  },\n  \"body\": {}\n}",
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado"
            },
            {
                "fieldkey": "tipoDePersonaContratante"
            },
            {
                "fieldkey": "identificadorPersonaContratante"
            },
            {
                "fieldkey": "identificadorPersonaContratanteMoral"
            },
            {
                "fieldkey": "validarRfcContratante"
            },
            {
                "fieldkey": "fakeField"
            },
            {
                "fieldkey": "primerNombreContratante"
            },
            {
                "fieldkey": "primerApellidoContratante"
            },
            {
                "fieldkey": "segundoApellidoContratante"
            },
            {
                "fieldkey": "curpContratante"
            },
            {
                "fieldkey": "sexoContratante"
            },
            {
                "fieldkey": "fechaNacimientoContratante"
            },
            {
                "fieldkey": "estadoCivilContratante"
            },
            {
                "fieldkey": "paisNacimientoContratante"
            },
            {
                "fieldkey": "lugarNacimientoContratante"
            },
            {
                "fieldkey": "nacionalidadContratante"
            },
            {
                "fieldkey": "ocupacionProfesionContratante"
            },
            {
                "fieldkey": "ingresosMensualesContratante"
            },
            {
                "fieldkey": "emailContratante"
            },
            {
                "fieldkey": "telefonoCelularContratante"
            },
            {
                "fieldkey": "nombreDelApoderadoLegalContratante"
            },
            {
                "fieldkey": "fechaDeNacimientoDelApoderadoContratante"
            },
            {
                "fieldkey": "anadirApoderadoLegalContratante"
            },
            {
                "fieldkey": "tipoDeIdentificacionEntregadaContratante"
            },
            {
                "fieldkey": "folioDeIdentificacionEntregadaContratante"
            },
            {
                "fieldkey": "residenteFiscalExtranjeroContratante"
            },
            {
                "fieldkey": "paisResidenteFiscalContratante"
            },
            {
                "fieldkey": "nIdentificacionEnElExtranjeroContratante"
            },
            {
                "fieldkey": "direccionContratante"
            },
            {
                "fieldkey": "nExteriorContratante"
            },
            {
                "fieldkey": "nIteriorContratante"
            },
            {
                "fieldkey": "codigoPostalContratante"
            },
            {
                "fieldkey": "estadoContratante"
            },
            {
                "fieldkey": "coloniaContratante"
            },
            {
                "fieldkey": "razonSocialContratante"
            },
            {
                "fieldkey": "fechaDeConstitucionContratante"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de los asegurados adicionales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "heading3",
                    "text": "Cobertura de gastos funerarios",
                    "spans": [{
                        "start": 0,
                        "end": 30,
                        "type": "strong"
                    }]
                },
                {
                    "type": "paragraph",
                    "text": "La designación de beneficiarios para esta cobertura es recíproca, es decir, en caso de fallecimiento del cónyuge, se entrega el 100% de la suma asegurada al titular.",
                    "spans": []
                }
                ],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "asegurados"
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de los asegurados adicionales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "heading3",
                    "text": "Asegurados adicionales para mascotas",
                    "spans": [{
                        "start": 0,
                        "end": 36,
                        "type": "strong"
                    }]
                },
                {
                    "type": "paragraph",
                    "text": "La designación de beneficiarios para esta cobertura es recíproca, es decir, en caso de fallecimiento del cónyuge, se entrega el 100% de la suma asegurada al titular.",
                    "spans": []
                }
                ],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "mascotas"
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de el o los beneficiarios",
                    "spans": []
                }],
                "collapse_description": true,
                "description": [{
                    "type": "paragraph",
                    "text": "Si estás considerando renombrar a un menor de edad como beneficiario es importante que consideres la siguiente información.",
                    "spans": []
                }],
                "collapsable_text": [{
                    "type": "paragraph",
                    "text": "Al nombrar beneficiarios menores de edad no se debe señalar a un mayor de edad como representante del menor, para que en su representación cobre la indemnización; ya que la legislación señala la forma en que deben designarse tutores, albaceas u otros cargos similares y no consideran al contrato de seguro como el instrumento adecuando para tal designación. Si designas a un mayor de edad como representante del menor beneficiario durante su minoría de edad, legalmente puede implicar que se nombra como beneficiario al mayor de edad, quien solo tendrá una obligación moral, pues la designación que se hace de beneficiarios en un contrato de seguro le concede el derecho incondicionado de disponer de la suma asegurada.",
                    "spans": []
                }],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "beneficiarios"
            },
            {
                "fieldkey": "mensajeErrorPorcentaje"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_cuestionario_medico",
                "title": [{
                    "type": "heading6",
                    "text": "Cuestionario Médico",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "paragraph",
                    "text": "Para continuar con la contratación del seguro de vida Plan Vive, es necesario completar un breve cuestionario de salud. Ten a mano tu identificación oficial.",
                    "spans": []
                }],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "estadoCuestionario"
            },
            {
                "fieldkey": "fakeField"
            },
            {
                "fieldkey": "fakeField"
            },
            {
                "fieldkey": "completarCuestionario"
            },
            {
                "fieldkey": "copiarEnlace"
            },
            {
                "fieldkey": "enviarEnlace"
            },
            {
                "fieldkey": "actualizar"
            },
            {
                "fieldkey": "mensajeModalElegibleConExtraprima"
            },
            {
                "fieldkey": "mensajeModalNoElegible"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_pasarela_pago",
                "title": [{
                    "type": "heading6",
                    "text": "Periodicidad de pago",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/emit-insurance\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"09e5ece8bcbf4ff4b1d099fb45e7b3bc\"\n   },\n  \"body\": {}\n}",
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/check-payment-status?referencia={referencia}\",\n  \"method\": \"GET\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"09e5ece8bcbf4ff4b1d099fb45e7b3bc\"\n   },\n  \"body\": {}\n}"
            },
            "items": [{
                "fieldkey": "periodicidadPagoId"
            },
            {
                "fieldkey": "pago"
            },
            {
                "fieldkey": "aceptOne"
            },
            {
                "fieldkey": "aceptTwo"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }
        ],
        "orderbysteps": [{
            "name": "Algunos datos",
            "key_step": "step_personales",
            "api_service": null
        },
        {
            "name": "Configura tu póliza",
            "key_step": "step_configura_tu_poliza",
            "api_service": null
        },
        {
            "name": "Cotización",
            "key_step": "step_cotizacion",
            "api_service": null
        },
        {
            "name": "Emisión Asegurado",
            "key_step": "step_emision_asegurado",
            "api_service": null
        },
        {
            "name": "Asegurados",
            "key_step": "step_asegurados",
            "api_service": null
        },
        {
            "name": "Emisión Contratante",
            "key_step": "step_emision_contratante",
            "api_service": null
        },
        {
            "name": "Cuestionario Médico",
            "key_step": "step_cuestionario_medico",
            "api_service": null
        },
        {
            "name": "Periodicidad de pago",
            "key_step": "step_pasarela_pago",
            "api_service": null
        }
        ]
    }
};

export const dataForm = {
    data: {
        formDefinition: {
            _id: "614e6aa0da5e79567a962667",
            name: "formPlanViveDev",
            _vid: 0,
            access: [{
                roles: [],
                type: "create_own",
            },
            {
                roles: [],
                type: "create_all",
            },
            {
                roles: [],
                type: "read_own",
            },
            {
                roles: [
                    "614e68a500a3577144caff4a",
                    "614e68a500a35755ddcaff4f",
                    "614e68a500a3570e18caff54",
                ],
                type: "read_all",
            },
            {
                roles: [],
                type: "update_own",
            },
            {
                roles: [],
                type: "update_all",
            },
            {
                roles: [],
                type: "delete_own",
            },
            {
                roles: [],
                type: "delete_all",
            },
            {
                roles: [],
                type: "team_read",
            },
            {
                roles: [],
                type: "team_write",
            },
            {
                roles: [],
                type: "team_admin",
            },
            ],
            components: [{
                title: "step_personales",
                breadcrumbClickable: true,
                buttonSettings: {
                    previous: true,
                    cancel: true,
                    next: true,
                },
                scrollToTop: false,
                collapsible: false,
                key: "page2",
                type: "panel",
                label: "Page 2",
                input: false,
                tableView: false,
                components: [{
                    label: "FECHA DE NACIMIENTO",
                    format: "DD/MM/YYYY",
                    tableView: false,
                    enableMinDateInput: false,
                    datePicker: {
                        minDate: "1870-01-01T12:00:00-04:56",
                        maxDate: "2021-01-01T12:00:00-05:00",
                        disableWeekends: false,
                        disableWeekdays: false,
                    },
                    enableMaxDateInput: false,
                    validate: {
                        required: true,
                        customMessage: "INGRESA UNA FECHA VÁLIDA",
                    },
                    key: "fechaNacimiento",
                    type: "datetime",
                    input: true,
                    widget: {
                        type: "calendar",
                        displayInTimezone: "viewer",
                        locale: "en",
                        useLocaleSettings: false,
                        allowInput: true,
                        mode: "single",
                        enableTime: true,
                        noCalendar: false,
                        format: "DD/MM/YYYY",
                        hourIncrement: 1,
                        minuteIncrement: 1,
                        time_24hr: false,
                        minDate: "1870-01-01T12:00:00-04:56",
                        disableWeekends: false,
                        disableWeekdays: false,
                        maxDate: "2021-01-01T12:00:00-05:00",
                    },
                    value: "1990-01-01",
                },
                {
                    label: "OCUPACIÓN",
                    widget: "choicesjs",
                    placeholder: "Elige tu ocupación ",
                    tableView: true,
                    dataSrc: "json",
                    data: {
                        json: {
                            url: "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/catalogos/ocupaciones",
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc",
                            },
                            body: {},
                        },
                    },
                    validate: {
                        required: true,
                        customMessage: "Este campo es requerido",
                    },
                    key: "claveOcupacion",
                    type: "select",
                    input: true,
                    value: "A392",
                },
                {
                    label: "PESO EN KILOGRAMOS",
                    placeholder: "Ej: 00.000 Kg",
                    suffix: "Kg",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "[0-9][0-9]\\.[0-9][0-9][0-9]",
                        customMessage: "Ingrese un peso correcto Ej: 99.999",
                        minLength: 1,
                        maxLength: 6,
                    },
                    key: "peso",
                    properties: {
                        fixed: "3",
                    },
                    type: "textfield",
                    input: true,
                    value: "80.000",
                },
                {
                    label: "ALTURA EN METROS",
                    placeholder: "Ej: 0.00 m",
                    suffix: "m",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "[0-9]\\.[0-9][0-9]",
                        customMessage: "Ingrese una altura correcta Ej: 1.80",
                        minLength: 1,
                        maxLength: 4,
                    },
                    key: "talla",
                    type: "textfield",
                    input: true,
                    value: "1.70",
                },
                {
                    label: "EL IMC ES DE",
                    placeholder: "0.0 m",
                    suffix: "m",
                    spellcheck: false,
                    disabled: true,
                    tableView: false,
                    calculateValue: {
                        operation: "peso/(talla*talla)",
                        fields: ["peso", "talla"],
                    },
                    validate: {
                        required: true,
                        minLength: 1,
                        maxLength: 6,
                    },
                    key: "imc",
                    properties: {
                        fixed: "3",
                    },
                    type: "textfield",
                    input: true,
                    value: "27.682",
                },
                {
                    label: "¿Eres fumador?",
                    tableView: false,
                    defaultValue: false,
                    validate: {
                        required: true,
                        customMessage: "Error",
                    },
                    key: "esFumador",
                    type: "checkbox",
                    input: true,
                    value: false,
                },
                {
                    label: "Genero",
                    optionsLabelPosition: "right",
                    customClass: "radioImage",
                    inline: false,
                    tableView: false,
                    values: [{
                        label: "Hombre",
                        value: "H",
                        shortcut: "",
                    },
                    {
                        label: "Mujer",
                        value: "M",
                        shortcut: "",
                    },
                    ],
                    validate: {
                        required: true,
                    },
                    key: "genero",
                    properties: {
                        H: "https://images.prismic.io/portal-cotizacion-suramex/0399ebf0-3ec8-4cf6-9f70-0f1105be2022_men.png?auto=compress,format",
                        M: "https://images.prismic.io/portal-cotizacion-suramex/4cb0207a-34b8-41c3-b8f0-1c94de47c94e_women.png?auto=compress,format",
                    },
                    type: "radio",
                    input: true,
                },
                {
                    label: "Familia",
                    optionsLabelPosition: "right",
                    customClass: "radioImage",
                    inline: false,
                    tableView: false,
                    values: [{
                        label: "Soltero(a)",
                        value: "T",
                        shortcut: "",
                    },
                    {
                        label: "Pareja sin hijos",
                        value: "F",
                        shortcut: "",
                    },
                    {
                        label: "Pareja con hijos",
                        value: "H",
                        shortcut: "",
                    },
                    ],
                    validate: {
                        required: true,
                    },
                    key: "claveTipoFamilia",
                    properties: {
                        T: "https://images.prismic.io/portal-cotizacion-suramex/a81f3af0-a49a-4a1b-b4d4-b3f5cc367095_solteros.png?auto=compress,format",
                        F: "https://images.prismic.io/portal-cotizacion-suramex/ffe662ac-b650-430a-9750-7c2d6b612171_parejasinhijos.png?auto=compress,format",
                        H: "https://images.prismic.io/portal-cotizacion-suramex/5144744e-ff1e-4825-ae75-b5d54c1bc20a_parejaconhijos.png?auto=compress,format",
                    },
                    type: "radio",
                    input: true,
                },
                {
                    label: "¿Tienes mascotas?",
                    tableView: false,
                    defaultValue: false,
                    validate: {
                        required: true,
                    },
                    key: "incluyeMascotas",
                    type: "checkbox",
                    input: true,
                },
                {
                    label: "Mascotas",
                    optionsLabelPosition: "right",
                    customClass: "radioImage",
                    inline: false,
                    tableView: false,
                    values: [{
                        label: "Perro",
                        value: "perro",
                        shortcut: "",
                    },
                    {
                        label: "Gato",
                        value: "gato",
                        shortcut: "",
                    },
                    {
                        label: "Ambos",
                        value: "ambos",
                        shortcut: "",
                    },
                    ],
                    validate: {
                        required: true,
                    },
                    key: "mascotas",
                    properties: {
                        perro: "https://images.prismic.io/portal-cotizacion-suramex/7bc9b6ae-f3d1-4b56-ad93-85983d859890_perro.png?auto=compress,format",
                        gato: "https://images.prismic.io/portal-cotizacion-suramex/14ee12a7-307e-4915-b35f-a245477d8c27_gato.png?auto=compress,format",
                        ambos: "https://images.prismic.io/portal-cotizacion-suramex/972369e9-eff7-479e-978b-38673d903ca5_ambos.png?auto=compress,format",
                    },
                    conditional: {
                        show: true,
                        when: "incluyeMascotas",
                        eq: "true",
                    },
                    type: "radio",
                    input: true,
                },
                {
                    label: "¿POR CUANTO TIEMPO QUIERES CONTRATAR TU SEGURO?",
                    widget: "choicesjs",
                    placeholder: "años",
                    tableView: true,
                    data: {
                        values: [{
                            label: "1 años",
                            value: "1Anos",
                        },
                        {
                            label: "5 años",
                            value: "5Anos",
                        },
                        {
                            label: "10 años",
                            value: "10Anos",
                        },
                        {
                            label: "15 años",
                            value: "15Anos",
                        },
                        {
                            label: "20 años",
                            value: "20Anos",
                        },
                        {
                            label: "25 años",
                            value: "25Anos",
                        },
                        ],
                    },
                    validate: {
                        required: true,
                    },
                    key: "tiempoContratoSeguro",
                    type: "select",
                    input: true,
                },
                {
                    label: "¿En qué monedas quieres tus coberturas?",
                    widget: "choicesjs",
                    placeholder: "Ej: pesos",
                    tableView: true,
                    data: {
                        values: [{
                            label: "USD - Dólares",
                            value: "USD",
                        },
                        {
                            label: "MXN - Pesos",
                            value: "MXN",
                        },
                        {
                            label: "UDIs",
                            value: "UDI",
                        },
                        ],
                    },
                    validate: {
                        required: true,
                    },
                    key: "monedaId",
                    type: "select",
                    input: true,
                },
                {
                    label: "Aliado",
                    defaultValue: "COTIZADORES_SURA",
                    key: "claveAliado",
                    type: "hidden",
                    input: true,
                    tableView: false,
                    value: "COTIZADORES_SURA",
                },
                {
                    label: "Status",
                    key: "status",
                    type: "hidden",
                    input: true,
                    tableView: false,
                }, {
                    "title": "Beneficiarios",
                    "breadcrumbClickable": true,
                    "buttonSettings": {
                        "previous": true,
                        "cancel": true,
                        "next": true
                    },
                    "scrollToTop": false,
                    "customClass": "repeatableContent",
                    "collapsible": false,
                    "key": "beneficiarios",
                    "type": "panel",
                    "label": "Panel",
                    "input": false,
                    "tableView": false,
                    "components": [{
                        "label": "Porcentaje",
                        "placeholder": "Ej. 100",
                        "tooltip": "Debes ingresar un valor entre 1 y 100, recuerda distribuir el 100% correctamente en todos tus beneficiarios.",
                        "tableView": true,
                        "validate": {
                            "required": true,
                            "pattern": "^0*(?:[1-9][0-9]?|100)$",
                            "customMessage": "Dato no válido",
                            "minLength": 1,
                            "maxLength": 3
                        },
                        "key": "porcentajeBeneficiario",
                        "type": "textfield",
                        "input": true
                    }]
                }
                ],
            },
            {
                title: "step_configura_tu_poliza",
                breadcrumbClickable: true,
                buttonSettings: {
                    previous: true,
                    cancel: true,
                    next: true,
                },
                scrollToTop: false,
                collapsible: false,
                key: "page3",
                type: "panel",
                label: "Page 2",
                input: false,
                tableView: false,
                components: [{
                    label: "Coberturas",
                    optionsLabelPosition: "right",
                    tableView: false,
                    defaultValue: {
                        1: false,
                        "": false,
                        "{": false,
                    },
                    values: [{
                        label: "api_service",
                        value: '{   "url": "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/coberturas?fechaNacimiento=value&claveTipoFamilia=value&claveOcupacion=value&claveAliado=value&incluyeMascotas=value&page=1",   "method": "GET",   "headers": {     "Content-Type": "application/json",     "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"   },   "body": {} }',
                        shortcut: "",
                    },],
                    validate: {
                        required: true,
                    },
                    key: "coberturas",
                    type: "selectboxes",
                    input: true,
                    inputType: "checkbox",
                },
                {
                    label: "Coberturas adicionales",
                    optionsLabelPosition: "right",
                    tableView: false,
                    defaultValue: {
                        1: false,
                        "": false,
                        "{": false,
                    },
                    values: [{
                        label: "api_service",
                        value: '{   "url": "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/coberturas?fechaNacimiento=value&claveTipoFamilia=value&claveOcupacion=value&claveAliado=value&incluyeMascotas=value&page=2",   "method": "GET",   "headers": {     "Content-Type": "application/json",     "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"   },   "body": {} }',
                        shortcut: "",
                    },],
                    validate: {
                        required: true,
                    },
                    key: "coberturasAdicionales",
                    type: "selectboxes",
                    input: true,
                    inputType: "checkbox",
                },
                ],
            },
            {
                title: "step_cotizacion",
                breadcrumbClickable: true,
                buttonSettings: {
                    previous: true,
                    cancel: true,
                    next: true,
                },
                scrollToTop: false,
                collapsible: false,
                key: "page4",
                type: "panel",
                label: "Page 3",
                input: false,
                tableView: false,
                components: [{
                    label: "Nombre",
                    placeholder: "Ej. Diana",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$",
                        customMessage: "Ingresa un nombre valido",
                        minLength: 1,
                        maxLength: 100,
                    },
                    key: "nombre",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "INGRESA TU E-MAIL",
                    placeholder: "ejemplo@gmail.com",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: '^(("[\\w-\\s]+")|([\\w-]+(?:\\.[\\w-]+)*)|("[\\w-\\s]+")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)',
                        customMessage: "Ingrese un correo electrónico valido",
                        minLength: 1,
                        maxLength: 100,
                    },
                    key: "email",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "TELÉFONO CELULAR",
                    placeholder: "Ej. 55 5723 799",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "1?-?\\(?[0-9]{3}[0-9]{3}[0-9]{4}",
                        customMessage: "Ingresa un número telefónico valido",
                        minLength: 1,
                        maxLength: 100,
                    },
                    key: "telefono",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "No soy un robot",
                    customClass: "recaptcha",
                    tableView: false,
                    defaultValue: false,
                    validate: {
                        required: true,
                    },
                    key: "noSoyUnRobot",
                    properties: {
                        sitekey: "6LdCNUMaAAAAAM3W7I7d9dsG9WXPb-0W0v7f9n9G",
                    },
                    type: "checkbox",
                    input: true,
                },
                {
                    label: 'HE LEÍDO Y ACEPTO EL <A HREF="https://invierteyahorra.suramexico.com/suramexico/aviso-de-privacidad-SUAM.html" target="_blank">AVISO DE PRIVACIDAD</A>',
                    tableView: false,
                    defaultValue: false,
                    validate: {
                        required: true,
                    },
                    key: "avisoPrivacidad",
                    type: "checkbox",
                    input: true,
                },
                {
                    label: "Planes",
                    optionsLabelPosition: "right",
                    customClass: "selectboxesPlans",
                    tableView: false,
                    defaultValue: {
                        api: false,
                        apiService: false,
                        "{": false,
                    },
                    values: [{
                        label: "api_service",
                        value: '{   "url": "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/cotizacion",   "method": "POST",   "headers": {     "Content-Type": "application/json",     "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"   },   "body": {} }',
                        shortcut: "",
                    },],
                    validate: {
                        required: true,
                    },
                    key: "planes",
                    type: "selectboxes",
                    input: true,
                    inputType: "checkbox",
                },
                ],
            },
            {
                title: "step_asegurados",
                breadcrumbClickable: true,
                buttonSettings: {
                    previous: true,
                    cancel: true,
                    next: true,
                },
                scrollToTop: false,
                collapsible: false,
                key: "page5",
                type: "panel",
                label: "Page 4",
                input: false,
                tableView: false,
                components: [{
                    title: "Asegurados",
                    breadcrumbClickable: true,
                    buttonSettings: {
                        previous: true,
                        cancel: true,
                        next: true,
                    },
                    scrollToTop: false,
                    customClass: "repeatableContent",
                    collapsible: false,
                    key: "asegurados",
                    properties: {
                        claveCobertura: "9198",
                        nameRelatedProperty: "coberturas",
                    },
                    type: "panel",
                    label: "Asegurados",
                    input: false,
                    tableView: false,
                    components: [{
                        label: "Nombre",
                        tableView: true,
                        validate: {
                            required: true,
                            pattern: "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$",
                            customMessage: "Ingresa un nombre valido",
                            minLength: 1,
                            maxLength: 100,
                        },
                        key: "nombreAsegurado",
                        type: "textfield",
                        input: true,
                    },
                    {
                        label: "Apellido paterno",
                        tableView: true,
                        validate: {
                            required: true,
                            pattern: "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$",
                            customMessage: "Ingresa un apellido valido",
                            minLength: 1,
                            maxLength: 100,
                        },
                        key: "apellidoPaternoAsegurado",
                        type: "textfield",
                        input: true,
                    },
                    {
                        label: "Apellido materno",
                        tableView: true,
                        validate: {
                            required: true,
                            pattern: "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$",
                            customMessage: "Ingresa un apellido valido",
                            minLength: 1,
                            maxLength: 100,
                        },
                        key: "apellidoMaternoAsegurado",
                        type: "textfield",
                        input: true,
                    },
                    {
                        label: "Fecha de nacimiento",
                        format: "DD/MM/YYYY",
                        tableView: false,
                        enableMinDateInput: false,
                        datePicker: {
                            minDate: "1870-01-01T11:59:00-04:56",
                            maxDate: "2021-01-01T12:00:00-05:00",
                            disableWeekends: false,
                            disableWeekdays: false,
                        },
                        enableMaxDateInput: false,
                        validate: {
                            required: true,
                            customMessage: "Ingresa una fecha válida",
                        },
                        key: "fechaNacimientoAsegurado",
                        type: "datetime",
                        input: true,
                        widget: {
                            type: "calendar",
                            displayInTimezone: "viewer",
                            locale: "en",
                            useLocaleSettings: false,
                            allowInput: true,
                            mode: "single",
                            enableTime: true,
                            noCalendar: false,
                            format: "DD/MM/YYYY",
                            hourIncrement: 1,
                            minuteIncrement: 1,
                            time_24hr: false,
                            minDate: "1870-01-01T11:59:00-04:56",
                            disableWeekends: false,
                            disableWeekdays: false,
                            maxDate: "2021-01-01T12:00:00-05:00",
                        },
                    },
                    {
                        label: "Parentesco",
                        widget: "choicesjs",
                        tableView: true,
                        data: {
                            values: [{
                                label: "Cónyuge",
                                value: "conyuge",
                            },
                            {
                                label: "Hijo/a",
                                value: "hijo/a",
                            },
                            ],
                        },
                        validate: {
                            required: true,
                        },
                        key: "parentescoAsegurado",
                        type: "select",
                        input: true,
                    },
                    {
                        label: "Género",
                        widget: "choicesjs",
                        tableView: true,
                        data: {
                            values: [{
                                label: "Femenino",
                                value: "femenino",
                            },
                            {
                                label: "Masculino",
                                value: "masculino",
                            },
                            ],
                        },
                        validate: {
                            required: true,
                        },
                        key: "generoAsegurado",
                        type: "select",
                        input: true,
                    },
                    ],
                },
                {
                    title: "Mascotas",
                    breadcrumbClickable: true,
                    buttonSettings: {
                        previous: true,
                        cancel: true,
                        next: true,
                    },
                    scrollToTop: false,
                    customClass: "repeatableContent",
                    collapsible: false,
                    key: "mascotas",
                    type: "panel",
                    label: "Mascotas",
                    input: false,
                    tableView: false,
                    components: [{
                        label: "Nombre Mascota",
                        tableView: true,
                        key: "nombreMascota",
                        type: "textfield",
                        input: true,
                    },],
                },
                ],
            },
            {
                title: "step_emision",
                breadcrumbClickable: true,
                buttonSettings: {
                    previous: true,
                    cancel: true,
                    next: true,
                },
                scrollToTop: false,
                collapsible: false,
                key: "page6",
                type: "panel",
                label: "Page 5",
                input: false,
                tableView: false,
                components: [{
                    input: true,
                    key: "folioMercantil",
                    tableView: true,
                    label: "Folio Mercantil ",
                    validate: {
                        required: true,
                        pattern: "[a-zA-Z0-9]",
                        maxLength: 20,
                    },
                    type: "textfield",
                },
                {
                    input: true,
                    key: "fechaDeNacimientoDelApoderado",
                    tableView: true,
                    label: "Fecha de nacimiento del apoderado ",
                    validate: {
                        required: true,
                    },
                    type: "textfield",
                },
                {
                    input: true,
                    key: "tipoDePersona",
                    customClass: "radioText",
                    tableView: false,
                    label: "TIPO DE PERSONA",
                    validate: {
                        required: true,
                    },
                    type: "radio",
                    values: [{
                        label: "PERSONA FÍSICA",
                        value: "personaFisica",
                        shortcut: "",
                    },
                    {
                        label: "PERSONA MORAL",
                        value: "personaMoral",
                        shortcut: "",
                    },
                    ],
                    optionsLabelPosition: "right",
                    inline: false,
                },
                {
                    input: true,
                    key: "nombreDelApoderadoLegal",
                    tableView: true,
                    label: "Nombre del apoderado legal ",
                    validate: {
                        required: true,
                        maxLength: 60,
                    },
                    type: "textfield",
                },
                {
                    label: "RFC",
                    tableView: true,
                    validate: {
                        required: true,
                    },
                    key: "identificadorPersona",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Primer Nombre",
                    tableView: true,
                    validate: {
                        required: true,
                    },
                    key: "primerNombre",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Validar RFC",
                    showValidations: false,
                    tableView: false,
                    key: "validarRfc",
                    logic: [{
                        name: "api_service",
                        trigger: {
                            type: "json",
                            json: {
                                url: "https://apimanagement-devqa.azure-api.net/catalogos-dev/personas?tipoIdentificadorPersona=1&identificadorPersona=value",
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc",
                                },
                                body: {},
                                action: "autocomplete",
                            },
                        },
                        actions: [],
                        isRowSelected: true,
                    },],
                    type: "button",
                    input: true,
                    saveOnEnter: false,
                },
                {
                    input: true,
                    key: "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
                    defaultValue: false,
                    tableView: false,
                    label: "Los datos del contratante son los mismos que los del asegurado",
                    type: "checkbox",
                },
                {
                    label: "Segundo Nombre",
                    tableView: true,
                    validate: {
                        required: true,
                    },
                    key: "segundoNombre",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Apellido materno",
                    tableView: true,
                    validate: {
                        required: true,
                    },
                    key: "segundoApellido",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Apellido paterno",
                    tableView: true,
                    validate: {
                        required: true,
                    },
                    key: "primerApellido",
                    type: "textfield",
                    input: true,
                },
                {
                    input: true,
                    key: "fechaDeConstitucion",
                    tableView: true,
                    label: "Fecha de constitución ",
                    validate: {
                        required: true,
                        maxLength: 8,
                    },
                    type: "textfield",
                },
                {
                    input: true,
                    key: "razonSocial",
                    tableView: true,
                    label: "Razón social ",
                    validate: {
                        required: true,
                        maxLength: 60,
                    },
                    type: "textfield",
                },
                {
                    input: true,
                    key: "campoParaIngresarElPaisDelDomicilioEnElExtranjeroDelContratante",
                    tableView: true,
                    label: "Campo para ingresar el país del domicilio en el extranjero del contratante. ",
                    type: "select",
                },
                {
                    label: "CURP",
                    tableView: true,
                    validate: {
                        required: true,
                        customMessage: "Tu CURP debe tener longitud de 18 caracteres",
                        minLength: 18,
                        maxLength: 18,
                    },
                    key: "curp",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Género",
                    widget: "choicesjs",
                    tableView: true,
                    data: {
                        values: [{
                            label: "Hombre",
                            value: "H - HOMBRE",
                        },
                        {
                            label: "Mujer",
                            value: "M - MUJER",
                        },
                        ],
                    },
                    validate: {
                        required: true,
                    },
                    key: "sexo",
                    type: "select",
                    input: true,
                },
                {
                    label: "Fecha de nacimiento",
                    disabled: true,
                    tableView: true,
                    customDefaultValue: "fechaNacimiento",
                    validate: {
                        required: true,
                    },
                    key: "fechaDeNacimiento",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Estado Civil",
                    tableView: true,
                    data: {
                        values: [{
                            label: "Soltero/a.",
                            value: "solteroA",
                        },
                        {
                            label: "Casado/a.",
                            value: "casadoA",
                        },
                        ],
                    },
                    validate: {
                        required: true,
                    },
                    key: "estadoCivil",
                    type: "select",
                    input: true,
                },
                {
                    label: "País de Nacimiento",
                    widget: "choicesjs",
                    placeholder: "Elige tu país de nacimiento",
                    tableView: true,
                    data: {
                        values: [{
                            label: "052 - MEXICO",
                            value: "052 - MEXICO",
                        },
                        {
                            label: "041 - COL",
                            value: "041 - COL",
                        },
                        ],
                    },
                    validate: {
                        required: true,
                        customMessage: "Este campo es requerido",
                    },
                    key: "pais",
                    type: "select",
                    input: true,
                },
                {
                    label: "Lugar de Nacimiento",
                    widget: "choicesjs",
                    placeholder: "Elige tu lugar de nacimiento",
                    tableView: true,
                    dataSrc: "json",
                    data: {
                        json: {
                            url: "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/catalogos/ocupaciones",
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc",
                            },
                            body: {},
                        },
                    },
                    validate: {
                        required: true,
                        customMessage: "Este campo es requerido",
                    },
                    key: "lugarNacimiento",
                    type: "select",
                    input: true,
                },
                {
                    label: "Nacionalidad",
                    widget: "choicesjs",
                    placeholder: "Elige tu nacionalidad",
                    tableView: true,
                    dataSrc: "json",
                    data: {
                        json: {
                            url: "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/catalogos/ocupaciones",
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc",
                            },
                            body: {},
                        },
                    },
                    validate: {
                        required: true,
                        customMessage: "Este campo es requerido",
                    },
                    key: "nacionalidad",
                    type: "select",
                    input: true,
                },
                {
                    label: "Ocupación o profesión",
                    tableView: true,
                    customDefaultValue: "claveOcupacion",
                    key: "ocupacionProfesion",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Puesto",
                    tableView: true,
                    validate: {
                        required: true,
                        customMessage: "Dato no válido",
                        minLength: 1,
                        maxLength: 30,
                    },
                    key: "puesto",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Ingresos mensuales",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "^[0-9]*$",
                        customMessage: "Dato no válido",
                        minLength: 1,
                        maxLength: 7,
                    },
                    key: "ingresosMensuales",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "¿Empleado gubernamental?",
                    tableView: false,
                    defaultValue: false,
                    validate: {
                        required: true,
                        customMessage: "Error",
                    },
                    key: "empleadoGubernamental",
                    type: "checkbox",
                    input: true,
                },
                {
                    label: "Descripción de actividades",
                    tableView: true,
                    validate: {
                        required: true,
                        customMessage: "Dato no válido",
                        minLength: 1,
                        maxLength: 70,
                    },
                    key: "descripcionActividades",
                    type: "textfield",
                    input: true,
                },
                {
                    input: true,
                    key: "anadirApoderadoLegal",
                    tableView: false,
                    label: "Añadir apoderado legal",
                    type: "button",
                    showValidations: false,
                    saveOnEnter: false,
                },
                {
                    label: "INGRESA TU E-MAIL",
                    placeholder: "ejemplo@gmail.com",
                    tableView: true,
                    customDefaultValue: "email",
                    validate: {
                        required: true,
                        pattern: '^(("[\\w-\\s]+")|([\\w-]+(?:\\.[\\w-]+)*)|("[\\w-\\s]+")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)',
                        customMessage: "Ingrese un correo electrónico valido",
                        minLength: 1,
                        maxLength: 100,
                    },
                    key: "email1",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Teléfono particular",
                    placeholder: "Ej. 55 5723 799",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "1?-?\\(?[0-9]{3}[0-9]{3}[0-9]{4}",
                        customMessage: "Ingresa un número telefónico valido",
                        minLength: 1,
                        maxLength: 100,
                    },
                    key: "telefonoParticular",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "TELÉFONO CELULAR",
                    placeholder: "Ej. 55 5723 799",
                    tableView: true,
                    customDefaultValue: "telefono",
                    validate: {
                        required: true,
                        pattern: "1?-?\\(?[0-9]{3}[0-9]{3}[0-9]{4}",
                        customMessage: "Ingresa un número telefónico valido",
                        minLength: 1,
                        maxLength: 100,
                    },
                    key: "telefono1",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "E.Firma",
                    tableView: true,
                    validate: {
                        pattern: "[a-zA-Z0-9]",
                        customMessage: "Dato no válido",
                    },
                    key: "eFirma",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Tipo de identificación entregada",
                    widget: "choicesjs",
                    tableView: true,
                    data: {
                        values: [{
                            label: "Credencial para votar vigente",
                            value: "credencialParaVotarVigente",
                        },
                        {
                            label: "Pasaporte vigente",
                            value: "pasaporteVigente",
                        },
                        {
                            label: "Cedula profesional",
                            value: "cedulaProfesional",
                        },
                        {
                            label: "Cartilla de servicio militar",
                            value: "cartillaDeServicioMilitar",
                        },
                        {
                            label: "Certificado de matrícula consultar para extranjeros",
                            value: "certificadoDeMatriculaConsultarParaExtranjeros",
                        },
                        {
                            label: "Documento migratorio vigente",
                            value: "documentoMigratorioVigente",
                        },
                        ],
                    },
                    validate: {
                        required: true,
                    },
                    key: "tipoDeIdentificacionEntregada",
                    type: "select",
                    input: true,
                },
                {
                    label: "País y entidad que expide el documento",
                    widget: "choicesjs",
                    tableView: true,
                    dataSrc: "json",
                    data: {
                        json: {
                            url: "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/catalogos/ocupaciones",
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc",
                            },
                            body: {},
                        },
                    },
                    validate: {
                        required: true,
                        customMessage: "Este campo es requerido",
                    },
                    key: "paisEntidadExpideDocumento",
                    type: "select",
                    input: true,
                },
                {
                    label: "Folio de identificación entregada",
                    tableView: true,
                    validate: {
                        required: true,
                    },
                    key: "folioDeIdentificacionEntregada",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "¿Otras nacionalidades?",
                    tableView: false,
                    defaultValue: false,
                    validate: {
                        customMessage: "Error",
                    },
                    key: "otrasNacionalidades",
                    conditional: {
                        show: false,
                        when: "pais",
                        eq: "052 - MEXICO",
                    },
                    type: "checkbox",
                    input: true,
                },
                {
                    label: "¿Cuáles?",
                    tableView: true,
                    validate: {
                        customMessage: "Dato no válido",
                        minLength: 1,
                        maxLength: 100,
                    },
                    key: "cuales",
                    conditional: {
                        show: true,
                        when: "otrasNacionalidades",
                        eq: "true",
                    },
                    type: "textfield",
                    input: true,
                },
                {
                    label: "¿Residente fiscal en el extranjero?",
                    tableView: false,
                    defaultValue: false,
                    validate: {
                        customMessage: "Error",
                    },
                    key: "residenteFiscalExtranjero",
                    conditional: {
                        show: false,
                        when: "pais",
                        eq: "052 - MEXICO",
                    },
                    type: "checkbox",
                    input: true,
                },
                {
                    label: "País donde es residente fiscal",
                    widget: "choicesjs",
                    tableView: true,
                    dataSrc: "json",
                    data: {
                        json: {
                            url: "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/catalogos/ocupaciones",
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc",
                            },
                            body: {},
                        },
                    },
                    validate: {
                        customMessage: "Este campo es requerido",
                    },
                    key: "paisResidenteFiscal",
                    conditional: {
                        show: true,
                        when: "residenteFiscalExtranjero",
                        eq: "true",
                    },
                    type: "select",
                    input: true,
                },
                {
                    label: "N° Identificación en el extranjero",
                    tableView: true,
                    validate: {
                        customMessage: "Dato no válido",
                        minLength: 1,
                        maxLength: 30,
                    },
                    key: "nIdentificacionEnElExtranjero",
                    conditional: {
                        show: true,
                        when: "residenteFiscalExtranjero",
                        eq: "true",
                    },
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Dirección",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$",
                        customMessage: "Dato no válido",
                        minLength: 1,
                        maxLength: 50,
                    },
                    key: "direccion",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "No. Exterior",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "[a-zA-Z0-9]",
                        customMessage: "Dato no válido",
                        minLength: 1,
                        maxLength: 6,
                    },
                    key: "nExterior",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "No. interior",
                    tableView: true,
                    validate: {
                        pattern: "[a-zA-Z0-9]",
                        customMessage: "Dato no válido",
                        minLength: 1,
                        maxLength: 6,
                    },
                    key: "nIterior",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Código postal",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "^[0-9]*$",
                        customMessage: "MINIMO 5 CARACTERES",
                        minLength: 5,
                        maxLength: 5,
                    },
                    key: "codigoPostal",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Estado",
                    tableView: true,
                    validate: {
                        required: true,
                    },
                    key: "estado",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Colonia",
                    widget: "choicesjs",
                    placeholder: "Elige la colonia",
                    tableView: true,
                    dataSrc: "json",
                    data: {
                        json: {
                            url: "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/catalogos/ocupaciones",
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc",
                            },
                            body: {},
                        },
                    },
                    validate: {
                        required: true,
                        customMessage: "Este campo es requerido",
                    },
                    key: "colonia",
                    type: "select",
                    input: true,
                },
                {
                    label: "Domicilio en el extranjero",
                    tableView: true,
                    validate: {
                        customMessage: "Dato no válido",
                        minLength: 1,
                        maxLength: 50,
                    },
                    key: "domicilioEnElExtranjero",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Teléfono (con clave lada)",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "^[0-9]*$",
                        customMessage: "Dato no válido",
                        minLength: 1,
                        maxLength: 15,
                    },
                    key: "telefonoExtranjero",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Cuénta con otro seguro de vida contratado de forma voluntaria?",
                    optionsLabelPosition: "right",
                    customClass: "radioText",
                    inline: false,
                    tableView: false,
                    values: [{
                        label: "Si",
                        value: "si",
                        shortcut: "",
                    },
                    {
                        label: "No",
                        value: "no",
                        shortcut: "",
                    },
                    ],
                    validate: {
                        required: true,
                    },
                    key: "cuentaConOtroSeguroDeVidaContratadoDeFormaVoluntaria",
                    type: "radio",
                    input: true,
                },
                {
                    label: "Le han rechazado, limitado o extra-primado alguna solicitud?",
                    optionsLabelPosition: "right",
                    customClass: "radioText",
                    inline: false,
                    tableView: false,
                    values: [{
                        label: "Si",
                        value: "si",
                        shortcut: "",
                    },
                    {
                        label: "No",
                        value: "no",
                        shortcut: "",
                    },
                    ],
                    validate: {
                        required: true,
                    },
                    key: "leHanRechazadoLimitadoOExtraPrimadoAlgunaSolicitud",
                    type: "radio",
                    input: true,
                },
                {
                    label: "pais",
                    tableView: true,
                    data: {
                        values: [{
                            label: "seleccionar pais",
                            value: "seleccionarPais",
                        },],
                    },
                    key: "pais1",
                    type: "select",
                    input: true,
                },
                {
                    label: "Razón social ",
                    tableView: true,
                    validate: {
                        required: true,
                        maxLength: 60,
                    },
                    key: "razonSocial1",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Fecha de constitución ",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "^[0-9]*$",
                        maxLength: 8,
                    },
                    key: "fechaDeConstitucion1",
                    type: "textfield",
                    input: true,
                },
                {
                    label: "Folio Mercantil ",
                    tableView: true,
                    validate: {
                        required: true,
                        pattern: "[a-zA-Z0-9]",
                        maxLength: 20,
                    },
                    key: "folioMercantil1",
                    type: "textfield",
                    input: true,
                },
                ],
            },
            ],
            controller: "",
            created: "2021-09-25T00:17:36.430Z",
            display: "wizard",
            key: "formDefinition",
            machineName: "lndyrsvmkeoqqty:formPlanViveDev",
            modified: "2021-11-24T15:43:53.345Z",
            owner: "614a594a05adf633b0ef9ffb",
            path: "formplanvivedev",
            project: "614e68a500a3576962caff43",
            properties: {},
            revisions: "",
            settings: {},
            submissionAccess: [{
                roles: [],
                type: "create_own",
            },
            {
                roles: [],
                type: "create_all",
            },
            {
                roles: [],
                type: "read_own",
            },
            {
                roles: [],
                type: "read_all",
            },
            {
                roles: [],
                type: "update_own",
            },
            {
                roles: [],
                type: "update_all",
            },
            {
                roles: [],
                type: "delete_own",
            },
            {
                roles: [],
                type: "delete_all",
            },
            {
                roles: [],
                type: "team_read",
            },
            {
                roles: [],
                type: "team_write",
            },
            {
                roles: [],
                type: "team_admin",
            },
            ],
            tags: [],
            title: "form-PlanVive-dev",
            type: "form",
        },
        modelConfig: {
            "_id": "6196cad898a62b31f0b42575",
            "key": "modelConfig",
            "configuracion": {
                "claveAliado": "COTIZADORES_SURA",
                "producto": "planVive",
                "status": "",
                "folio": 0
            },
            "poliza": {
                "oficinaId": null,
                "productoId": 0,
                "estado": "",
                "numeroPolizaCotizacion": 0,
                "monedaId": "",
                "atrGrupoId": null,
                "atrSubgrupoId": null,
                "atrPerfilTarifaId": null,
                "atrPuntoVentaId": null,
                "usuarioId": null,
                "atrTipoTemporalidad": "",
                "solicitudId": 0,
                "periodicidadPagoId": 12,
                "agenteId": "",
                "nombreAgente": "",
                "nombrePromotor": "",
                "promotorId": "",
                "oficinaDescripcion": "",
                "email": ""
            },
            "situacion": {
                "paqueteModalidadPlan": "",
                "fechaNacimiento": "",
                "genero": "",
                "parentesco": "T",
                "esFumador": false,
                "ingresoMensual": "",
                "peso": "",
                "talla": "",
                "claveOcupacion": "",
                "descripcionOcupacion": "",
                "claveTipoFamilia": "T",
                "nombre": "",
                "email": "",
                "telefono": 0,
                "incluyeMascotas": false
            },
            "asegurado": {
                "datosPersonales": {
                    "posicionAsegurado": 1,
                    "identificadorInterno": "",
                    "tipoIdentificadorId": 1,
                    "tipoJuridicoId": "",
                    "rfc": "",
                    "curp": "",
                    "razonSocial": "",
                    "nombre": "",
                    "segundoNombre": "",
                    "primerApellido": "",
                    "segundoApellido": "",
                    "fechaNacimiento": "",
                    "genero": "",
                    "numeroTelefono": "",
                    "calleNumInterior": "",
                    "email": "",
                    "estadoCivil": "",
                    "ocupacion": "",
                    "empleadoGobierno": "",
                    "descripcionActividades": "",
                    "telefonoParticular": "",
                    "telefonoCelular": "",
                    "firmaElectronica": "",
                    "tipoIdentificacion": "",
                    "folioIdentificacion": "",
                    "residenteFiscalExtranjero": "",
                    "nacionalidad": "",
                    "descripcionNacionalidad": "",
                    "telefonoClaveLada": "",
                    "paisNacimiento": "",
                    "lugarNacimiento": "",
                    "puesto": "",
                    "paisExpideDocto": "",
                    "otraNacionalidad": "",
                    "descOtraNacionalidad": "",
                    "paisResideFiscalmente": "",
                    "numIdExtranjero": "",
                    "losDatosDelContratanteSonLosMismosQueLosDelAsegurado": false,
                    "tipoDeIdentificacionEntregada": ""
                },
                "direccion": {
                    "ordinalDomicilio": 1,
                    "tipoDomicilioId": "1",
                    "calleNombre": "",
                    "calleNumeroExt": "",
                    "calleNumInterior": "",
                    "numeroDepartamentoInterno": 0,
                    "siglasDomicilio": "",
                    "codigoPostalId": "",
                    "coloniaId": "",
                    "coloniaDescripcion": "",
                    "municipioId": "",
                    "municipioDescripcion": "",
                    "estadoId": "",
                    "estadoDescripcion": "",
                    "paisId": "",
                    "paisDescripcion": "",
                    "zonaDescripcion": "",
                    "ciudadId": "",
                    "ciudadDescripcion": ""
                }
            },
            "tomador": {
                "datosPersonales": {
                    "identificadorInterno": "",
                    "tipoIdentificadorId": 1,
                    "tipoJuridicoId": "",
                    "tipoDePersona": "",
                    "rfc": "",
                    "curp": "",
                    "razonSocial": "",
                    "nombre": "",
                    "segundoNombre": "",
                    "primerApellido": "",
                    "segundoApellido": "",
                    "fechaNacimiento": "",
                    "genero": "",
                    "numeroTelefono": "",
                    "email": "",
                    "estadoCivil": "",
                    "empleadoGobierno": "",
                    "descripcionActividades": "",
                    "telefonoParticular": "",
                    "telefonoCelular": "",
                    "firmaElectronica": "",
                    "tipoIdentificacion": "",
                    "folioIdentificacion": "",
                    "residenteFiscalExtranjero": "",
                    "nacionalidad": "",
                    "telefonoClaveLada": "",
                    "paisNacimiento": "",
                    "lugarNacimiento": "",
                    "puesto": "",
                    "paisExpideDocto": "",
                    "otraNacionalidad": "",
                    "descOtraNacionalidad": "",
                    "paisResideFiscalmente": "",
                    "numIdExtranjero": "",
                    "nombreDelApoderadoLegal": "",
                    "descripcionNacionalidad": "",
                    "fechaDeNacimientoDelApoderado": "",
                    "ocupacion": "",
                    "descripcionOcupacion": "",
                    "estadoCivilDescripcion": "",
                    "generoDescripcion": "",
                    "paisResideFiscalmenteDescripcion": "",
                    "tipoDeIdentificacionEntregada": ""
                },
                "direccion": {
                    "ordinalDomicilio": 0,
                    "tipoDomicilioId": "1",
                    "calleNombre": "",
                    "calleNumeroExt": "",
                    "calleNumInterior": "",
                    "numeroDepartamentoInterno": 0,
                    "siglasDomicilio": "",
                    "codigoPostalId": "",
                    "coloniaId": "",
                    "coloniaDescripcion": "",
                    "municipioId": "",
                    "municipioDescripcion": "",
                    "estadoId": "",
                    "estadoDescripcion": "",
                    "paisId": "",
                    "paisDescripcion": "",
                    "zonaDescripcion": "",
                    "ciudadId": "",
                    "ciudadDescripcion": ""
                }
            },
            "aseguradosAdicionalesGF": {
                "personas": [
                    {
                        "numeroObjeto": 1,
                        "nombre": "",
                        "apePaterno": "",
                        "apeMaterno": "",
                        "fechaNacimiento": "",
                        "parentesco": "",
                        "parentescoDescripcion": "",
                        "genero": "",
                        "generoDescripcion": ""
                    }
                ],
                "mascotas": [
                    {
                        "numeroObjeto": 1,
                        "nombre": "",
                        "tipoMascota": "",
                        "raza": "",
                        "edad": "",
                        "generoMascot": "",
                        "tipoMascotaDescripcion": "",
                        "generoMascotDescripcion": ""
                    }
                ]
            },
            "beneficiarios": [
                {
                    "numeroObjeto": 1,
                    "nombre": "",
                    "apePaterno": "",
                    "apeMaterno": "",
                    "fechaNacimiento": "",
                    "parentesco": "",
                    "parentescoDescripcion": "",
                    "genero": "",
                    "generoDescripcion": "",
                    "porcentaje": ""
                }
            ],
            "coberturas": [
                {
                    "claveCobertura": "",
                    "sumaAsegurada": 0,
                    "atrRecargoCobertura": 0,
                    "porcentajeExtraPrima": "0",
                    "claveSumaAseguradaCapital": "",
                    "atrActiveDotal": "",
                    "montoPrimaNetaCobertura": 0,
                    "atrExtraprimaActividad": 0
                }
            ],
            "plan": {
                "nombrePlan": "",
                "temporalidad": "",
                "monto": "",
                "descripcion": ""
            },
            "gastosFunerarios": {
                "titular": "T",
                "titularYconyugue": "C",
                "titularEhijos": "H",
                "titularConyugueHijos": "F",
                "sumaAseguradaGF": ""
            },
            "formaPago": {
                "periodicidadPagoId": "",
                "metodoPagoId": "8",
                "metodoPagoDescrip": "TRANSFERENCIA",
                "cantidadCuotas": 12,
                "montoPrimerPago": 3209.6272,
                "montoPagoSubsecuente": 3209.6272,
                "swPagoLinea": false,
                "bancoId": "Santander",
                "sucursalId": "",
                "numeroCuenta": "",
                "gestorId": "",
                "numeroTarjeta": "",
                "fechaVencimiento": "",
                "cvv": "",
                "montoCobrado": "3562.27",
                "numeroReferencia": "1",
                "numeroAutorizacion": "1",
                "fechaCobro": "2021-10-13T23:07:04.2647777+00:00",
                "tipoCambio": "0",
                "diaCobro": "15"
            },
            "conocimientoCliente": {
                "cuentaConOtroSeguroDeVidaContratadoDeFormaVoluntaria": "",
                "leHanRechazadoLimitadoOExtraPrimadoAlgunaSolicitud": ""
            },
            "polizaCotizacion": {
                "oficina": 1,
                "ramo": 901,
                "estado": "W",
                "numeroPoliza": "188930",
                "solicitudId": 101134,
                "suplemento": 0,
                "poliza": "188930",
                "rfc": "XXXXXXX"
            }
        },
        modelFolio: {
            "_id": "61f9b1bb4d14c600076a56c0",
            "key": "modelFolio",
            "producto": "planVive",
            "aliado": "COTIZADORES_SURA",
            "numFolio": 101126
        },
        persistenceModel: {
            "_id": "621ea49dd11c8c00075e6a4a",
            "key": "persistenceModel",
            "configuracion": {
                "folio": "",
                "estadoFlujo": "",
                "ultimaPersistencia": {},
                "estadoBarraProgreso": []
            },
            "componentes": [],
            "cuestionariosMedicos": {},
            "datosAgente": {},
            "cotizaciones": [],
            "emisiones": []
        }
    },
    formResponses: [
        {
            "label": "Aliado",
            "defaultValue": "COTIZADORES_SURA",
            "key": "claveAliado",
            "type": "hidden",
            "input": true,
            "tableView": false,
            "value": "COTIZADORES_SURA"
        },
        {
            "label": "Status",
            "defaultValue": "ACEPTAR",
            "key": "status",
            "type": "hidden",
            "input": true,
            "tableView": false,
            "value": "ACEPTAR"
        },
        {
            "label": "Url Cuestionarios Medicos",
            "key": "urlCuestionariosMedicos",
            "type": "hidden",
            "input": true,
            "tableView": false
        },
        {
            "label": "Folio",
            "key": "folio",
            "type": "hidden",
            "input": true,
            "tableView": false,
            "value": 101134
        },
        {
            "label": "MI IMC ES DE",
            "placeholder": "0.0 m",
            "tooltip": "Índice de Masa Corporal",
            "suffix": "m",
            "spellcheck": false,
            "disabled": true,
            "tableView": false,
            "calculateValue": {
                "operation": "peso/(talla*talla)",
                "fields": [
                    "peso",
                    "talla"
                ]
            },
            "validate": {
                "required": true,
                "minLength": 1,
                "maxLength": 6
            },
            "key": "imc",
            "properties": {
                "fixed": "3"
            },
            "type": "textfield",
            "input": true,
            "value": "20.761"
        },
        {
            "label": "¿Eres fumador?",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "required": true,
                "customMessage": "Error"
            },
            "key": "esFumador",
            "type": "checkbox",
            "input": true,
            "value": false
        },
        {
            "label": "FECHA DE NACIMIENTO",
            "format": "DD/MM/YYYY",
            "tableView": false,
            "enableMinDateInput": false,
            "datePicker": {
                "minDate": "1870-01-01T12:00:00-04:56",
                "maxDate": "2021-01-01T12:00:00-05:00",
                "disableWeekends": false,
                "disableWeekdays": false
            },
            "enableMaxDateInput": false,
            "validate": {
                "required": true,
                "customMessage": "INGRESA UNA FECHA VÁLIDA"
            },
            "key": "fechaNacimiento",
            "type": "datetime",
            "input": true,
            "widget": {
                "type": "calendar",
                "displayInTimezone": "viewer",
                "locale": "en",
                "useLocaleSettings": false,
                "allowInput": true,
                "mode": "single",
                "enableTime": true,
                "noCalendar": false,
                "format": "DD/MM/YYYY",
                "hourIncrement": 1,
                "minuteIncrement": 1,
                "time_24hr": false,
                "minDate": "1870-01-01T12:00:00-04:56",
                "disableWeekends": false,
                "disableWeekdays": false,
                "maxDate": "2021-01-01T12:00:00-05:00"
            },
            "value": "1980-12-12"
        },
        {
            "label": "OCUPACIÓN",
            "widget": "choicesjs",
            "placeholder": "Elige tu ocupación ",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/catalogos/ocupaciones",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "claveOcupacion",
            "type": "select",
            "input": true,
            "valuesResponse": [
                {
                    "clave": "A397",
                    "descripcion": "ACTRIZ"
                }
            ],
            "value": "A397"
        },
        {
            "label": "PESO EN KILOGRAMOS",
            "placeholder": "Ej: 00.000 Kg",
            "suffix": "Kg",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "[0-9]{1,3}\\.[0-9][0-9][0-9]",
                "customMessage": "Ingrese un peso correcto Ej: 99.999",
                "minLength": 1,
                "maxLength": 7
            },
            "key": "peso",
            "properties": {
                "fixed": "3"
            },
            "type": "textfield",
            "input": true,
            "value": "60.000"
        },
        {
            "label": "ALTURA EN METROS",
            "placeholder": "Ej: 0.00 m",
            "suffix": "m",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "(?:(2.)([0-5])|(?:(1.)([0-9])))[0-9]",
                "customMessage": "Ingrese una altura correcta Ej: 1.80",
                "minLength": 1,
                "maxLength": 4
            },
            "key": "talla",
            "type": "textfield",
            "input": true,
            "value": "1.70"
        },
        {
            "label": "Genero",
            "optionsLabelPosition": "right",
            "customClass": "radioImage",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "Femenino",
                    "value": "M",
                    "shortcut": ""
                },
                {
                    "label": "Masculino",
                    "value": "H",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "genero",
            "properties": {
                "H": "https://images.prismic.io/portal-cotizacion-suramex/0399ebf0-3ec8-4cf6-9f70-0f1105be2022_men.png?auto=compress,format",
                "M": "https://images.prismic.io/portal-cotizacion-suramex/4cb0207a-34b8-41c3-b8f0-1c94de47c94e_women.png?auto=compress,format"
            },
            "type": "radio",
            "input": true,
            "value": "M"
        },
        {
            "label": "¿Tienes mascotas?",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "required": true
            },
            "key": "incluyeMascotas",
            "type": "checkbox",
            "input": true,
            "value": true
        },
        {
            "label": "Familia",
            "optionsLabelPosition": "right",
            "customClass": "radioImage",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "Soltero(a)",
                    "value": "T",
                    "shortcut": ""
                },
                {
                    "label": "Pareja sin hijos",
                    "value": "C",
                    "shortcut": ""
                },
                {
                    "label": "Pareja con hijos",
                    "value": "F",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "claveTipoFamilia",
            "properties": {
                "T": "https://images.prismic.io/portal-cotizacion-suramex/a81f3af0-a49a-4a1b-b4d4-b3f5cc367095_solteros.png?auto=compress,format",
                "C": "https://images.prismic.io/portal-cotizacion-suramex/ffe662ac-b650-430a-9750-7c2d6b612171_parejasinhijos.png?auto=compress,format",
                "F": "https://images.prismic.io/portal-cotizacion-suramex/5144744e-ff1e-4825-ae75-b5d54c1bc20a_parejaconhijos.png?auto=compress,format"
            },
            "type": "radio",
            "input": true,
            "value": "C"
        },
        {
            "label": "Mascotas",
            "optionsLabelPosition": "right",
            "customClass": "radioImage",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "Perro",
                    "value": "perro",
                    "shortcut": ""
                },
                {
                    "label": "Gato",
                    "value": "gato",
                    "shortcut": ""
                },
                {
                    "label": "Ambos",
                    "value": "ambos",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "mascota",
            "properties": {
                "perro": "https://images.prismic.io/portal-cotizacion-suramex/7bc9b6ae-f3d1-4b56-ad93-85983d859890_perro.png?auto=compress,format",
                "gato": "https://images.prismic.io/portal-cotizacion-suramex/14ee12a7-307e-4915-b35f-a245477d8c27_gato.png?auto=compress,format",
                "ambos": "https://images.prismic.io/portal-cotizacion-suramex/972369e9-eff7-479e-978b-38673d903ca5_ambos.png?auto=compress,format"
            },
            "conditional": {
                "show": true,
                "when": "incluyeMascotas",
                "eq": "true"
            },
            "type": "radio",
            "input": true,
            "value": "perro"
        },
        {
            "label": "¿POR CUANTO TIEMPO QUIERES CONTRATAR TU SEGURO?",
            "widget": "choicesjs",
            "placeholder": "años",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "1 año",
                        "value": "1"
                    },
                    {
                        "label": "5 años",
                        "value": "5"
                    },
                    {
                        "label": "10 años",
                        "value": "10"
                    },
                    {
                        "label": "15 años",
                        "value": "15"
                    },
                    {
                        "label": "20 años",
                        "value": "20"
                    },
                    {
                        "label": "25 años",
                        "value": "25"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "atrTipoTemporalidad",
            "type": "select",
            "input": true,
            "value": "5"
        },
        {
            "label": "¿En qué monedas quieres tus coberturas?",
            "widget": "choicesjs",
            "placeholder": "Ej: pesos",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "MXN - Pesos",
                        "value": "MXN"
                    },
                    {
                        "label": "USD - Dólares",
                        "value": "USD"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "monedaId",
            "type": "select",
            "input": true,
            "value": "USD"
        },
        {
            "label": "Coberturas",
            "optionsLabelPosition": "right",
            "tableView": false,
            "defaultValue": {
                "1": false,
                "": false,
                "{": false
            },
            "values": [
                {
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/coberturas?fechaNacimiento=value&claveTipoFamilia=value&claveOcupacion=value&claveAliado=value&atrTipoTemporalidad=value&incluyeMascotas=value&page=1\",   \"method\": \"GET\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"   },   \"body\": {} }",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "coberturas",
            "type": "selectboxes",
            "input": true,
            "inputType": "checkbox",
            "value": [
                {
                    "nombre": "COBERTURA BÁSICA POR FALLECIMIENTO",
                    "claveCobertura": "9190",
                    "obligatorio": true,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 50,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 1500000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 75000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 230769,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "BÁSICA",
                    "asegurados": [],
                    "page": "1",
                    "img": "be8d7cbd-4fbe-473d-972c-1444d267104c_fallecimiento.png",
                    "descripcion": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada.",
                    "criterios": {
                        "igualdad": [
                            "9194"
                        ],
                        "nuevoMaximo": [
                            {
                                "coberturas": [
                                    "9191",
                                    "9192",
                                    "9193",
                                    "9195"
                                ],
                                "formula": {
                                    "operador": "*",
                                    "valor1": "sumaAseguradaSeleccionada",
                                    "valor2": 1.5
                                }
                            },
                            {
                                "coberturas": [
                                    "9197"
                                ],
                                "formula": {
                                    "operador": "*",
                                    "valor1": "sumaAseguradaSeleccionada",
                                    "valor2": 0.5
                                }
                            }
                        ]
                    },
                    "value": 75000
                },
                {
                    "nombre": "GASTOS FUNERARIOS",
                    "claveCobertura": "9198",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 58,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 20000,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 1000,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 3076,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": null,
                    "tipo": "RECOMENDADA",
                    "asegurados": [
                        {
                            "claveAsegurado": "T",
                            "dsAsegurado": "Para mí",
                            "porcentajeExtraPrima": 0
                        },
                        {
                            "claveAsegurado": "H",
                            "dsAsegurado": "Para mí y mis hijos",
                            "porcentajeExtraPrima": 0
                        },
                        {
                            "claveAsegurado": "C",
                            "dsAsegurado": "Para mí y mi cónyuge",
                            "porcentajeExtraPrima": 0
                        },
                        {
                            "claveAsegurado": "F",
                            "dsAsegurado": "Para mí, mi cónyuge y mis hijos (menores de 18 años)",
                            "porcentajeExtraPrima": 0
                        }
                    ],
                    "page": "1",
                    "img": "6ed16477-76dd-42c5-9faa-93fee1fc6436_gastos-funerarios.png",
                    "descripcion": "En caso de que llegaran a faltar tú, tu cónyuge o alguno de tus hijos, tus beneficiarios recibirán la suma asegurada contratada.",
                    "checks": "C",
                    "value": 2500
                }
            ],
            "valueResponse": [
                {
                    "nombre": "COBERTURA BÁSICA POR FALLECIMIENTO",
                    "claveCobertura": "9190",
                    "obligatorio": true,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 50,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 1500000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 75000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 230769,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "BÁSICA",
                    "asegurados": [],
                    "page": "1",
                    "img": "be8d7cbd-4fbe-473d-972c-1444d267104c_fallecimiento.png",
                    "descripcion": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada.",
                    "criterios": {
                        "igualdad": [
                            "9194"
                        ],
                        "nuevoMaximo": [
                            {
                                "coberturas": [
                                    "9191",
                                    "9192",
                                    "9193",
                                    "9195"
                                ],
                                "formula": {
                                    "operador": "*",
                                    "valor1": "sumaAseguradaSeleccionada",
                                    "valor2": 1.5
                                }
                            },
                            {
                                "coberturas": [
                                    "9197"
                                ],
                                "formula": {
                                    "operador": "*",
                                    "valor1": "sumaAseguradaSeleccionada",
                                    "valor2": 0.5
                                }
                            }
                        ]
                    },
                    "value": 75000
                },
                {
                    "nombre": "MUERTE ACCIDENTAL",
                    "claveCobertura": "9191",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 51,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 2000000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 100000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 307692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "6efe56e5-8e7f-4002-9281-d49670c7bec8_fallecimiento-accidental.png",
                    "descripcion": "Pagamos a los beneficiarios una suma asegurada adicional en caso de que el fallecimiento del asegurado ocurra a causa de un accidente."
                },
                {
                    "nombre": "MUERTE ACCIDENTAL COLECTIVA",
                    "claveCobertura": "9192",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 52,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 100000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 5000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 15385,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "89c178b5-61e7-4132-9f7e-d75c4d638eea_exencionpagos-primas-invalidez.png",
                    "descripcion": "Pagamos a los beneficiarios una suma asegurada adicional en caso de que el fallecimiento del asegurado ocurra a causa de un accidente como pasajero en transporte terrestre público, un elevador público o un incendio en un edificio público."
                },
                {
                    "nombre": "PÉRDIDAS ORGÁNICAS",
                    "claveCobertura": "9195",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 55,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 2000000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 100000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 307692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "b5331ca7-35f7-4dfa-b2f5-35e39683d1c8_perdidas-organicas.png",
                    "descripcion": "Indemnizamos al asegurado en caso de sufrir la pérdida de alguna parte del cuerpo a consecuencia de un accidente, de acuerdo al tipo de pérdida sufrida."
                },
                {
                    "nombre": "INDEMNIZACIÓN DIARIA POR HOSPITALIZACIÓN",
                    "claveCobertura": "9196",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 56,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 120,
                            "sumaAseguradaMaxima": 1500,
                            "sumaAseguradaPredeterminada": 1000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 6,
                            "sumaAseguradaMaxima": 75,
                            "sumaAseguradaPredeterminada": 50,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 19,
                            "sumaAseguradaMaxima": 230,
                            "sumaAseguradaPredeterminada": 154,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "a8b46c2b-5211-415b-af7b-32d4b31107de_indemnizacion-diaria-hospitaliza.png",
                    "descripcion": "En caso de estar hospitalizado a causa de una enfermedad o accidente, contarás con un apoyo económico."
                },
                {
                    "nombre": "ENFERMEDADES GRAVES",
                    "claveCobertura": "9197",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 57,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 375000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 150000,
                            "sumaAseguradaPredeterminada": 18750,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 57692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "136b5425-92b5-458f-9427-5dc01bed3bb4_enfermedades-graves.png",
                    "descripcion": "Si eres diagnosticado por primera vez con alguna de las 9 enfermedades graves cubiertas, se te pagará la suma asegurada contratada para esta cobertura."
                },
                {
                    "nombre": "GASTOS FUNERARIOS",
                    "claveCobertura": "9198",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 58,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 20000,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 1000,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 3076,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": null,
                    "tipo": "RECOMENDADA",
                    "asegurados": [
                        {
                            "claveAsegurado": "T",
                            "dsAsegurado": "Para mí",
                            "porcentajeExtraPrima": 0
                        },
                        {
                            "claveAsegurado": "H",
                            "dsAsegurado": "Para mí y mis hijos",
                            "porcentajeExtraPrima": 0
                        },
                        {
                            "claveAsegurado": "C",
                            "dsAsegurado": "Para mí y mi cónyuge",
                            "porcentajeExtraPrima": 0
                        },
                        {
                            "claveAsegurado": "F",
                            "dsAsegurado": "Para mí, mi cónyuge y mis hijos (menores de 18 años)",
                            "porcentajeExtraPrima": 0
                        }
                    ],
                    "page": "1",
                    "img": "6ed16477-76dd-42c5-9faa-93fee1fc6436_gastos-funerarios.png",
                    "descripcion": "En caso de que llegaran a faltar tú, tu cónyuge o alguno de tus hijos, tus beneficiarios recibirán la suma asegurada contratada.",
                    "checks": "C",
                    "value": 2500
                }
            ]
        },
        {
            "label": "Coberturas adicionales",
            "optionsLabelPosition": "right",
            "tableView": false,
            "defaultValue": {
                "1": false,
                "": false,
                "{": false
            },
            "values": [
                {
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/coberturas?fechaNacimiento=value&claveTipoFamilia=value&claveOcupacion=value&claveAliado=value&incluyeMascotas=value&page=2\",   \"method\": \"GET\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"   },   \"body\": {} }",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "coberturasAdicionales",
            "type": "selectboxes",
            "input": true,
            "inputType": "checkbox",
            "value": [
                {
                    "nombre": "PROTECCIÓN MASCOTAS",
                    "claveCobertura": "9204",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 62,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 5000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 250,
                            "sumaAseguradaMaxima": 250,
                            "sumaAseguradaPredeterminada": 250,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 769,
                            "sumaAseguradaMaxima": 769,
                            "sumaAseguradaPredeterminada": 769,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": null,
                    "tipo": "OPCIONAL",
                    "asegurados": [],
                    "page": "2",
                    "img": "5cf7b422-6c95-46cd-99e9-7f4ee608a1ad_mascotas.png",
                    "descripcion": "Tu mascota estará protegida en caso de fallecimiento.",
                    "value": 250
                }
            ],
            "valueResponse": [
                {
                    "nombre": "PROTECCIÓN ADICIONAL POR FALLECIMIENTO",
                    "claveCobertura": "9202",
                    "obligatorio": false,
                    "dependencia": "9190",
                    "claveSumaAseguradaCapital": 60,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 100000,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "USD": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 5000,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "UDI": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 15385,
                            "porcentajeSumAseguradaMinDependencia": 20
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "OPCIONAL",
                    "asegurados": [],
                    "page": "2",
                    "img": "6fb25117-e9fd-4351-bb97-e3f61b16151b_proteccion-adicional-fallecimiento.png",
                    "descripcion": "En caso de que llegues a faltar, tus beneficiarios contarán con un bono adicional que podrán utilizar para fines como: gastos del hogar, etc."
                },
                {
                    "nombre": "PROTECCIÓN MASCOTAS",
                    "claveCobertura": "9204",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 62,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 5000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 250,
                            "sumaAseguradaMaxima": 250,
                            "sumaAseguradaPredeterminada": 250,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 769,
                            "sumaAseguradaMaxima": 769,
                            "sumaAseguradaPredeterminada": 769,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": null,
                    "tipo": "OPCIONAL",
                    "asegurados": [],
                    "page": "2",
                    "img": "5cf7b422-6c95-46cd-99e9-7f4ee608a1ad_mascotas.png",
                    "descripcion": "Tu mascota estará protegida en caso de fallecimiento.",
                    "value": 250
                }
            ]
        },
        {
            "label": "Aceptar aviso de privacidad",
            "customClass": "readonly",
            "defaultValue": "Al continuar estas aceptando el <A HREF=\"https://www.segurossura.com.mx/legales/aviso-de-privacidad/\" target=\"_blank\">aviso de privacidad</A>",
            "key": "avisoPrivacidad",
            "type": "hidden",
            "input": true,
            "tableView": false,
            "value": "Al continuar estas aceptando el <A HREF=\"https://www.segurossura.com.mx/legales/aviso-de-privacidad/\" target=\"_blank\">aviso de privacidad</A>"
        },
        {
            "label": "No soy un robot",
            "customClass": "recaptcha",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "required": true
            },
            "key": "noSoyUnRobot",
            "properties": {
                "sitekey": "6LdCNUMaAAAAAM3W7I7d9dsG9WXPb-0W0v7f9n9G"
            },
            "type": "checkbox",
            "input": true,
            "value": true
        },
        {
            "label": "Nombre",
            "placeholder": "Ej. Diana",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Ingresa un nombre valido",
                "minLength": 1,
                "maxLength": 100
            },
            "key": "nombre",
            "type": "textfield",
            "input": true,
            "value": "ROBERTO"
        },
        {
            "label": "INGRESA TU E-MAIL",
            "placeholder": "ejemplo@gmail.com",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                "customMessage": "Ingrese un correo electrónico valido",
                "minLength": 1,
                "maxLength": 100
            },
            "key": "email",
            "type": "textfield",
            "input": true,
            "value": "a@a.com"
        },
        {
            "label": "TELÉFONO CELULAR",
            "placeholder": "Ej. 555723799",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^(?!.*?([1234567890])\\1{9,}|(1234567890))[0-9]*$",
                "customMessage": "Ingresa un número telefónico valido",
                "minLength": 10,
                "maxLength": 10
            },
            "key": "telefono",
            "type": "textfield",
            "input": true,
            "value": "3005555555"
        },
        {
            "label": "Planes",
            "optionsLabelPosition": "right",
            "customClass": "selectboxesPlans",
            "tableView": false,
            "defaultValue": {
                "api": false,
                "apiService": false,
                "{": false
            },
            "values": [
                {
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/cotizacion\",   \"method\": \"POST\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"   },   \"body\": {} }",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "planes",
            "type": "selectboxes",
            "input": true,
            "inputType": "checkbox",
            "value": [
                {
                    "paquete": "Mi plan vive más",
                    "valor": 220.96,
                    "asistencias": "Asistencia básica (legal, médica, funeraria y repatriación) + nutricional y psicológica",
                    "tooltip": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada.",
                    "descripcion": "Complementa tu Plan Vive con asistencia nutricional y psicológica.",
                    "coberturas": [
                        {
                            "claveCobertura": "9198",
                            "sumaAsegurada": 2500,
                            "atrRecargoCobertura": 0,
                            "porcentajeExtraPrima": "0",
                            "claveSumaAseguradaCapital": 58,
                            "atrExtraprimaActividad": "0"
                        },
                        {
                            "claveCobertura": "9190",
                            "sumaAsegurada": 75000,
                            "atrRecargoCobertura": 0,
                            "porcentajeExtraPrima": "0",
                            "claveSumaAseguradaCapital": 50,
                            "atrExtraprimaActividad": "0"
                        },
                        {
                            "claveCobertura": "9204",
                            "sumaAsegurada": 250,
                            "atrRecargoCobertura": 0,
                            "porcentajeExtraPrima": "0",
                            "claveSumaAseguradaCapital": 62,
                            "atrExtraprimaActividad": "0"
                        },
                        {
                            "claveCobertura": "9207",
                            "sumaAsegurada": 0,
                            "atrRecargoCobertura": 0,
                            "porcentajeExtraPrima": "0",
                            "claveSumaAseguradaCapital": 65,
                            "atrExtraprimaActividad": "0"
                        }
                    ]
                }
            ]
        },
        {
            "label": "Nombre",
            "placeholder": "Ej. Juan",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "primerNombre",
            "type": "textfield",
            "input": true,
            "customDefaultValue": "nombre",
            "value": "ROBERTO"
        },
        {
            "label": "Fecha de nacimiento",
            "format": "DD/MM/YYYY",
            "placeholder": "Ej. 25/04/1996",
            "tableView": false,
            "enableMinDateInput": false,
            "datePicker": {
                "minDate": "1870-01-01T11:59:00-04:56",
                "maxDate": "2021-01-01T12:00:00-05:00",
                "disableWeekends": false,
                "disableWeekdays": false
            },
            "enableMaxDateInput": false,
            "customDefaultValue": "fechaNacimiento",
            "validate": {
                "required": true
            },
            "key": "fechaDeNacimientoAsegurado",
            "type": "datetime",
            "input": true,
            "widget": {
                "type": "calendar",
                "displayInTimezone": "viewer",
                "locale": "en",
                "useLocaleSettings": false,
                "allowInput": true,
                "mode": "single",
                "enableTime": true,
                "noCalendar": false,
                "format": "DD/MM/YYYY",
                "hourIncrement": 1,
                "minuteIncrement": 1,
                "time_24hr": false,
                "minDate": "1870-01-01T11:59:00-04:56",
                "disableWeekends": false,
                "disableWeekdays": false,
                "maxDate": "2021-01-01T12:00:00-05:00"
            },
            "value": "1980-12-12"
        },
        {
            "label": "INGRESA TU E-MAIL",
            "placeholder": "ejemplo@gmail.com",
            "tableView": true,
            "customDefaultValue": "email",
            "validate": {
                "required": true,
                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                "customMessage": "Ingrese un correo electrónico valido",
                "minLength": 1,
                "maxLength": 100
            },
            "key": "email1",
            "type": "textfield",
            "input": true,
            "value": "a@a.com"
        },
        {
            "label": "TELÉFONO CELULAR",
            "placeholder": "Ej. 55 5723 799",
            "tableView": true,
            "customDefaultValue": "telefono",
            "validate": {
                "required": true,
                "pattern": "^(?!.*?([1234567890])\\1{9,}|(1234567890))[0-9]*$",
                "customMessage": "Ingresa un número telefónico valido",
                "minLength": 10,
                "maxLength": 10
            },
            "key": "telefonoCelular",
            "type": "textfield",
            "input": true,
            "value": "3005555555"
        },
        {
            "label": "¿Residente fiscal en el extranjero?",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "customMessage": "Error"
            },
            "key": "residenteFiscalExtranjero",
            "conditional": {
                "show": false,
                "when": "pais",
                "eq": "052"
            },
            "type": "checkbox",
            "input": true,
            "value": false
        },
        {
            "label": "Género",
            "widget": "choicesjs",
            "placeholder": "Elige género",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Femenino",
                        "value": "M"
                    },
                    {
                        "label": "Masculino",
                        "value": "H"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "sexo",
            "type": "select",
            "input": true,
            "customDefaultValue": "genero",
            "value": "H",
            "valuesResponse": [
                {
                    "clave": "H",
                    "descripcion": "HOMBRE"
                }
            ]
        },
        {
            "label": "Ocupación o profesión",
            "widget": "choicesjs",
            "placeholder": "Elige ocupación o profesión",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/catalogos/ocupaciones",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "claveOcupacion",
            "key": "ocupacionProfesion",
            "type": "select",
            "input": true,
            "value": "A397",
            "valuesResponse": [
                {
                    "clave": "A397",
                    "descripcion": "ACTRIZ"
                }
            ]
        },
        {
            "label": "Ocupación o profesión",
            "widget": "choicesjs",
            "placeholder": "Elige ocupación o profesión",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/catalogos/ocupaciones",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "claveOcupacion",
            "key": "ocupacionProfesion",
            "type": "select",
            "input": true,
            "value": "A397",
            "valuesResponse": [
                {
                    "clave": "A397",
                    "descripcion": "ACTRIZ"
                }
            ]
        },
        {
            "label": "RFC",
            "placeholder": "Ingresa el número de RFC",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[A-Z0-9]*$",
                "customMessage": "Dato no válido",
                "minLength": 13,
                "maxLength": 13
            },
            "key": "identificadorPersona",
            "type": "textfield",
            "input": true,
            "value": "PUFR801212K28"
        },
        {
            "label": "Apellido paterno",
            "placeholder": "Ej. Pérez",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "primerApellido",
            "type": "textfield",
            "input": true,
            "value": "PRUEBA"
        },
        {
            "label": "Apellido materno",
            "placeholder": "Ej. Rodríguez",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "segundoApellido",
            "type": "textfield",
            "input": true,
            "value": "FERNANDEZ"
        },
        {
            "label": "Código postal",
            "placeholder": "Ej. 43540",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[0-9]*$",
                "customMessage": "Dato no válido",
                "minLength": 5,
                "maxLength": 5
            },
            "key": "codigoPostal",
            "type": "textfield",
            "input": true,
            "value": "39300"
        },
        {
            "label": "País de Nacimiento",
            "widget": "choicesjs",
            "placeholder": "Elige país de nacimiento",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/paises",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "pais",
            "type": "select",
            "input": true,
            "value": "052",
            "valuesResponse": [
                {
                    "clave": "052",
                    "descripcion": "MEXICO"
                }
            ]
        },
        {
            "label": "Estado",
            "widget": "choicesjs",
            "placeholder": "Elige el estado",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostal=value&catalogo=ESTADO",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "validate": {
                "required": true
            },
            "key": "estadoAsegurado",
            "type": "select",
            "input": true,
            "value": "12",
            "valuesResponse": [
                {
                    "clave": "12",
                    "descripcion": "GUERRERO"
                }
            ]
        },
        {
            "label": "Colonia",
            "widget": "choicesjs",
            "placeholder": "Elige la colonia",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostal=value&catalogo=COLONIA",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "coloniaAsegurado",
            "type": "select",
            "input": true,
            "value": "12G04",
            "valuesResponse": [
                {
                    "clave": "12G04",
                    "descripcion": "TEPETATES"
                }
            ]
        },
        {
            "label": "CURP",
            "placeholder": "Digita Clave Única de Registro de Población",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z0-9]+$",
                "customMessage": "Tu CURP debe tener longitud de 18 caracteres",
                "minLength": 18,
                "maxLength": 18
            },
            "key": "curp",
            "type": "textfield",
            "input": true,
            "value": "123212132131232132"
        },
        {
            "label": "Estado Civil",
            "widget": "choicesjs",
            "placeholder": "Elige estado civil",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Casado/a.",
                        "value": "C"
                    },
                    {
                        "label": "Soltero/a.",
                        "value": "S"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "estadoCivil",
            "type": "select",
            "input": true,
            "value": "C"
        },
        {
            "label": "Lugar de Nacimiento",
            "placeholder": "Lugar de Nacimiento",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 40
            },
            "key": "lugarNacimiento",
            "type": "textfield",
            "input": true,
            "value": "aa"
        },
        {
            "label": "Nacionalidad",
            "widget": "choicesjs",
            "placeholder": "Elige tu nacionalidad",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/nacionalidades",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "nacionalidad",
            "type": "select",
            "input": true,
            "valuesResponse": [
                {
                    "clave": "001",
                    "descripcion": "AFGANISTAN"
                }
            ],
            "value": "001"
        },
        {
            "label": "Ingresos mensuales",
            "placeholder": "Ej. 113434",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "/^([1-9]\\d*(\\.\\d*[1-9][0-9])?)|(\\d*[1-9])|(0\\.\\d*[1-9])$/",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 7
            },
            "key": "ingresosMensuales",
            "type": "textfield",
            "input": true,
            "value": "11"
        },
        {
            "label": "Tipo de identificación entregada",
            "widget": "choicesjs",
            "placeholder": "Elige tipo de identificación entregada",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Credencial para votar vigente",
                        "value": "credencialParaVotarVigente"
                    },
                    {
                        "label": "Pasaporte vigente",
                        "value": "pasaporteVigente"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "tipoDeIdentificacionEntregada",
            "type": "select",
            "input": true,
            "value": "credencialParaVotarVigente"
        },
        {
            "label": "Folio de identificación entregada",
            "placeholder": "Ej. 788120155J",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 30
            },
            "key": "folioDeIdentificacionEntregada",
            "type": "textfield",
            "input": true,
            "value": "123123"
        },
        {
            "label": "Dirección",
            "placeholder": "Digita la dirección",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 50
            },
            "key": "direccion",
            "type": "textfield",
            "input": true,
            "value": "aa"
        },
        {
            "label": "No. Exterior",
            "placeholder": "Ej. 2214",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^(0|[1-9][0-9]*)$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 6
            },
            "key": "nExterior",
            "type": "textfield",
            "input": true,
            "value": "112"
        },
        {
            "label": "Ciudad",
            "widget": "choicesjs",
            "placeholder": "Elige la ciudad",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostal=value&catalogo=CIUDAD",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "ciudadAsegurado",
            "type": "select",
            "input": true,
            "valuesResponse": [
                {
                    "clave": "12-00001-0",
                    "descripcion": "CIUDAD DE ACAPULCO DE JUAREZ"
                }
            ],
            "value": "12-00001-0"
        },
        {
            "label": "Municipio",
            "widget": "choicesjs",
            "placeholder": "Elige el municipio",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostal=value&catalogo=MUNICIPIO",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "municipioAsegurado",
            "type": "select",
            "input": true,
            "valuesResponse": [
                {
                    "clave": "12-00001",
                    "descripcion": "ACAPULCO DE JUAREZ"
                }
            ],
            "value": "12-00001"
        },
        {
            "label": "Cuénta con otro seguro de vida contratado de forma voluntaria?",
            "optionsLabelPosition": "right",
            "customClass": "radioText",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "Si",
                    "value": "si",
                    "shortcut": ""
                },
                {
                    "label": "No",
                    "value": "no",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "cuentaConOtroSeguroDeVidaContratadoDeFormaVoluntaria",
            "type": "radio",
            "input": true,
            "value": "no"
        },
        {
            "label": "Le han rechazado, limitado o extra-primado alguna solicitud?",
            "optionsLabelPosition": "right",
            "customClass": "radioText",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "Si",
                    "value": "si",
                    "shortcut": ""
                },
                {
                    "label": "No",
                    "value": "no",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "leHanRechazadoLimitadoOExtraPrimadoAlgunaSolicitud",
            "type": "radio",
            "input": true,
            "value": "no"
        },
        {
            "label": "Parentesco",
            "widget": "choicesjs",
            "placeholder": "Elige el parentesco",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "CÓNYUGE",
                        "value": "C"
                    },
                    {
                        "label": "HIJO(A)",
                        "value": "H"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "parentescoAsegurado-0",
            "properties": {
                "parentContainer": "asegurados"
            },
            "type": "select",
            "input": true,
            "value": "C"
        },
        {
            "label": "Mensaje modal - Error en porcentaje acumulado",
            "defaultValue": "Recuerda que el porcentaje acumulado debe sumar el 100%",
            "key": "mensajeErrorPorcentaje",
            "type": "hidden",
            "input": true,
            "tableView": false,
            "value": "Recuerda que el porcentaje acumulado debe sumar el 100%"
        },
        {
            "label": "Genero persona moral",
            "defaultValue": "Empresa",
            "key": "generoPersonaMoralContratante",
            "type": "hidden",
            "input": true,
            "tableView": false,
            "value": "Empresa"
        },
        {
            "label": "Los datos del contratante son los mismos que los del asegurado",
            "customClass": "checkClassic",
            "tableView": false,
            "defaultValue": true,
            "key": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
            "properties": {
                "autocomplete": "true"
            },
            "type": "checkbox",
            "input": true,
            "value": true
        },
        {
            "label": "RFC",
            "placeholder": "Digita el RFC",
            "tableView": true,
            "customDefaultValue": "identificadorPersona",
            "validate": {
                "required": true,
                "pattern": "^[A-Z0-9]*$",
                "customMessage": "Dato no válido",
                "minLength": 13,
                "maxLength": 13
            },
            "key": "identificadorPersonaContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "PUFR801212K28"
        },
        {
            "label": "Nombre",
            "placeholder": "Ej. Juan",
            "tableView": true,
            "customDefaultValue": "primerNombre",
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "primerNombreContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "ROBERTO"
        },
        {
            "label": "Apellido paterno",
            "placeholder": "Ej. Rodriguez",
            "tableView": true,
            "customDefaultValue": "primerApellido",
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "primerApellidoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "PRUEBA"
        },
        {
            "label": "Apellido materno",
            "placeholder": "Ej. Martínez",
            "tableView": true,
            "customDefaultValue": "segundoApellido",
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "segundoApellidoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "FERNANDEZ"
        },
        {
            "label": "CURP",
            "placeholder": "Digita el CURP",
            "tableView": true,
            "customDefaultValue": "curp",
            "validate": {
                "required": true,
                "pattern": "^[a-zA-Z0-9]+$",
                "customMessage": "Tu CURP debe tener longitud de 18 caracteres",
                "minLength": 18,
                "maxLength": 18
            },
            "key": "curpContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "123212132131232132"
        },
        {
            "label": "Género",
            "widget": "choicesjs",
            "placeholder": "Elige el género",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Femenino",
                        "value": "M"
                    },
                    {
                        "label": "Masculino",
                        "value": "H"
                    }
                ]
            },
            "customDefaultValue": "genero",
            "validate": {
                "required": true
            },
            "key": "sexoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true,
            "value": "M"
        },
        {
            "label": "Fecha de nacimiento",
            "format": "DD/MM/YYYY",
            "tableView": false,
            "enableMinDateInput": false,
            "datePicker": {
                "minDate": "1870-01-01T11:59:00-04:56",
                "maxDate": "2021-01-01T12:00:00-05:00",
                "disableWeekends": false,
                "disableWeekdays": false
            },
            "enableMaxDateInput": false,
            "customDefaultValue": "fechaNacimiento",
            "validate": {
                "required": true
            },
            "key": "fechaNacimientoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "datetime",
            "input": true,
            "widget": {
                "type": "calendar",
                "displayInTimezone": "viewer",
                "locale": "en",
                "useLocaleSettings": false,
                "allowInput": true,
                "mode": "single",
                "enableTime": true,
                "noCalendar": false,
                "format": "DD/MM/YYYY",
                "hourIncrement": 1,
                "minuteIncrement": 1,
                "time_24hr": false,
                "minDate": "1870-01-01T11:59:00-04:56",
                "disableWeekends": false,
                "disableWeekdays": false,
                "maxDate": "2021-01-01T12:00:00-05:00"
            },
            "value": "1980-12-12"
        },
        {
            "label": "Estado Civil",
            "widget": "choicesjs",
            "placeholder": "Elige estado civil",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Soltero/a.",
                        "value": "S"
                    },
                    {
                        "label": "Casado/a.",
                        "value": "C"
                    }
                ]
            },
            "customDefaultValue": "estadoCivil",
            "validate": {
                "required": true
            },
            "key": "estadoCivilContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true,
            "value": "C"
        },
        {
            "label": "País de Nacimiento",
            "widget": "choicesjs",
            "placeholder": "Elige tu país de nacimiento",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/paises",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "pais",
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "paisNacimientoContratante",
            "type": "select",
            "input": true,
            "value": "052",
            "valuesResponse": [
                {
                    "clave": "001",
                    "descripcion": "AFGANISTAN"
                },
                {
                    "clave": "002",
                    "descripcion": "ALBANIA"
                },
                {
                    "clave": "103",
                    "descripcion": "ALEMANIA"
                },
                {
                    "clave": "003",
                    "descripcion": "ANDORRA"
                },
                {
                    "clave": "004",
                    "descripcion": "ANGOLA"
                },
                {
                    "clave": "005",
                    "descripcion": "ANGUILLA"
                },
                {
                    "clave": "006",
                    "descripcion": "ANTIGUA Y BARBUDA"
                },
                {
                    "clave": "173",
                    "descripcion": "ANTILLAS HOLANDESAS"
                },
                {
                    "clave": "007",
                    "descripcion": "ARABIA SAUDI"
                },
                {
                    "clave": "008",
                    "descripcion": "ARGELIA"
                },
                {
                    "clave": "009",
                    "descripcion": "ARGENTINA"
                },
                {
                    "clave": "010",
                    "descripcion": "ARMENIA"
                },
                {
                    "clave": "011",
                    "descripcion": "ARUBA"
                },
                {
                    "clave": "141",
                    "descripcion": "AUSTRALIA"
                },
                {
                    "clave": "012",
                    "descripcion": "AUSTRIA"
                },
                {
                    "clave": "013",
                    "descripcion": "AZERBAIYAN"
                },
                {
                    "clave": "014",
                    "descripcion": "BAHAMAS"
                },
                {
                    "clave": "169",
                    "descripcion": "BAHREIN"
                },
                {
                    "clave": "015",
                    "descripcion": "BANGLADESH"
                },
                {
                    "clave": "016",
                    "descripcion": "BARBADOS"
                },
                {
                    "clave": "114",
                    "descripcion": "BELGICA"
                },
                {
                    "clave": "017",
                    "descripcion": "BELICE"
                },
                {
                    "clave": "018",
                    "descripcion": "BENIN"
                },
                {
                    "clave": "019",
                    "descripcion": "BHUTAN"
                },
                {
                    "clave": "020",
                    "descripcion": "BIELORRUSIA"
                },
                {
                    "clave": "021",
                    "descripcion": "BOLIVIA"
                },
                {
                    "clave": "022",
                    "descripcion": "BOSNIA Y HERZEGOVINA"
                },
                {
                    "clave": "023",
                    "descripcion": "BOTSWANA"
                },
                {
                    "clave": "024",
                    "descripcion": "BRASIL"
                },
                {
                    "clave": "025",
                    "descripcion": "BRUNEI DARUSSALAM"
                },
                {
                    "clave": "906",
                    "descripcion": "BULGARIA"
                },
                {
                    "clave": "026",
                    "descripcion": "BURKINA FASO"
                },
                {
                    "clave": "027",
                    "descripcion": "BURUNDI"
                },
                {
                    "clave": "028",
                    "descripcion": "CAIMANES"
                },
                {
                    "clave": "029",
                    "descripcion": "CAMBOYA"
                },
                {
                    "clave": "030",
                    "descripcion": "CAMERUN"
                },
                {
                    "clave": "126",
                    "descripcion": "CANADA"
                },
                {
                    "clave": "031",
                    "descripcion": "CHAD"
                },
                {
                    "clave": "171",
                    "descripcion": "CHANNEL ISLANDS"
                },
                {
                    "clave": "032",
                    "descripcion": "CHILE"
                },
                {
                    "clave": "134",
                    "descripcion": "CHINA"
                },
                {
                    "clave": "033",
                    "descripcion": "CHIPRE"
                },
                {
                    "clave": "035",
                    "descripcion": "CHIPRE TURCO"
                },
                {
                    "clave": "036",
                    "descripcion": "CHRISTMAS ISLANDS"
                },
                {
                    "clave": "037",
                    "descripcion": "CIUDAD DEL VATICANO"
                },
                {
                    "clave": "127",
                    "descripcion": "COLOMBIA"
                },
                {
                    "clave": "038",
                    "descripcion": "COMORES"
                },
                {
                    "clave": "133",
                    "descripcion": "COREA DEL NORTE"
                },
                {
                    "clave": "039",
                    "descripcion": "COREA DEL SUR"
                },
                {
                    "clave": "040",
                    "descripcion": "COSTA DE MARFIL"
                },
                {
                    "clave": "506",
                    "descripcion": "COSTA RICA"
                },
                {
                    "clave": "041",
                    "descripcion": "CROACIA"
                },
                {
                    "clave": "042",
                    "descripcion": "CUBA"
                },
                {
                    "clave": "043",
                    "descripcion": "DIEGO GARCIA"
                },
                {
                    "clave": "116",
                    "descripcion": "DINAMARCA"
                },
                {
                    "clave": "044",
                    "descripcion": "DOMINICA"
                },
                {
                    "clave": "900",
                    "descripcion": "ECUADOR"
                },
                {
                    "clave": "139",
                    "descripcion": "EGIPTO"
                },
                {
                    "clave": "903",
                    "descripcion": "EL SALVADOR"
                },
                {
                    "clave": "045",
                    "descripcion": "EMIRATOS ARABES UNIDOS"
                },
                {
                    "clave": "046",
                    "descripcion": "ERITREA"
                },
                {
                    "clave": "047",
                    "descripcion": "ESLOVAQUIA"
                },
                {
                    "clave": "048",
                    "descripcion": "ESLOVENIA"
                },
                {
                    "clave": "034",
                    "descripcion": "ESPAÑA"
                },
                {
                    "clave": "055",
                    "descripcion": "ESTADOS UNIDOS"
                },
                {
                    "clave": "049",
                    "descripcion": "ESTONIA"
                },
                {
                    "clave": "050",
                    "descripcion": "ETIOPIA"
                },
                {
                    "clave": "051",
                    "descripcion": "FEDERACION RUSA"
                },
                {
                    "clave": "053",
                    "descripcion": "FIJI"
                },
                {
                    "clave": "054",
                    "descripcion": "FILIPINAS"
                },
                {
                    "clave": "110",
                    "descripcion": "FINLANDIA"
                },
                {
                    "clave": "109",
                    "descripcion": "FRANCIA"
                },
                {
                    "clave": "056",
                    "descripcion": "GABON"
                },
                {
                    "clave": "057",
                    "descripcion": "GAMBIA"
                },
                {
                    "clave": "058",
                    "descripcion": "GEORGIA"
                },
                {
                    "clave": "059",
                    "descripcion": "GHANA"
                },
                {
                    "clave": "060",
                    "descripcion": "GIBRALTAR"
                },
                {
                    "clave": "061",
                    "descripcion": "GRAN BRETAÑA"
                },
                {
                    "clave": "062",
                    "descripcion": "GRANADA"
                },
                {
                    "clave": "063",
                    "descripcion": "GRECIA"
                },
                {
                    "clave": "064",
                    "descripcion": "GROELANDIA"
                },
                {
                    "clave": "065",
                    "descripcion": "GUADALUPE"
                },
                {
                    "clave": "066",
                    "descripcion": "GUAM"
                },
                {
                    "clave": "067",
                    "descripcion": "GUATEMALA"
                },
                {
                    "clave": "068",
                    "descripcion": "GUAYANA FRANCESA"
                },
                {
                    "clave": "071",
                    "descripcion": "GUINEA BISSAU"
                },
                {
                    "clave": "069",
                    "descripcion": "GUINEA ECUATORIAL"
                },
                {
                    "clave": "070",
                    "descripcion": "GUINEA REPUBLIC"
                },
                {
                    "clave": "072",
                    "descripcion": "GUYANA"
                },
                {
                    "clave": "073",
                    "descripcion": "HAITI"
                },
                {
                    "clave": "117",
                    "descripcion": "HOLANDA"
                },
                {
                    "clave": "901",
                    "descripcion": "HONDURAS"
                },
                {
                    "clave": "074",
                    "descripcion": "HONG KONG"
                },
                {
                    "clave": "075",
                    "descripcion": "HUNGRIA"
                },
                {
                    "clave": "174",
                    "descripcion": "INDIA"
                },
                {
                    "clave": "076",
                    "descripcion": "INDONESIA"
                },
                {
                    "clave": "101",
                    "descripcion": "INGLATERRA"
                },
                {
                    "clave": "077",
                    "descripcion": "IRAN"
                },
                {
                    "clave": "078",
                    "descripcion": "IRAQ"
                },
                {
                    "clave": "118",
                    "descripcion": "IRLANDA"
                },
                {
                    "clave": "079",
                    "descripcion": "ISLANDIA"
                },
                {
                    "clave": "080",
                    "descripcion": "ISLAS COCOS"
                },
                {
                    "clave": "081",
                    "descripcion": "ISLAS COOK"
                },
                {
                    "clave": "082",
                    "descripcion": "ISLAS DEL CABO VERDE"
                },
                {
                    "clave": "083",
                    "descripcion": "ISLAS FERROE"
                },
                {
                    "clave": "084",
                    "descripcion": "ISLAS MALVINAS"
                },
                {
                    "clave": "085",
                    "descripcion": "ISLAS MARIANAS"
                },
                {
                    "clave": "086",
                    "descripcion": "ISLAS SALOMON"
                },
                {
                    "clave": "087",
                    "descripcion": "ISLAS VIRGENES AMERICANAS"
                },
                {
                    "clave": "088",
                    "descripcion": "ISLAS VIRGENES BRITANICAS"
                },
                {
                    "clave": "089",
                    "descripcion": "ISRAEL"
                },
                {
                    "clave": "108",
                    "descripcion": "ITALIA"
                },
                {
                    "clave": "090",
                    "descripcion": "JAMAICA"
                },
                {
                    "clave": "105",
                    "descripcion": "JAPON"
                },
                {
                    "clave": "091",
                    "descripcion": "JORDANIA"
                },
                {
                    "clave": "092",
                    "descripcion": "KAZAJSTAN"
                },
                {
                    "clave": "093",
                    "descripcion": "KENIA"
                },
                {
                    "clave": "094",
                    "descripcion": "KIRGUIZASTAN"
                },
                {
                    "clave": "095",
                    "descripcion": "KIRIBATI"
                },
                {
                    "clave": "096",
                    "descripcion": "KUWUAIT"
                },
                {
                    "clave": "097",
                    "descripcion": "LAOS"
                },
                {
                    "clave": "111",
                    "descripcion": "LAS BERMUDAS"
                },
                {
                    "clave": "098",
                    "descripcion": "LESHOTO"
                },
                {
                    "clave": "099",
                    "descripcion": "LETONIA"
                },
                {
                    "clave": "100",
                    "descripcion": "LIBANO"
                },
                {
                    "clave": "102",
                    "descripcion": "LIBERIA"
                },
                {
                    "clave": "106",
                    "descripcion": "LIBIA"
                },
                {
                    "clave": "107",
                    "descripcion": "LIECHTENSTEIN"
                },
                {
                    "clave": "112",
                    "descripcion": "LITUANIA"
                },
                {
                    "clave": "145",
                    "descripcion": "LUXEMBURGO"
                },
                {
                    "clave": "113",
                    "descripcion": "MACAO"
                },
                {
                    "clave": "115",
                    "descripcion": "MACEDONIA"
                },
                {
                    "clave": "119",
                    "descripcion": "MADAGASCAR"
                },
                {
                    "clave": "120",
                    "descripcion": "MALASIA"
                },
                {
                    "clave": "121",
                    "descripcion": "MALAWI"
                },
                {
                    "clave": "122",
                    "descripcion": "MALDIVAS"
                },
                {
                    "clave": "124",
                    "descripcion": "MALI"
                },
                {
                    "clave": "170",
                    "descripcion": "MALTA"
                },
                {
                    "clave": "125",
                    "descripcion": "MARRUECOS"
                },
                {
                    "clave": "128",
                    "descripcion": "MARSHALL ISLANDS"
                },
                {
                    "clave": "129",
                    "descripcion": "MARTINICA"
                },
                {
                    "clave": "130",
                    "descripcion": "MAURICIO"
                },
                {
                    "clave": "132",
                    "descripcion": "MAURITANIA"
                },
                {
                    "clave": "135",
                    "descripcion": "MAYOTTE"
                },
                {
                    "clave": "052",
                    "descripcion": "MEXICO"
                },
                {
                    "clave": "136",
                    "descripcion": "MICRONESIA"
                },
                {
                    "clave": "137",
                    "descripcion": "MOLDAVIA"
                },
                {
                    "clave": "138",
                    "descripcion": "MONACO"
                },
                {
                    "clave": "140",
                    "descripcion": "MONGOLIA"
                },
                {
                    "clave": "142",
                    "descripcion": "MONTSERRAT"
                },
                {
                    "clave": "143",
                    "descripcion": "MOZAMBIQUE"
                },
                {
                    "clave": "144",
                    "descripcion": "MYANMAR"
                },
                {
                    "clave": "146",
                    "descripcion": "NAMIBIA"
                },
                {
                    "clave": "147",
                    "descripcion": "NAURU"
                },
                {
                    "clave": "150",
                    "descripcion": "NEGERIA"
                },
                {
                    "clave": "148",
                    "descripcion": "NEPAL"
                },
                {
                    "clave": "902",
                    "descripcion": "NICARAGUA"
                },
                {
                    "clave": "149",
                    "descripcion": "NIGER"
                },
                {
                    "clave": "151",
                    "descripcion": "NIUE"
                },
                {
                    "clave": "152",
                    "descripcion": "NORFOLK ISLANDS"
                },
                {
                    "clave": "153",
                    "descripcion": "NORUEGA"
                },
                {
                    "clave": "154",
                    "descripcion": "NUEVA CELEDONIA"
                },
                {
                    "clave": "155",
                    "descripcion": "NUEVA ZELANDA"
                },
                {
                    "clave": "156",
                    "descripcion": "OMAN"
                },
                {
                    "clave": "157",
                    "descripcion": "PAISES BAJOS"
                },
                {
                    "clave": "158",
                    "descripcion": "PAKISTAN"
                },
                {
                    "clave": "159",
                    "descripcion": "PALAU"
                },
                {
                    "clave": "131",
                    "descripcion": "PANAMA"
                },
                {
                    "clave": "160",
                    "descripcion": "PAPUA NUEVA GUINEA"
                },
                {
                    "clave": "161",
                    "descripcion": "PARAGUAY"
                },
                {
                    "clave": "162",
                    "descripcion": "PERU"
                },
                {
                    "clave": "163",
                    "descripcion": "PITCAINR ISLANDS"
                },
                {
                    "clave": "164",
                    "descripcion": "POLINESIA FRANCESA"
                },
                {
                    "clave": "165",
                    "descripcion": "POLONIA"
                },
                {
                    "clave": "166",
                    "descripcion": "PORTUGAL"
                },
                {
                    "clave": "167",
                    "descripcion": "PUERTO RICO"
                },
                {
                    "clave": "168",
                    "descripcion": "QATAR"
                },
                {
                    "clave": "172",
                    "descripcion": "REPUBLICA CENTROAFRICANA"
                },
                {
                    "clave": "176",
                    "descripcion": "REPUBLICA CHECA"
                },
                {
                    "clave": "177",
                    "descripcion": "REPUBLICA DEL CONGO"
                },
                {
                    "clave": "178",
                    "descripcion": "REPUBLICA DEMOCRATICA DEL CONGO"
                },
                {
                    "clave": "179",
                    "descripcion": "REPUBLICA DOMINICANA"
                },
                {
                    "clave": "180",
                    "descripcion": "REUNION"
                },
                {
                    "clave": "181",
                    "descripcion": "RUANDA"
                },
                {
                    "clave": "182",
                    "descripcion": "RUMANIA"
                },
                {
                    "clave": "183",
                    "descripcion": "SAMOA AMERICANA"
                },
                {
                    "clave": "184",
                    "descripcion": "SAMOA OCCIDENTAL"
                },
                {
                    "clave": "185",
                    "descripcion": "SAN CRISTOBAL Y NEVIS"
                },
                {
                    "clave": "186",
                    "descripcion": "SAN MARINO"
                },
                {
                    "clave": "187",
                    "descripcion": "SAN PEDRO Y MIGUELON"
                },
                {
                    "clave": "188",
                    "descripcion": "SAN TOME Y PRINCIPE"
                },
                {
                    "clave": "189",
                    "descripcion": "SAN VICENTE Y GRANADINAS"
                },
                {
                    "clave": "190",
                    "descripcion": "SANTA ELENA"
                },
                {
                    "clave": "191",
                    "descripcion": "SANTA LUCIA"
                },
                {
                    "clave": "192",
                    "descripcion": "SENEGAL"
                },
                {
                    "clave": "193",
                    "descripcion": "SERVIA Y MONTENEGRO"
                },
                {
                    "clave": "194",
                    "descripcion": "SEYCHELLES"
                },
                {
                    "clave": "195",
                    "descripcion": "SIERRA LEONA"
                },
                {
                    "clave": "196",
                    "descripcion": "SINGAPUR"
                },
                {
                    "clave": "197",
                    "descripcion": "SIRIA"
                },
                {
                    "clave": "198",
                    "descripcion": "SOMALIA"
                },
                {
                    "clave": "199",
                    "descripcion": "SRI LANKA"
                },
                {
                    "clave": "175",
                    "descripcion": "SUDAFRICA"
                },
                {
                    "clave": "200",
                    "descripcion": "SUDAN"
                },
                {
                    "clave": "123",
                    "descripcion": "SUECIA"
                },
                {
                    "clave": "104",
                    "descripcion": "SUIZA"
                },
                {
                    "clave": "201",
                    "descripcion": "SURINAM"
                },
                {
                    "clave": "202",
                    "descripcion": "SWAZILANDIA"
                },
                {
                    "clave": "203",
                    "descripcion": "TADJIKISTAN"
                },
                {
                    "clave": "204",
                    "descripcion": "TAILANDIA"
                },
                {
                    "clave": "205",
                    "descripcion": "TAIWAN"
                },
                {
                    "clave": "206",
                    "descripcion": "TANZANIA"
                },
                {
                    "clave": "207",
                    "descripcion": "TIMOR ORIENTAL"
                },
                {
                    "clave": "208",
                    "descripcion": "TOGO"
                },
                {
                    "clave": "209",
                    "descripcion": "TONGA"
                },
                {
                    "clave": "210",
                    "descripcion": "TRINIDAD Y TOBAGO"
                },
                {
                    "clave": "211",
                    "descripcion": "TUNEZ"
                },
                {
                    "clave": "212",
                    "descripcion": "TURKMENISTAN"
                },
                {
                    "clave": "213",
                    "descripcion": "TURKS Y CAICOS"
                },
                {
                    "clave": "214",
                    "descripcion": "TURQUIA"
                },
                {
                    "clave": "215",
                    "descripcion": "TUVALU"
                },
                {
                    "clave": "216",
                    "descripcion": "UCRANIA"
                },
                {
                    "clave": "217",
                    "descripcion": "UGANDA"
                },
                {
                    "clave": "218",
                    "descripcion": "URUGUAY"
                },
                {
                    "clave": "219",
                    "descripcion": "UZBEKISTAN"
                },
                {
                    "clave": "220",
                    "descripcion": "VANUATU"
                },
                {
                    "clave": "221",
                    "descripcion": "VENEZUELA"
                },
                {
                    "clave": "222",
                    "descripcion": "VIETNAM"
                },
                {
                    "clave": "223",
                    "descripcion": "WALLIS Y FUTUNA"
                },
                {
                    "clave": "224",
                    "descripcion": "YEMEN"
                },
                {
                    "clave": "225",
                    "descripcion": "YIBUTI"
                },
                {
                    "clave": "226",
                    "descripcion": "YUGOSLAVIA"
                },
                {
                    "clave": "227",
                    "descripcion": "ZAIRE"
                },
                {
                    "clave": "228",
                    "descripcion": "ZAMBIA"
                },
                {
                    "clave": "229",
                    "descripcion": "ZIMBABWE"
                }
            ]
        },
        {
            "label": "Lugar de Nacimiento",
            "placeholder": "Lugar de Nacimiento",
            "tableView": true,
            "customDefaultValue": "lugarNacimiento",
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 40
            },
            "key": "lugarNacimientoContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "aa"
        },
        {
            "label": "Nacionalidad",
            "widget": "choicesjs",
            "placeholder": "Elige tu nacionalidad",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/nacionalidades",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "nacionalidad",
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "nacionalidadContratante",
            "type": "select",
            "input": true,
            "value": "001"
        },
        {
            "label": "Ocupación o profesión",
            "widget": "choicesjs",
            "placeholder": "Elige ocupación",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/catalogos/ocupaciones",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "claveOcupacion",
            "validate": {
                "required": true
            },
            "key": "ocupacionProfesionContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true,
            "value": "A397"
        },
        {
            "label": "Ingresos mensuales",
            "placeholder": "Ej. 8599",
            "tableView": true,
            "customDefaultValue": "ingresosMensuales",
            "validate": {
                "required": true,
                "pattern": "/^([1-9]\\d*(\\.\\d*[1-9][0-9])?)|(\\d*[1-9])|(0\\.\\d*[1-9])$/",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 7
            },
            "key": "ingresosMensualesContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "11"
        },
        {
            "label": "INGRESA TU E-MAIL",
            "placeholder": "ejemplo@gmail.com",
            "tableView": true,
            "customDefaultValue": "email",
            "validate": {
                "required": true,
                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                "customMessage": "Ingrese un correo electrónico valido",
                "minLength": 1,
                "maxLength": 100
            },
            "key": "emailContratante",
            "type": "textfield",
            "input": true,
            "value": "a@a.com"
        },
        {
            "label": "TELÉFONO CELULAR",
            "placeholder": "Ej. 55 5723 799",
            "tableView": true,
            "customDefaultValue": "telefono",
            "validate": {
                "required": true,
                "pattern": "^(?!.*?([1234567890])\\1{9,}|(1234567890))[0-9]*$",
                "customMessage": "Ingresa un número telefónico valido",
                "minLength": 10,
                "maxLength": 10
            },
            "key": "telefonoCelularContratante",
            "type": "textfield",
            "input": true,
            "value": "3005555555"
        },
        {
            "label": "Tipo de identificación entregada",
            "widget": "choicesjs",
            "placeholder": "Elige tipo de identificación",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Credencial para votar vigente",
                        "value": "credencialParaVotarVigente"
                    },
                    {
                        "label": "Pasaporte vigente",
                        "value": "pasaporteVigente"
                    }
                ]
            },
            "customDefaultValue": "tipoDeIdentificacionEntregada",
            "validate": {
                "required": true
            },
            "key": "tipoDeIdentificacionEntregadaContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true,
            "value": "credencialParaVotarVigente"
        },
        {
            "label": "Folio de identificación entregada",
            "placeholder": "Digita folio de identificación",
            "tableView": true,
            "customDefaultValue": "folioDeIdentificacionEntregada",
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 30
            },
            "key": "folioDeIdentificacionEntregadaContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "123123"
        },
        {
            "label": "¿Residente fiscal en el extranjero?",
            "tableView": false,
            "defaultValue": false,
            "customDefaultValue": "residenteFiscalExtranjero",
            "validate": {
                "required": true,
                "customMessage": "Error"
            },
            "key": "residenteFiscalExtranjeroContratante",
            "conditional": {
                "show": false,
                "when": "paisNacimientoContratante",
                "eq": "052"
            },
            "type": "checkbox",
            "input": true,
            "value": ""
        },
        {
            "label": "Dirección",
            "tableView": true,
            "customDefaultValue": "direccion",
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 50
            },
            "key": "direccionContratante",
            "type": "textfield",
            "input": true,
            "placeholder": "Ej. Av Benito J No 90",
            "value": "aa"
        },
        {
            "label": "No. Exterior",
            "placeholder": "Ej. 451",
            "tableView": true,
            "customDefaultValue": "nExterior",
            "validate": {
                "required": true,
                "pattern": "^(0|[1-9][0-9]*)$",
                "customMessage": "Dato no válido",
                "minLength": 1,
                "maxLength": 6
            },
            "key": "nExteriorContratante",
            "type": "textfield",
            "input": true,
            "value": "112"
        },
        {
            "label": "Código postal",
            "placeholder": "Ej. 43540",
            "tableView": true,
            "customDefaultValue": "codigoPostal",
            "validate": {
                "required": true,
                "pattern": "^[0-9]*$",
                "customMessage": "Dato no válido",
                "minLength": 5,
                "maxLength": 5
            },
            "key": "codigoPostalContratante",
            "type": "textfield",
            "input": true,
            "value": "39300"
        },
        {
            "label": "Estado",
            "widget": "choicesjs",
            "placeholder": "Elige el estado",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostalContratante=value&catalogo=ESTADO",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "estadoAsegurado",
            "validate": {
                "required": true
            },
            "key": "estadoContratante",
            "type": "select",
            "input": true,
            "value": "12"
        },
        {
            "label": "Colonia",
            "widget": "choicesjs",
            "placeholder": "Elige la colonia",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostalContratante=value&catalogo=COLONIA",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "coloniaAsegurado",
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "coloniaContratante",
            "type": "select",
            "input": true,
            "value": "12G04"
        },
        {
            "label": "Ciudad",
            "widget": "choicesjs",
            "placeholder": "Elige la ciudad",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostalContratante=value&catalogo=CIUDAD",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "ciudadAsegurado",
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "ciudadContratante",
            "type": "select",
            "input": true,
            "value": "12-00001-0"
        },
        {
            "label": "Municipio",
            "widget": "choicesjs",
            "placeholder": "Elige el municipio",
            "tableView": true,
            "dataSrc": "json",
            "data": {
                "json": {
                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostalContratante=value&catalogo=MUNICIPIO",
                    "method": "GET",
                    "headers": {
                        "Content-Type": "application/json",
                        "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                    },
                    "body": {}
                }
            },
            "customDefaultValue": "municipioAsegurado",
            "validate": {
                "required": true,
                "customMessage": "Este campo es requerido"
            },
            "key": "municipioContratante",
            "type": "select",
            "input": true,
            "value": "12-00001"
        },
        {
            "label": "TIPO DE PERSONA",
            "optionsLabelPosition": "right",
            "customClass": "radioText",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "PERSONA FÍSICA",
                    "value": "personaFisica",
                    "shortcut": ""
                },
                {
                    "label": "PERSONA MORAL",
                    "value": "personaMoral",
                    "shortcut": ""
                }
            ],
            "customDefaultValue": "tipoDePersona",
            "validate": {
                "required": true
            },
            "key": "tipoDePersonaContratante",
            "conditional": {
                "show": true,
                "when": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
                "eq": "false"
            },
            "type": "radio",
            "input": true,
            "defaultValue": "personaFisica",
            "value": "personaFisica"
        },
        {
            "label": "Añadir apoderado legal",
            "customClass": "checkClassic",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "required": true
            },
            "key": "anadirApoderadoLegalContratante",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaMoral"
            },
            "type": "checkbox",
            "input": true,
            "value": false
        }
    ],
    hiddenFields: [],
    disabledFields: {}
};

export const dataFormSendRequest = {
    data: {
        modelConfig: {
            _id: "617b1d71f9014c8fa24a517a",
            key: "modelConfig",
            configuracion: {
                claveAliado: "COTIZADORES_SURA",
                producto: "planVive",
                status: "evaluacion",
            },
            poliza: {
                oficinaId: null,
                solicitudId: 1,
                periodicidadPagoId: 12,
                monedaId: "MXP",
                atrGrupoId: null,
                atrSubgrupoId: null,
                atrPerfilTarifaId: null,
                atrPuntoVentaId: null,
                usuarioId: null,
                atrTipoTemporalidad: "1",
            },
            situacion: {
                fechaNacimiento: "1990-01-01",
                genero: "H",
                parentesco: "T",
                esFumador: "N",
                peso: "75",
                talla: "1.75",
                claveOcupacion: "A438",
                claveTipoFamilia: "T",
                nombre: "alguien",
                email: "algo@algo.com",
                telefono: 234534,
            },
            coberturas: [{
                claveCobertura: "9190",
                sumaAsegurada: 150000,
                atrRecargoCobertura: 0,
                porcentajeExtraPrima: "1.5",
                claveSumaAseguradaCapital: "50",
            },],
        },
        modelFolio: { numFolio: "123123" }
    },
    formResponses: [{
        "label": "Folio",
        "key": "folio",
        "type": "hidden",
        "input": true,
        "tableView": false,
    }, {
        "label": "Status",
        "key": "status",
        "type": "hidden",
        "input": true,
        "tableView": false,
    }, {
        "label": "Periodicidad",
        "optionsLabelPosition": "right",
        "customClass": "selectboxesPeriodicity",
        "inline": false,
        "tableView": false,
        "defaultValue": 12,
        "values": [{
            "label": "Anual",
            "value": "12",
            "shortcut": ""
        },
        {
            "label": "Semestral",
            "value": "6",
            "shortcut": ""
        },
        {
            "label": "Trimestral",
            "value": "3",
            "shortcut": ""
        },
        {
            "label": "Mensual",
            "value": "1",
            "shortcut": ""
        }
        ],
        "key": "periodicidadPagoId",
        "properties": {
            "1": "0.5",
            "3": "0.3",
            "6": "0.2",
            "12": "0"
        },
        "type": "radio",
        "input": true,
        "value": 1
    }],
    hiddenFields: [],
    disabledFields: {}
};

export const formStatus = {
    steps: [{
        "key_step": "step_personales",
        "name": "Algunos datos",
        "questions": [{
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Hola, para iniciar ingresa algunos datos personales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "No",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "80-20",
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/validaciones/suscripciones-previas?fechaNacimiento=value&peso=value&talla=value&claveOcupacion=value\",\n  \"method\": \"GET\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                "sidebar_service": "Si",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "FECHA DE NACIMIENTO",
                "format": "DD/MM/YYYY",
                "tableView": false,
                "enableMinDateInput": false,
                "datePicker": {
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "maxDate": "2021-01-01T12:00:00-05:00",
                    "disableWeekends": false,
                    "disableWeekdays": false
                },
                "enableMaxDateInput": false,
                "validate": {
                    "required": true,
                    "customMessage": "INGRESA UNA FECHA VÁLIDA"
                },
                "key": "fechaNacimiento",
                "type": "datetime",
                "input": true,
                "widget": {
                    "type": "calendar",
                    "displayInTimezone": "viewer",
                    "locale": "en",
                    "useLocaleSettings": false,
                    "allowInput": true,
                    "mode": "single",
                    "enableTime": true,
                    "noCalendar": false,
                    "format": "DD/MM/YYYY",
                    "hourIncrement": 1,
                    "minuteIncrement": 1,
                    "time_24hr": false,
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "disableWeekends": false,
                    "disableWeekdays": false,
                    "maxDate": "2021-01-01T12:00:00-05:00"
                },
                "value": "1990-01-01"
            },
            {
                "label": "OCUPACIÓN",
                "widget": "choicesjs",
                "placeholder": "Elige tu ocupación ",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/catalogos/ocupaciones",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "claveOcupacion",
                "type": "select",
                "input": true,
                "valuesResponse": [
                    {
                        "clave": "A001",
                        "descripcion": "ABOGADO"
                    }
                ],
                "value": "A001"
            },
            {
                "label": "PESO EN KILOGRAMOS",
                "placeholder": "Ej: 00.000 Kg",
                "suffix": "Kg",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "[0-9]{1,3}\\.[0-9][0-9][0-9]",
                    "customMessage": "Ingrese un peso correcto Ej: 99.999",
                    "minLength": 1,
                    "maxLength": 7
                },
                "key": "peso",
                "properties": {
                    "fixed": "3"
                },
                "type": "textfield",
                "input": true,
                "value": "80.000"
            },
            {
                "label": "ALTURA EN METROS",
                "placeholder": "Ej: 0.00 m",
                "suffix": "m",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "(?:(2.)([0-5])|(?:(1.)([0-9])))[0-9]",
                    "customMessage": "Ingrese una altura correcta Ej: 1.80",
                    "minLength": 1,
                    "maxLength": 4
                },
                "key": "talla",
                "type": "textfield",
                "input": true,
                "value": "1.70"
            },
            {
                "label": "MI IMC ES DE",
                "placeholder": "0.0 m",
                "tooltip": "Índice de Masa Corporal",
                "suffix": "m",
                "spellcheck": false,
                "disabled": true,
                "tableView": false,
                "calculateValue": {
                    "operation": "peso/(talla*talla)",
                    "fields": [
                        "peso",
                        "talla"
                    ]
                },
                "validate": {
                    "required": true,
                    "minLength": 1,
                    "maxLength": 6
                },
                "key": "imc",
                "properties": {
                    "fixed": "3"
                },
                "type": "textfield",
                "input": true,
                "value": "27.682"
            },
            {
                "label": "¿Eres fumador?",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true,
                    "customMessage": "Error"
                },
                "key": "esFumador",
                "type": "checkbox",
                "input": true,
                "value": false
            },
            {
                "label": "Aliado",
                "defaultValue": "COTIZADORES_SURA",
                "key": "claveAliado",
                "type": "hidden",
                "input": true,
                "tableView": false,
                "value": "COTIZADORES_SURA"
            },
            {
                "label": "Status",
                "defaultValue": "ACEPTAR",
                "key": "status",
                "type": "hidden",
                "input": true,
                "tableView": false,
                "value": "ACEPTAR"
            },
            {
                "label": "Url Cuestionarios Medicos",
                "key": "urlCuestionariosMedicos",
                "type": "hidden",
                "input": true,
                "tableView": false
            },
            {
                "label": "Folio",
                "key": "folio",
                "type": "hidden",
                "input": true,
                "tableView": false,
                "value": 407416
            }, {
                "title": "Beneficiarios",
                "breadcrumbClickable": true,
                "buttonSettings": {
                    "previous": true,
                    "cancel": true,
                    "next": true
                },
                "scrollToTop": false,
                "customClass": "repeatableContent",
                "collapsible": false,
                "key": "beneficiarios",
                "type": "panel",
                "label": "Panel",
                "input": false,
                "tableView": false,
                "components": [{
                    "label": "Porcentaje",
                    "placeholder": "Ej. 100",
                    "tooltip": "Debes ingresar un valor entre 1 y 100, recuerda distribuir el 100% correctamente en todos tus beneficiarios.",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^0*(?:[1-9][0-9]?|100)$",
                        "customMessage": "Dato no válido",
                        "minLength": 1,
                        "maxLength": 3
                    },
                    "key": "porcentajeBeneficiario",
                    "type": "textfield",
                    "input": true
                }]
            },
            {
                "title": "infoAsegurados",
                "key": "infoAsegurados"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Selecciona tu género",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "",
                "optionsLabelPosition": "right",
                "customClass": "radioImage",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "Femenino",
                    "value": "M",
                    "shortcut": ""
                },
                {
                    "label": "Masculino",
                    "value": "H",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "genero",
                "properties": {
                    "H": "https://images.prismic.io/portal-cotizacion-suramex/0399ebf0-3ec8-4cf6-9f70-0f1105be2022_men.png?auto=compress,format",
                    "M": "https://images.prismic.io/portal-cotizacion-suramex/4cb0207a-34b8-41c3-b8f0-1c94de47c94e_women.png?auto=compress,format"
                },
                "type": "radio",
                "input": true,
                "value": "M"
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "¿Cómo es tu familia?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Familia",
                "optionsLabelPosition": "right",
                "customClass": "radioImage",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "Soltero(a)",
                    "value": "T",
                    "shortcut": ""
                },
                {
                    "label": "Pareja sin hijos",
                    "value": "C",
                    "shortcut": ""
                },
                {
                    "label": "Pareja con hijos",
                    "value": "F",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "claveTipoFamilia",
                "properties": {
                    "T": "https://images.prismic.io/portal-cotizacion-suramex/a81f3af0-a49a-4a1b-b4d4-b3f5cc367095_solteros.png?auto=compress,format",
                    "C": "https://images.prismic.io/portal-cotizacion-suramex/ffe662ac-b650-430a-9750-7c2d6b612171_parejasinhijos.png?auto=compress,format",
                    "F": "https://images.prismic.io/portal-cotizacion-suramex/5144744e-ff1e-4825-ae75-b5d54c1bc20a_parejaconhijos.png?auto=compress,format"
                },
                "type": "radio",
                "input": true,
                "value": "T"
            },
            {
                "label": "¿Tienes mascotas?",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true
                },
                "key": "incluyeMascotas",
                "type": "checkbox",
                "input": true,
                "value": false
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "¿Qué tipo de mascota tienes?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Mascotas",
                "optionsLabelPosition": "right",
                "customClass": "radioImage",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "Perro",
                    "value": "perro",
                    "shortcut": ""
                },
                {
                    "label": "Gato",
                    "value": "gato",
                    "shortcut": ""
                },
                {
                    "label": "Ambos",
                    "value": "ambos",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "mascotas",
                "properties": {
                    "perro": "https://images.prismic.io/portal-cotizacion-suramex/7bc9b6ae-f3d1-4b56-ad93-85983d859890_perro.png?auto=compress,format",
                    "gato": "https://images.prismic.io/portal-cotizacion-suramex/14ee12a7-307e-4915-b35f-a245477d8c27_gato.png?auto=compress,format",
                    "ambos": "https://images.prismic.io/portal-cotizacion-suramex/972369e9-eff7-479e-978b-38673d903ca5_ambos.png?auto=compress,format"
                },
                "conditional": {
                    "show": true,
                    "when": "incluyeMascotas",
                    "eq": "true"
                },
                "type": "radio",
                "input": true
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Selecciona la temporalidad y moneda de tu póliza:",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "50-50",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "¿POR CUANTO TIEMPO QUIERES CONTRATAR TU SEGURO?",
                "widget": "choicesjs",
                "placeholder": "años",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "1 año",
                        "value": "1"
                    },
                    {
                        "label": "5 años",
                        "value": "5"
                    },
                    {
                        "label": "10 años",
                        "value": "10"
                    },
                    {
                        "label": "15 años",
                        "value": "15"
                    },
                    {
                        "label": "20 años",
                        "value": "20"
                    },
                    {
                        "label": "25 años",
                        "value": "25"
                    }
                    ]
                },
                "validate": {
                    "required": true
                },
                "key": "atrTipoTemporalidad",
                "type": "select",
                "input": true,
                "value": "1"
            },
            {
                "label": "¿En qué monedas quieres tus coberturas?",
                "widget": "choicesjs",
                "placeholder": "Ej: pesos",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "USD - Dólares",
                        "value": "USD"
                    },
                    {
                        "label": "MXN - Pesos",
                        "value": "MXN"
                    }
                    ]
                },
                "validate": {
                    "required": true
                },
                "key": "monedaId",
                "type": "select",
                "input": true,
                "value": "USD"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }
        ]
    },
    {
        "key_step": "step_configura_tu_poliza",
        "name": "Configura tu póliza",
        "questions": [{
            "primary": {
                "associated_group": "step_configura_tu_poliza",
                "title": [{
                    "type": "heading6",
                    "text": "Elige tus coberturas y sumas aseguradas",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Coberturas",
                "optionsLabelPosition": "right",
                "tableView": false,
                "defaultValue": {
                    "1": false,
                    "": false,
                    "{": false
                },
                "values": [{
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/coberturas?fechaNacimiento=value&claveTipoFamilia=value&claveOcupacion=value&claveAliado=value&atrTipoTemporalidad=value&incluyeMascotas=value&page=1\",   \"method\": \"GET\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"   },   \"body\": {} }",
                    "shortcut": ""
                }],
                "validate": {
                    "required": true
                },
                "key": "coberturas",
                "type": "selectboxes",
                "input": true,
                "inputType": "checkbox",
                "value": [{
                    "nombre": "COBERTURA BÁSICA POR FALLECIMIENTO",
                    "claveCobertura": "9190",
                    "obligatorio": true,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 50,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 700000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 35000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 107692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "BÁSICA",
                    "asegurados": [],
                    "page": "1",
                    "img": "be8d7cbd-4fbe-473d-972c-1444d267104c_fallecimiento.png",
                    "descripcion": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada",
                    "criterios": {
                        "igualdad": [
                            "9194"
                        ],
                        "nuevoMaximo": [{
                            "coberturas": [
                                "9191",
                                "9192",
                                "9193",
                                "9195"
                            ],
                            "formula": {
                                "operador": "*",
                                "valor1": "sumaAseguradaSeleccionada",
                                "valor2": 1.5
                            }
                        },
                        {
                            "coberturas": [
                                "9197"
                            ],
                            "formula": {
                                "operador": "*",
                                "valor1": "sumaAseguradaSeleccionada",
                                "valor2": 0.5
                            }
                        }
                        ]
                    },
                    "value": 35000
                },
                {
                    "nombre": "GASTOS FUNERARIOS",
                    "claveCobertura": "9198",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 58,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 20000,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 1000,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 3076,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": null,
                    "tipo": "RECOMENDADA",
                    "asegurados": [{
                        "claveAsegurado": "T",
                        "dsAsegurado": "Para mí",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "H",
                        "dsAsegurado": "Para mí y mis hijos",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "C",
                        "dsAsegurado": "Para mí y mi cónyuge",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "F",
                        "dsAsegurado": "Para mí, mi cónyuge y mis hijos (menores de 18 años)",
                        "porcentajeExtraPrima": 0
                    }
                    ],
                    "page": "1",
                    "img": "6ed16477-76dd-42c5-9faa-93fee1fc6436_gastos-funerarios.png",
                    "descripcion": "En caso de que llegaran a faltar tú, tu cónyuge o alguno de tus hijos, tus beneficiarios recibirán la suma asegurada contratada",
                    "checks": "T",
                    "value": 2500
                }
                ],
                "valueResponse": [{
                    "nombre": "COBERTURA BÁSICA POR FALLECIMIENTO",
                    "claveCobertura": "9190",
                    "obligatorio": true,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 50,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 700000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 35000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 107692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "BÁSICA",
                    "asegurados": [],
                    "page": "1",
                    "img": "be8d7cbd-4fbe-473d-972c-1444d267104c_fallecimiento.png",
                    "descripcion": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada",
                    "criterios": {
                        "igualdad": [
                            "9194"
                        ],
                        "nuevoMaximo": [{
                            "coberturas": [
                                "9191",
                                "9192",
                                "9193",
                                "9195"
                            ],
                            "formula": {
                                "operador": "*",
                                "valor1": "sumaAseguradaSeleccionada",
                                "valor2": 1.5
                            }
                        },
                        {
                            "coberturas": [
                                "9197"
                            ],
                            "formula": {
                                "operador": "*",
                                "valor1": "sumaAseguradaSeleccionada",
                                "valor2": 0.5
                            }
                        }
                        ]
                    },
                    "value": 35000
                },
                {
                    "nombre": "MUERTE ACCIDENTAL",
                    "claveCobertura": "9191",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 51,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "6efe56e5-8e7f-4002-9281-d49670c7bec8_fallecimiento-accidental.png",
                    "descripcion": "Pagamos a los beneficiarios una suma asegurada adicional en caso de que el fallecimiento del asegurado ocurra en un accidente."
                },
                {
                    "nombre": "MUERTE ACCIDENTAL COLECTIVA",
                    "claveCobertura": "9192",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 52,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "89c178b5-61e7-4132-9f7e-d75c4d638eea_exencionpagos-primas-invalidez.png",
                    "descripcion": "Pagamos a los beneficiarios una suma asegurada adicional en caso de que el fallecimiento del asegurado ocurra a causa de un accidente como pasajero en transporte terrestre público."
                },
                {
                    "nombre": "INVALIDEZ TOTAL Y PERMANENTE",
                    "claveCobertura": "9193",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 53,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 1500000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 75000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 230769,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "89c178b5-61e7-4132-9f7e-d75c4d638eea_exencionpagos-primas-invalidez.png",
                    "descripcion": null
                },
                {
                    "nombre": "PÉRDIDAS ORGÁNICAS",
                    "claveCobertura": "9195",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 55,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 1500000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 75000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 230769,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "b5331ca7-35f7-4dfa-b2f5-35e39683d1c8_perdidas-organicas.png",
                    "descripcion": "Indemnizamos al asegurado en caso de sufrir la pérdida de alguna parte del cuerpo a consecuencia de un accidente, de acuerdo al tipo de pérdida sufrida"
                },
                {
                    "nombre": "INDEMNIZACIÓN DIARIA POR HOSPITALIZACIÓN",
                    "claveCobertura": "9196",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 56,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 120,
                            "sumaAseguradaMaxima": 1500,
                            "sumaAseguradaPredeterminada": 1000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 6,
                            "sumaAseguradaMaxima": 75,
                            "sumaAseguradaPredeterminada": 50,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 19,
                            "sumaAseguradaMaxima": 230,
                            "sumaAseguradaPredeterminada": 154,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "a8b46c2b-5211-415b-af7b-32d4b31107de_indemnizacion-diaria-hospitaliza.png",
                    "descripcion": "En caso de estar hospitalizado a causa de una enfermedad o accidente, contarás con un apoyo económico."
                },
                {
                    "nombre": "ENFERMEDADES GRAVES",
                    "claveCobertura": "9197",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 57,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 375000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 150000,
                            "sumaAseguradaPredeterminada": 18750,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 57692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "136b5425-92b5-458f-9427-5dc01bed3bb4_enfermedades-graves.png",
                    "descripcion": "Si eres diagnosticado por primera vez con alguna de las 9 enfermedades graves cubiertas, se te pagará la suma asegurada contratada para esta cobertura."
                },
                {
                    "nombre": "GASTOS FUNERARIOS",
                    "claveCobertura": "9198",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 58,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 20000,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 1000,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 3076,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": null,
                    "tipo": "RECOMENDADA",
                    "asegurados": [{
                        "claveAsegurado": "T",
                        "dsAsegurado": "Para mí",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "H",
                        "dsAsegurado": "Para mí y mis hijos",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "C",
                        "dsAsegurado": "Para mí y mi cónyuge",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "F",
                        "dsAsegurado": "Para mí, mi cónyuge y mis hijos (menores de 18 años)",
                        "porcentajeExtraPrima": 0
                    }
                    ],
                    "page": "1",
                    "img": "6ed16477-76dd-42c5-9faa-93fee1fc6436_gastos-funerarios.png",
                    "descripcion": "En caso de que llegaran a faltar tú, tu cónyuge o alguno de tus hijos, tus beneficiarios recibirán la suma asegurada contratada",
                    "checks": "T",
                    "value": 2500
                }
                ]
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_configura_tu_poliza",
                "title": [{
                    "type": "heading6",
                    "text": "¿Te gustaría personalizar tu experiencia con estas coberturas adicionales?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Coberturas adicionales",
                "optionsLabelPosition": "right",
                "tableView": false,
                "defaultValue": {
                    "1": false,
                    "": false,
                    "{": false
                },
                "values": [{
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/coberturas?fechaNacimiento=value&claveTipoFamilia=value&claveOcupacion=value&claveAliado=value&incluyeMascotas=value&page=2\",   \"method\": \"GET\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"   },   \"body\": {} }",
                    "shortcut": ""
                }],
                "validate": {
                    "required": true
                },
                "key": "coberturasAdicionales",
                "type": "selectboxes",
                "input": true,
                "inputType": "checkbox",
                "value": [],
                "valueResponse": [{
                    "nombre": "PROTECCIÓN ADICIONAL POR FALLECIMIENTO",
                    "claveCobertura": "9202",
                    "obligatorio": false,
                    "dependencia": "9190",
                    "claveSumaAseguradaCapital": 60,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "USD": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "UDI": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": 20
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "OPCIONAL",
                    "asegurados": [],
                    "page": "2",
                    "img": "6fb25117-e9fd-4351-bb97-e3f61b16151b_proteccion-adicional-fallecimiento.png",
                    "descripcion": "En caso de que llegues a faltar, tus beneficiarios contarán con un bono adicional que podrán utilizar para fines como: gastos del hogar, etc."
                },
                {
                    "nombre": "PROTECCIÓN ADICIONAL POR INVALIDEZ",
                    "claveCobertura": "9203",
                    "obligatorio": false,
                    "dependencia": "9193",
                    "claveSumaAseguradaCapital": 61,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "USD": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "UDI": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": 20
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "OPCIONAL",
                    "asegurados": [],
                    "page": "2",
                    "img": "1d81a23f-a339-4a52-b092-9105eec4b628_proteccion-adicional-invalidez.png",
                    "descripcion": "En caso de sufrir algún accidente o enfermedad que te provoque una invalidez total y permanente, recibirás la suma asegurada contratada."
                }
                ]
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }
        ]
    },
    {
        "key_step": "step_cotizacion",
        "name": "Cotización",
        "questions": [{
            "primary": {
                "associated_group": "step_cotizacion",
                "title": [],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "50-50",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Nombre",
                "placeholder": "Ej. Diana",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Ingresa un nombre valido",
                    "minLength": 1,
                    "maxLength": 100
                },
                "key": "nombre",
                "type": "textfield",
                "input": true,
                "value": "dfgdfgf"
            },
            {
                "label": "INGRESA TU E-MAIL",
                "placeholder": "ejemplo@gmail.com",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                    "customMessage": "Ingrese un correo electrónico valido",
                    "minLength": 1,
                    "maxLength": 100
                },
                "key": "email",
                "type": "textfield",
                "input": true,
                "value": "dfgdfg@gmail.com"
            },
            {
                "label": "TELÉFONO CELULAR",
                "placeholder": "Ej. 555723799",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^(?!.*?([1234567890])\\1{9,}|(1234567890))[0-9]*$",
                    "customMessage": "Ingresa un número telefónico valido",
                    "minLength": 10,
                    "maxLength": 10
                },
                "key": "telefono",
                "type": "textfield",
                "input": true,
                "value": "6346546546"
            },
            {
                "label": "No soy un robot",
                "customClass": "recaptcha",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true
                },
                "key": "noSoyUnRobot",
                "properties": {
                    "sitekey": "6LdCNUMaAAAAAM3W7I7d9dsG9WXPb-0W0v7f9n9G"
                },
                "type": "checkbox",
                "input": true,
                "value": true
            },
            {
                "label": "Aceptar aviso de privacidad",
                "customClass": "readonly",
                "defaultValue": "Al continuar estas aceptando el <A HREF=\"https://invierteyahorra.suramexico.com/suramexico/aviso-de-privacidad-SUAM.html\" target=\"_blank\">aviso de privacidad</A>",
                "key": "avisoPrivacidad",
                "type": "hidden",
                "input": true,
                "tableView": false,
                "value": "Al continuar estas aceptando el <A HREF=\"https://invierteyahorra.suramexico.com/suramexico/aviso-de-privacidad-SUAM.html\" target=\"_blank\">aviso de privacidad</A>"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_cotizacion",
                "title": [{
                    "type": "heading6",
                    "text": "Planes",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "No",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Planes",
                "optionsLabelPosition": "right",
                "customClass": "selectboxesPlans",
                "tableView": false,
                "defaultValue": {
                    "api": false,
                    "apiService": false,
                    "{": false
                },
                "values": [{
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/cotizacion\",   \"method\": \"POST\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"   },   \"body\": {} }",
                    "shortcut": ""
                }],
                "validate": {
                    "required": true
                },
                "key": "planes",
                "type": "selectboxes",
                "input": true,
                "inputType": "checkbox",
                "value": [{
                    "paquete": "Mi Plan Vive",
                    "valor": 53.92,
                    "asistencias": "Asistencia básica (legal, médica, funeraria y repatriación)",
                    "tooltip": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada.",
                    "descripcion": "Tu seguro de vida personalizado con las Coberturas que elegiste.",
                    "coberturas": [{
                        "claveCobertura": "9190",
                        "sumaAsegurada": 35000,
                        "atrRecargoCobertura": 0,
                        "porcentajeExtraPrima": "0",
                        "claveSumaAseguradaCapital": 50
                    },
                    {
                        "claveCobertura": "9198",
                        "sumaAsegurada": 2500,
                        "atrRecargoCobertura": 0,
                        "porcentajeExtraPrima": "0",
                        "claveSumaAseguradaCapital": 58
                    },
                    {
                        "claveCobertura": "9206",
                        "sumaAsegurada": 0,
                        "atrRecargoCobertura": 0,
                        "porcentajeExtraPrima": "0",
                        "claveSumaAseguradaCapital": 64
                    }
                    ]
                }]
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }
        ]
    },
    {
        "key_step": "step_emision_asegurado",
        "name": "Emisión Asegurado",
        "questions": [{
            "primary": {
                "associated_group": "step_emision_asegurado",
                "title": [{
                    "type": "heading6",
                    "text": "Información del asegurado titular",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "60-40",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "RFC",
                "placeholder": "Ingresa el número de RFC",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[A-Z0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 13,
                    "maxLength": 13
                },
                "key": "identificadorPersona",
                "type": "textfield",
                "input": true,
                "value": "5465465465465"
            },
            {
                "label": "Validar RFC",
                "showValidations": false,
                "tableView": false,
                "key": "validarRfc",
                "logic": [{
                    "name": "api_service",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/personas?tipoIdentificadorPersona=1&identificadorPersona=value",
                            "method": "GET",
                            "headers": {
                                "Content-Type": "application/json",
                                "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                            },
                            "body": {},
                            "action": "autocomplete"
                        }
                    },
                    "actions": [],
                    "isRowSelected": true
                }],
                "type": "button",
                "input": true,
                "saveOnEnter": false
            },
            {
                "type": "fakeField"
            },
            {
                "label": "Nombre",
                "placeholder": "Ej. Juan",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "primerNombre",
                "type": "textfield",
                "input": true,
                "value": "dfg"
            },
            {
                "label": "Apellido paterno",
                "placeholder": "Ej. Pérez",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "primerApellido",
                "type": "textfield",
                "input": true,
                "value": "dfdf"
            },
            {
                "label": "Apellido materno",
                "placeholder": "Ej. Rodríguez",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "segundoApellido",
                "type": "textfield",
                "input": true,
                "value": "dfgfd"
            },
            {
                "label": "CURP",
                "placeholder": "Digita Clave Única de Registro de Población",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-Z0-9]+$",
                    "customMessage": "Tu CURP debe tener longitud de 18 caracteres",
                    "minLength": 18,
                    "maxLength": 18
                },
                "key": "curp",
                "type": "textfield",
                "input": true,
                "value": "546546546546546546"
            },
            {
                "label": "Género",
                "widget": "choicesjs",
                "placeholder": "Elige género",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Femenino",
                        "value": "M"
                    },
                    {
                        "label": "Masculino",
                        "value": "H"
                    }
                    ]
                },
                "validate": {
                    "required": true
                },
                "key": "sexo",
                "type": "select",
                "input": true,
                "value": "M"
            },
            {
                "label": "Fecha de nacimiento",
                "format": "DD/MM/YYYY",
                "tableView": false,
                "enableMinDateInput": false,
                "datePicker": {
                    "minDate": "1870-01-01T11:59:00-04:56",
                    "maxDate": "2021-01-01T12:00:00-05:00",
                    "disableWeekends": false,
                    "disableWeekdays": false
                },
                "enableMaxDateInput": false,
                "customDefaultValue": "fechaNacimiento",
                "validate": {
                    "required": true
                },
                "key": "fechaDeNacimientoAsegurado",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "datetime",
                "input": true,
                "widget": {
                    "type": "calendar",
                    "displayInTimezone": "viewer",
                    "locale": "en",
                    "useLocaleSettings": false,
                    "allowInput": true,
                    "mode": "single",
                    "enableTime": true,
                    "noCalendar": false,
                    "format": "DD/MM/YYYY",
                    "hourIncrement": 1,
                    "minuteIncrement": 1,
                    "time_24hr": false,
                    "minDate": "1870-01-01T11:59:00-04:56",
                    "disableWeekends": false,
                    "disableWeekdays": false,
                    "maxDate": "2021-01-01T12:00:00-05:00"
                },
                "value": "1990-01-01"
            },
            {
                "label": "Estado Civil",
                "widget": "choicesjs",
                "placeholder": "Elige estado civil",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Soltero/a.",
                        "value": "S"
                    },
                    {
                        "label": "Casado/a.",
                        "value": "C"
                    }
                    ]
                },
                "validate": {
                    "required": true
                },
                "key": "estadoCivil",
                "type": "select",
                "input": true,
                "value": "C"
            },
            {
                "label": "País de Nacimiento",
                "widget": "choicesjs",
                "placeholder": "Elige país de nacimiento",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/paises",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "pais",
                "type": "select",
                "input": true,
                "valuesResponse": [
                    {
                        "clave": "002",
                        "descripcion": "AFGANISTAN"
                    }
                ],
                "value": "002"
            },
            {
                "label": "Lugar de Nacimiento",
                "placeholder": "Lugar de Nacimiento",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 40
                },
                "key": "lugarNacimiento",
                "type": "textfield",
                "input": true,
                "value": "dfgfd"
            },
            {
                "label": "Nacionalidad",
                "widget": "choicesjs",
                "placeholder": "Elige tu nacionalidad",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/nacionalidades",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "nacionalidad",
                "type": "select",
                "input": true,
                "valuesResponse": [
                    {
                        "clave": "002",
                        "descripcion": "AFGANO"
                    }
                ],
                "value": "002"
            },
            {
                "label": "Ocupación o profesión",
                "widget": "choicesjs",
                "placeholder": "Elige ocupación o profesión",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/catalogos/ocupaciones",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "claveOcupacion",
                "key": "ocupacionProfesion",
                "type": "select",
                "input": true,
                "value": "A001",
                "valuesResponse": [
                    {
                        "clave": "A001",
                        "descripcion": "ABOGADO"
                    }
                ]
            },
            {
                "label": "Ingresos mensuales",
                "placeholder": "Ej. 113434",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 7
                },
                "key": "ingresosMensuales",
                "type": "textfield",
                "input": true,
                "value": "6546546"
            },
            {
                "label": "INGRESA TU E-MAIL",
                "placeholder": "ejemplo@gmail.com",
                "tableView": true,
                "customDefaultValue": "email",
                "validate": {
                    "required": true,
                    "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                    "customMessage": "Ingrese un correo electrónico valido",
                    "minLength": 1,
                    "maxLength": 100
                },
                "key": "email1",
                "type": "textfield",
                "input": true,
                "value": "dfgdfg@gmail.com"
            },
            {
                "label": "TELÉFONO CELULAR",
                "placeholder": "Ej. 55 5723 799",
                "tableView": true,
                "customDefaultValue": "telefono",
                "validate": {
                    "required": true,
                    "pattern": "^(?!.*?([1234567890])\\1{9,}|(1234567890))[0-9]*$",
                    "customMessage": "Ingresa un número telefónico valido",
                    "minLength": 10,
                    "maxLength": 10
                },
                "key": "telefonoCelular",
                "type": "textfield",
                "input": true,
                "value": "6346546546"
            },
            {
                "label": "Tipo de identificación entregada",
                "widget": "choicesjs",
                "placeholder": "Elige tipo de identificación entregada",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Credencial para votar vigente",
                        "value": "credencialParaVotarVigente"
                    },
                    {
                        "label": "Pasaporte vigente",
                        "value": "pasaporteVigente"
                    }
                    ]
                },
                "validate": {
                    "required": true
                },
                "key": "tipoDeIdentificacionEntregada",
                "type": "select",
                "input": true,
                "value": "credencialParaVotarVigente"
            },
            {
                "label": "Folio de identificación entregada",
                "placeholder": "Ej. 788120155J",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 30
                },
                "key": "folioDeIdentificacionEntregada",
                "type": "textfield",
                "input": true,
                "value": "65465465465465"
            },
            {
                "label": "¿Residente fiscal en el extranjero?",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "customMessage": "Error"
                },
                "key": "residenteFiscalExtranjero",
                "conditional": {
                    "show": false,
                    "when": "pais",
                    "eq": "052"
                },
                "type": "checkbox",
                "input": true,
                "value": true
            },
            {
                "label": "País donde es residente fiscal",
                "widget": "choicesjs",
                "placeholder": "Elige país donde es residente fiscal",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/paises",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "paisResidenteFiscal",
                "conditional": {
                    "show": true,
                    "when": "residenteFiscalExtranjero",
                    "eq": "true"
                },
                "type": "select",
                "input": true,
                "valuesResponse": [
                    {
                        "clave": "004",
                        "descripcion": "AFGANISTAN"
                    }
                ],
                "value": "004"
            },
            {
                "label": "N° Identificación en el extranjero",
                "placeholder": "Ej. 1034388456",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 30
                },
                "key": "nIdentificacionEnElExtranjero",
                "conditional": {
                    "show": true,
                    "when": "residenteFiscalExtranjero",
                    "eq": "true"
                },
                "type": "textfield",
                "input": true,
                "value": "465465465465465465"
            },
            {
                "label": "Dirección",
                "placeholder": "Digita la dirección",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 50
                },
                "key": "direccion",
                "type": "textfield",
                "input": true,
                "value": "dfgf"
            },
            {
                "label": "No. Exterior",
                "placeholder": "Ej. 2214",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^(0|[1-9][0-9]*)$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 6
                },
                "key": "nExterior",
                "type": "textfield",
                "input": true,
                "value": "534654"
            },
            {
                "label": "No. interior",
                "placeholder": "Ej. 0121",
                "tableView": true,
                "validate": {
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 6
                },
                "key": "nIterior",
                "type": "textfield",
                "input": true
            },
            {
                "label": "Código postal",
                "placeholder": "Ej. 43540",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 5,
                    "maxLength": 5
                },
                "key": "codigoPostal",
                "type": "textfield",
                "input": true,
                "value": "97100"
            },
            {
                "label": "Estado",
                "widget": "choicesjs",
                "placeholder": "Elige el estado",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostal=value&catalogo=ESTADO",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true
                },
                "key": "estadoAsegurado",
                "type": "select",
                "input": true,
                "valuesResponse": [{
                    "clave": "31",
                    "descripcion": "YUCATAN"
                }],
                "value": "31"
            },
            {
                "label": "Colonia",
                "widget": "choicesjs",
                "placeholder": "Elige la colonia",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostal=value&catalogo=COLONIA",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "coloniaAsegurado",
                "type": "select",
                "input": true,
                "valuesResponse": [{
                    "clave": "003RB",
                    "descripcion": "ITZIMNA PRIVADA PEREZ"
                },
                {
                    "clave": "003RC",
                    "descripcion": "ITZIMNA PRIVADA PEREZ PF"
                },
                {
                    "clave": "31094",
                    "descripcion": "RINCONADA ITZMINA"
                },
                {
                    "clave": "31A28",
                    "descripcion": "ITZIMNA"
                },
                {
                    "clave": "31A29",
                    "descripcion": "ITZIMNA 2"
                }
                ],
                "value": "31094"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_emision_asegurado",
                "title": [{
                    "type": "heading6",
                    "text": "Identificación y conocimiento del cliente",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Cuénta con otro seguro de vida contratado de forma voluntaria?",
                "optionsLabelPosition": "right",
                "customClass": "radioText",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "Si",
                    "value": "si",
                    "shortcut": ""
                },
                {
                    "label": "No",
                    "value": "no",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "cuentaConOtroSeguroDeVidaContratadoDeFormaVoluntaria",
                "type": "radio",
                "input": true,
                "value": "no"
            },
            {
                "label": "Le han rechazado, limitado o extra-primado alguna solicitud?",
                "optionsLabelPosition": "right",
                "customClass": "radioText",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "Si",
                    "value": "si",
                    "shortcut": ""
                },
                {
                    "label": "No",
                    "value": "no",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "leHanRechazadoLimitadoOExtraPrimadoAlgunaSolicitud",
                "type": "radio",
                "input": true,
                "value": "no"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }
        ]
    },
    {
        "key_step": "step_asegurados",
        "name": "Asegurados",
        "questions": [{
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de los asegurados adicionales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "heading3",
                    "text": "Cobertura de gastos funerarios",
                    "spans": [{
                        "start": 0,
                        "end": 30,
                        "type": "strong"
                    }]
                },
                {
                    "type": "paragraph",
                    "text": "La designación de beneficiarios para esta cobertura es recíproca, es decir, en caso de fallecimiento del cónyuge, se entrega el 100% de la suma asegurada al titular.",
                    "spans": []
                }
                ],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "title": "Asegurados",
                "breadcrumbClickable": true,
                "buttonSettings": {
                    "previous": true,
                    "cancel": true,
                    "next": true
                },
                "scrollToTop": false,
                "customClass": "repeatableContent",
                "collapsible": false,
                "key": "asegurados",
                "properties": {
                    "nameRelatedProperty": "coberturas",
                    "valueRelatedKey": "9198"
                },
                "type": "panel",
                "label": "Asegurados",
                "input": false,
                "tableView": false,
                "components": [{
                    "label": "Nombre",
                    "placeholder": "Ej. Juan",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un nombre valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "nombreAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Apellido paterno",
                    "placeholder": "Ej. Rodríguez",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un apellido valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "apellidoPaternoAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Apellido materno",
                    "placeholder": "Ej. Pérez",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un apellido valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "apellidoMaternoAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Fecha de nacimiento",
                    "format": "DD/MM/YYYY",
                    "tableView": false,
                    "enableMinDateInput": false,
                    "datePicker": {
                        "minDate": "1870-01-01T11:59:00-04:56",
                        "disableWeekends": false,
                        "disableWeekdays": false
                    },
                    "enableMaxDateInput": false,
                    "validate": {
                        "required": true,
                        "customMessage": "Ingresa una fecha válida"
                    },
                    "key": "fechaNacimientoAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "datetime",
                    "input": true,
                    "widget": {
                        "type": "calendar",
                        "displayInTimezone": "viewer",
                        "locale": "en",
                        "useLocaleSettings": false,
                        "allowInput": true,
                        "mode": "single",
                        "enableTime": true,
                        "noCalendar": false,
                        "format": "DD/MM/YYYY",
                        "hourIncrement": 1,
                        "minuteIncrement": 1,
                        "time_24hr": false,
                        "minDate": "1870-01-01T11:59:00-04:56",
                        "disableWeekends": false,
                        "disableWeekdays": false,
                        "maxDate": null
                    }
                },
                {
                    "label": "Parentesco",
                    "widget": "choicesjs",
                    "placeholder": "Elige el parentesco",
                    "tableView": true,
                    "data": {
                        "values": [{
                            "label": "CÓNYUGE",
                            "value": "C"
                        },
                        {
                            "label": "HIJO(A)",
                            "value": "H"
                        }
                        ]
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "parentescoAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Género",
                    "widget": "choicesjs",
                    "placeholder": "Elige el género",
                    "tableView": true,
                    "data": {
                        "values": [{
                            "label": "Femenino",
                            "value": "M"
                        },
                        {
                            "label": "Masculino",
                            "value": "H"
                        }
                        ]
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "generoAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Acciones",
                    "key": "acciones-asegurados",
                    "type": "hidden",
                    "input": true,
                    "tableView": false
                }
                ]
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de los asegurados adicionales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "heading3",
                    "text": "Asegurados adicionales para mascotas",
                    "spans": [{
                        "start": 0,
                        "end": 36,
                        "type": "strong"
                    }]
                },
                {
                    "type": "paragraph",
                    "text": "La designación de beneficiarios para esta cobertura es recíproca, es decir, en caso de fallecimiento del cónyuge, se entrega el 100% de la suma asegurada al titular.",
                    "spans": []
                }
                ],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "title": "Mascotas",
                "breadcrumbClickable": true,
                "buttonSettings": {
                    "previous": true,
                    "cancel": true,
                    "next": true
                },
                "scrollToTop": false,
                "customClass": "repeatableContent",
                "collapsible": false,
                "key": "mascotas",
                "properties": {
                    "nameRelatedProperty": "coberturas",
                    "valueRelatedKey": "9204"
                },
                "type": "panel",
                "label": "Mascotas",
                "input": false,
                "tableView": false,
                "components": [{
                    "label": "Tipo de mascota",
                    "widget": "choicesjs",
                    "placeholder": "Elige tipo de mascota",
                    "tableView": true,
                    "data": {
                        "values": [{
                            "label": "Perro",
                            "value": "P"
                        },
                        {
                            "label": "Gato",
                            "value": "G"
                        }
                        ]
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "tipoDeMascota",
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Nombre",
                    "placeholder": "Ej. Rocky",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un nombre valido",
                        "minLength": 1,
                        "maxLength": 20
                    },
                    "key": "nombreMascota",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Raza",
                    "placeholder": "Digita raza de tu mascota",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingrese una raza valida",
                        "minLength": 1,
                        "maxLength": 20
                    },
                    "key": "raza",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Edad",
                    "placeholder": "Digita edad de tu mascota",
                    "tooltip": "No se puede registrar una mascota de más de 15 años",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^([1-9]|[0-1][0-5])$",
                        "customMessage": "Dato no válido",
                        "minLength": 1,
                        "maxLength": 2
                    },
                    "key": "edad",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Genero",
                    "widget": "choicesjs",
                    "placeholder": "Elige el género de tu mascota",
                    "tableView": true,
                    "data": {
                        "values": [{
                            "label": "Hembra",
                            "value": "M"
                        },
                        {
                            "label": "Macho",
                            "value": "H"
                        }
                        ]
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "generoMascota",
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Acciones",
                    "key": "acciones-mascotas",
                    "type": "hidden",
                    "input": true,
                    "tableView": false
                }
                ]
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de el o los beneficiarios",
                    "spans": []
                }],
                "collapse_description": true,
                "description": [{
                    "type": "paragraph",
                    "text": "Si estás considerando renombrar a un menor de edad como beneficiario es importante que consideres la siguiente información.",
                    "spans": []
                }],
                "collapsable_text": [{
                    "type": "paragraph",
                    "text": "Al nombrar beneficiarios menores de edad no se debe señalar a un mayor de edad como representante del menor, para que en su representación cobre la indemnización; ya que la legislación señala la forma en que deben designarse tutores, albaceas u otros cargos similares y no consideran al contrato de seguro como el instrumento adecuando para tal designación. Si designas a un mayor de edad como representante del menor beneficiario durante su minoría de edad, legalmente puede implicar que se nombra como beneficiario al mayor de edad, quien solo tendrá una obligación moral, pues la designación que se hace de beneficiarios en un contrato de seguro le concede el derecho incondicionado de disponer de la suma asegurada.",
                    "spans": []
                }],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "title": "Beneficiarios",
                "breadcrumbClickable": true,
                "buttonSettings": {
                    "previous": true,
                    "cancel": true,
                    "next": true
                },
                "scrollToTop": false,
                "customClass": "repeatableContent",
                "collapsible": false,
                "key": "beneficiarios",
                "type": "panel",
                "label": "Panel",
                "input": false,
                "tableView": false,
                "components": [{
                    "label": "Nombre",
                    "placeholder": "Ej. Juan",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un nombre valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "nombreBeneficiario",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Apellido paterno",
                    "placeholder": "Ej. Rodríguez",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un apellido valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "apellidoPaternoBeneficiario",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Apellido materno",
                    "placeholder": "Ej. Martínez",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un apellido valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "apellidoMaternoBeneficiario",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Fecha de nacimiento",
                    "format": "DD/MM/YYYY",
                    "tableView": false,
                    "enableMinDateInput": false,
                    "datePicker": {
                        "minDate": "1870-01-01T11:59:00-04:56",
                        "disableWeekends": false,
                        "disableWeekdays": false
                    },
                    "enableMaxDateInput": false,
                    "validate": {
                        "required": true,
                        "customMessage": "Ingresa una fecha válida"
                    },
                    "key": "fechaNacimientoBeneficiario",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "datetime",
                    "input": true,
                    "widget": {
                        "type": "calendar",
                        "displayInTimezone": "viewer",
                        "locale": "en",
                        "useLocaleSettings": false,
                        "allowInput": true,
                        "mode": "single",
                        "enableTime": true,
                        "noCalendar": false,
                        "format": "DD/MM/YYYY",
                        "hourIncrement": 1,
                        "minuteIncrement": 1,
                        "time_24hr": false,
                        "minDate": "1870-01-01T11:59:00-04:56",
                        "disableWeekends": false,
                        "disableWeekdays": false,
                        "maxDate": null
                    }
                },
                {
                    "label": "Parentesco",
                    "widget": "choicesjs",
                    "placeholder": "Elige parentesco",
                    "tableView": true,
                    "dataSrc": "json",
                    "data": {
                        "json": {
                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/parentescos",
                            "method": "GET",
                            "headers": {
                                "Content-Type": "application/json",
                                "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                            },
                            "body": {}
                        }
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "parentescoBeneficiario",
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Genero",
                    "widget": "choicesjs",
                    "placeholder": "Elige género",
                    "tableView": true,
                    "data": {
                        "values": [{
                            "label": "Femenino ",
                            "value": "M"
                        },
                        {
                            "label": "Masculino",
                            "value": "H"
                        }
                        ]
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "generoBeneficiario",
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Porcentaje",
                    "placeholder": "Ej. 100",
                    "tooltip": "Debes ingresar un valor entre 1 y 100, recuerda distribuir el 100% correctamente en todos tus beneficiarios.",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[0-9]*$",
                        "customMessage": "Dato no válido",
                        "minLength": 1,
                        "maxLength": 3
                    },
                    "key": "porcentajeBeneficiario",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Acciones",
                    "key": "acciones-beneficiarios",
                    "type": "hidden",
                    "input": true,
                    "tableView": false
                }
                ]
            },
            {
                "label": "Mensaje modal - Error en porcentaje acumulado",
                "defaultValue": "Recuerda que el porcentaje acumulado debe sumar el 100%",
                "key": "mensajeErrorPorcentaje",
                "type": "hidden",
                "input": true,
                "tableView": false
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }
        ]
    },
    {
        "key_step": "step_emision_contratante",
        "name": "Emisión Contratante",
        "questions": [{
            "primary": {
                "associated_group": "step_emision_contratante",
                "title": [{
                    "type": "heading6",
                    "text": "Datos del contratante",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "50-50",
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/find-form-medical\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Los datos del contratante son los mismos que los del asegurado",
                "customClass": "checkClassic",
                "tableView": false,
                "defaultValue": true,
                "key": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
                "properties": {
                    "autocomplete": "true"
                },
                "type": "checkbox",
                "input": true
            },
            {
                "label": "TIPO DE PERSONA",
                "optionsLabelPosition": "right",
                "customClass": "radioText",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "PERSONA FÍSICA",
                    "value": "personaFisica",
                    "shortcut": ""
                },
                {
                    "label": "PERSONA MORAL",
                    "value": "personaMoral",
                    "shortcut": ""
                }
                ],
                "customDefaultValue": "tipoDePersona",
                "validate": {
                    "required": true
                },
                "key": "tipoDePersonaContratante",
                "conditional": {
                    "show": true,
                    "when": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
                    "eq": "false"
                },
                "type": "radio",
                "input": true,
                "defaultValue": "personaFisica"
            },
            {
                "label": "RFC",
                "placeholder": "Digita el RFC",
                "tableView": true,
                "customDefaultValue": "identificadorPersona",
                "validate": {
                    "required": true,
                    "pattern": "^[A-Z0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 13,
                    "maxLength": 13
                },
                "key": "identificadorPersonaContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "RFC",
                "placeholder": "Digita el RFC",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[A-Z0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 12,
                    "maxLength": 12
                },
                "key": "identificadorPersonaContratanteMoral",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaMoral"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Validar RFC",
                "showValidations": false,
                "tableView": false,
                "key": "validarRfcContratante",
                "conditional": {
                    "show": true,
                    "when": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
                    "eq": "false"
                },
                "logic": [{
                    "name": "api_service",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/personas?tipoIdentificadorPersona=1&identificadorPersonaContratante=value",
                            "method": "GET",
                            "headers": {
                                "Content-Type": "application/json",
                                "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                            },
                            "body": {},
                            "action": "autocomplete",
                            "key": "Contratante"
                        }
                    },
                    "actions": [],
                    "isRowSelected": true
                }],
                "type": "button",
                "input": true,
                "saveOnEnter": false
            },
            {
                "type": "fakeField"
            },
            {
                "label": "Nombre",
                "placeholder": "Ej. Juan",
                "tableView": true,
                "customDefaultValue": "nombre",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "primerNombreContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Apellido paterno",
                "placeholder": "Ej. Rodriguez",
                "tableView": true,
                "customDefaultValue": "primerApellido",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "primerApellidoContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Apellido materno",
                "placeholder": "Ej. Martínez",
                "tableView": true,
                "customDefaultValue": "segundoApellido",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "segundoApellidoContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "CURP",
                "placeholder": "Digita el CURP",
                "tableView": true,
                "customDefaultValue": "curp",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-Z0-9]+$",
                    "customMessage": "Tu CURP debe tener longitud de 18 caracteres",
                    "minLength": 18,
                    "maxLength": 18
                },
                "key": "curpContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Género",
                "widget": "choicesjs",
                "placeholder": "Elige el género",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Femenino",
                        "value": "M"
                    },
                    {
                        "label": "Masculino",
                        "value": "H"
                    }
                    ]
                },
                "customDefaultValue": "genero",
                "validate": {
                    "required": true
                },
                "key": "sexoContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "select",
                "input": true
            },
            {
                "label": "Fecha de nacimiento",
                "format": "DD/MM/YYYY",
                "tableView": false,
                "enableMinDateInput": false,
                "datePicker": {
                    "minDate": "1870-01-01T11:59:00-04:56",
                    "maxDate": "2021-01-01T12:00:00-05:00",
                    "disableWeekends": false,
                    "disableWeekdays": false
                },
                "enableMaxDateInput": false,
                "customDefaultValue": "fechaNacimiento",
                "validate": {
                    "required": true
                },
                "key": "fechaNacimientoContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "datetime",
                "input": true,
                "widget": {
                    "type": "calendar",
                    "displayInTimezone": "viewer",
                    "locale": "en",
                    "useLocaleSettings": false,
                    "allowInput": true,
                    "mode": "single",
                    "enableTime": true,
                    "noCalendar": false,
                    "format": "DD/MM/YYYY",
                    "hourIncrement": 1,
                    "minuteIncrement": 1,
                    "time_24hr": false,
                    "minDate": "1870-01-01T11:59:00-04:56",
                    "disableWeekends": false,
                    "disableWeekdays": false,
                    "maxDate": "2021-01-01T12:00:00-05:00"
                }
            },
            {
                "label": "Estado Civil",
                "widget": "choicesjs",
                "placeholder": "Elige estado civil",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Soltero/a.",
                        "value": "S"
                    },
                    {
                        "label": "Casado/a.",
                        "value": "C"
                    }
                    ]
                },
                "customDefaultValue": "estadoCivil",
                "validate": {
                    "required": true
                },
                "key": "estadoCivilContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "select",
                "input": true
            },
            {
                "label": "País de Nacimiento",
                "widget": "choicesjs",
                "placeholder": "Elige tu país de nacimiento",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/paises",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "pais",
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "paisNacimientoContratante",
                "type": "select",
                "input": true
            },
            {
                "label": "Lugar de Nacimiento",
                "placeholder": "Lugar de Nacimiento",
                "tableView": true,
                "customDefaultValue": "lugarNacimiento",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 40
                },
                "key": "lugarNacimientoContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Nacionalidad",
                "widget": "choicesjs",
                "placeholder": "Elige tu nacionalidad",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/nacionalidades",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "pais",
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "nacionalidadContratante",
                "type": "select",
                "input": true
            },
            {
                "label": "Ocupación o profesión",
                "widget": "choicesjs",
                "placeholder": "Elige ocupación",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/catalogos/ocupaciones",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "claveOcupacion",
                "validate": {
                    "required": true
                },
                "key": "ocupacionProfesionContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "select",
                "input": true
            },
            {
                "label": "Ingresos mensuales",
                "placeholder": "Ej. 8599",
                "tableView": true,
                "customDefaultValue": "ingresosMensuales",
                "validate": {
                    "required": true,
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 7
                },
                "key": "ingresosMensualesContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "INGRESA TU E-MAIL",
                "placeholder": "ejemplo@gmail.com",
                "tableView": true,
                "customDefaultValue": "email",
                "validate": {
                    "required": true,
                    "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                    "customMessage": "Ingrese un correo electrónico valido",
                    "minLength": 1,
                    "maxLength": 100
                },
                "key": "emailContratante",
                "type": "textfield",
                "input": true
            },
            {
                "label": "TELÉFONO CELULAR",
                "placeholder": "Ej. 55 5723 799",
                "tableView": true,
                "customDefaultValue": "telefono",
                "validate": {
                    "required": true,
                    "pattern": "^(?!.*?([1234567890])\\1{9,}|(1234567890))[0-9]*$",
                    "customMessage": "Ingresa un número telefónico valido",
                    "minLength": 10,
                    "maxLength": 10
                },
                "key": "telefonoCelularContratante",
                "type": "textfield",
                "input": true
            },
            {
                "label": "Nombre del apoderado legal ",
                "placeholder": "Ej. Juan Martínez Gil",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "maxLength": 60
                },
                "key": "nombreDelApoderadoLegalContratante",
                "conditional": {
                    "show": true,
                    "when": "anadirApoderadoLegalContratante",
                    "eq": "true"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Fecha de nacimiento del apoderado",
                "format": "DD/MM/YYYY",
                "tableView": false,
                "enableMinDateInput": false,
                "datePicker": {
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "maxDate": "2021-01-01T12:00:00-05:00",
                    "disableWeekends": false,
                    "disableWeekdays": false
                },
                "enableMaxDateInput": false,
                "validate": {
                    "required": true,
                    "customMessage": "INGRESA UNA FECHA VÁLIDA"
                },
                "key": "fechaDeNacimientoDelApoderadoContratante",
                "conditional": {
                    "show": true,
                    "when": "anadirApoderadoLegalContratante",
                    "eq": "true"
                },
                "type": "datetime",
                "input": true,
                "widget": {
                    "type": "calendar",
                    "displayInTimezone": "viewer",
                    "locale": "en",
                    "useLocaleSettings": false,
                    "allowInput": true,
                    "mode": "single",
                    "enableTime": true,
                    "noCalendar": false,
                    "format": "DD/MM/YYYY",
                    "hourIncrement": 1,
                    "minuteIncrement": 1,
                    "time_24hr": false,
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "disableWeekends": false,
                    "disableWeekdays": false,
                    "maxDate": "2021-01-01T12:00:00-05:00"
                }
            },
            {
                "label": "Añadir apoderado legal",
                "customClass": "checkClassic",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true
                },
                "key": "anadirApoderadoLegalContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaMoral"
                },
                "type": "checkbox",
                "input": true
            },
            {
                "label": "Tipo de identificación entregada",
                "widget": "choicesjs",
                "placeholder": "Elige tipo de identificación",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Credencial para votar vigente",
                        "value": "credencialParaVotarVigente"
                    },
                    {
                        "label": "Pasaporte vigente",
                        "value": "pasaporteVigente"
                    }
                    ]
                },
                "customDefaultValue": "tipoDeIdentificacionEntregada",
                "validate": {
                    "required": true
                },
                "key": "tipoDeIdentificacionEntregadaContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "select",
                "input": true
            },
            {
                "label": "Folio de identificación entregada",
                "placeholder": "Digita folio de identificación",
                "tableView": true,
                "customDefaultValue": "folioDeIdentificacionEntregada",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 30
                },
                "key": "folioDeIdentificacionEntregadaContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "¿Residente fiscal en el extranjero?",
                "tableView": false,
                "defaultValue": false,
                "customDefaultValue": "residenteFiscalExtranjero",
                "validate": {
                    "required": true,
                    "customMessage": "Error"
                },
                "key": "residenteFiscalExtranjeroContratante",
                "conditional": {
                    "show": false,
                    "when": "paisNacimientoContratante",
                    "eq": "052"
                },
                "type": "checkbox",
                "input": true
            },
            {
                "label": "País donde es residente fiscal",
                "widget": "choicesjs",
                "placeholder": "Elija el país",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/paises",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "paisResidenteFiscal",
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "paisResidenteFiscalContratante",
                "conditional": {
                    "show": true,
                    "when": "residenteFiscalExtranjeroContratante",
                    "eq": "true"
                },
                "type": "select",
                "input": true
            },
            {
                "label": "N° Identificación en el extranjero",
                "placeholder": "Ej SS1035439311",
                "tableView": true,
                "customDefaultValue": "nIdentificacionEnElExtranjero",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 30
                },
                "key": "nIdentificacionEnElExtranjeroContratante",
                "conditional": {
                    "show": true,
                    "when": "residenteFiscalExtranjeroContratante",
                    "eq": "true"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Dirección",
                "tableView": true,
                "customDefaultValue": "direccion",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 50
                },
                "key": "direccionContratante",
                "type": "textfield",
                "input": true,
                "placeholder": "Ej. Av Benito J No 90"
            },
            {
                "label": "No. Exterior",
                "placeholder": "Ej. 451",
                "tableView": true,
                "customDefaultValue": "nExterior",
                "validate": {
                    "required": true,
                    "pattern": "^(0|[1-9][0-9]*)$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 6
                },
                "key": "nExteriorContratante",
                "type": "textfield",
                "input": true
            },
            {
                "label": "No. interior",
                "placeholder": "Ej. 102",
                "tableView": true,
                "customDefaultValue": "nIterior",
                "validate": {
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 6
                },
                "key": "nIteriorContratante",
                "type": "textfield",
                "input": true
            },
            {
                "label": "Código postal",
                "placeholder": "Ej. 43540",
                "tableView": true,
                "customDefaultValue": "codigoPostal",
                "validate": {
                    "required": true,
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 5,
                    "maxLength": 5
                },
                "key": "codigoPostalContratante",
                "type": "textfield",
                "input": true
            },
            {
                "label": "Estado",
                "widget": "choicesjs",
                "placeholder": "Elige el estado",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostalContratante=value&catalogo=ESTADO",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "estadoAsegurado",
                "validate": {
                    "required": true
                },
                "key": "estadoContratante",
                "type": "select",
                "input": true
            },
            {
                "label": "Colonia",
                "widget": "choicesjs",
                "placeholder": "Elige la colonia",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostalContratante=value&catalogo=COLONIA",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "coloniaAsegurado",
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "coloniaContratante",
                "type": "select",
                "input": true
            },
            {
                "label": "Razón social",
                "placeholder": "Digita razón social",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "maxLength": 60
                },
                "key": "razonSocialContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaMoral"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Fecha de constitución",
                "format": "DD/MM/YYYY",
                "tableView": false,
                "enableMinDateInput": false,
                "datePicker": {
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "maxDate": "2021-01-01T12:00:00-05:00",
                    "disableWeekends": false,
                    "disableWeekdays": false
                },
                "enableMaxDateInput": false,
                "validate": {
                    "customMessage": "INGRESA UNA FECHA VÁLIDA"
                },
                "key": "fechaDeConstitucionContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaMoral"
                },
                "type": "datetime",
                "input": true,
                "widget": {
                    "type": "calendar",
                    "displayInTimezone": "viewer",
                    "locale": "en",
                    "useLocaleSettings": false,
                    "allowInput": true,
                    "mode": "single",
                    "enableTime": true,
                    "noCalendar": false,
                    "format": "DD/MM/YYYY",
                    "hourIncrement": 1,
                    "minuteIncrement": 1,
                    "time_24hr": false,
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "disableWeekends": false,
                    "disableWeekdays": false,
                    "maxDate": "2021-01-01T12:00:00-05:00"
                }
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }]
    },
    {
        "key_step": "step_cuestionario_medico",
        "name": "Cuestionario Médico",
        "questions": [{
            "primary": {
                "associated_group": "step_cuestionario_medico",
                "title": [{
                    "type": "heading6",
                    "text": "Cuestionario Médico",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "paragraph",
                    "text": "Para continuar con la contratación del seguro de vida Plan Vive, es necesario completar un breve cuestionario de salud. Ten a mano tu identificación oficial.",
                    "spans": []
                }],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Estado",
                "hidden": true,
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "(Elegible)",
                    "customMessage": "Debes completar el cuestionario para continuar"
                },
                "key": "estadoCuestionario",
                "type": "textfield",
                "input": true
            },
            {
                "type": "fakeField"
            },
            {
                "type": "fakeField"
            },
            {
                "label": "Completar Cuestionario",
                "action": "event",
                "showValidations": false,
                "tableView": false,
                "key": "completarCuestionario",
                "logic": [{
                    "name": "logic",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "field": "urlCuestionariosMedicos",
                            "action": "redirect"
                        }
                    },
                    "actions": []
                }],
                "type": "button",
                "input": true
            },
            {
                "label": "Copiar enlace",
                "action": "event",
                "showValidations": false,
                "tableView": false,
                "key": "copiarEnlace",
                "type": "button",
                "input": true,
                "logic": [{
                    "name": "logic",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "field": "urlCuestionariosMedicos",
                            "action": "copy"
                        }
                    },
                    "actions": []
                }]
            },
            {
                "label": "Enviar enlace",
                "action": "event",
                "showValidations": false,
                "tableView": false,
                "key": "enviarEnlace",
                "logic": [{
                    "name": "api_service",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "url": "https://apimanagement-devqa.azure-api.net/utilerias-qa/send/mail",
                            "method": "POST",
                            "headers": {
                                "Content-Type": "application/json",
                                "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589",
                                "apiKeySendGrid": "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"
                            },
                            "body": {
                                "to": "",
                                "from": "noe.santiago@segurossura.com.mx",
                                "templateId": "d-d703cc789cbf47d098faeace09bc14f3",
                                "dynamicTemplateData": {
                                    "NOMBRE_COMPLETO": "Juanito Banana",
                                    "URL": "http://google.com"
                                }
                            },
                            "action": "send",
                            "field": "urlCuestionariosMedicos"
                        }
                    },
                    "actions": []
                }],
                "type": "button",
                "input": true
            },
            {
                "label": "Actualizar",
                "showValidations": false,
                "tableView": false,
                "key": "actualizar",
                "logic": [{
                    "name": "api_service",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "url": "https://apimanagement-devqa.azure-api.net/cuestionariosmedicos-qa/status",
                            "method": "POST",
                            "headers": {
                                "Content-Type": "application/json",
                                "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                            },
                            "body": {},
                            "action": "update",
                            "fieldBody": "urlCuestionariosMedicos",
                            "fieldUpdate": "estadoCuestionario"
                        }
                    },
                    "actions": [],
                    "isRowSelected": true
                }],
                "type": "button",
                "input": true,
                "saveOnEnter": false
            },
            {
                "label": "Mensaje modal - Elegible con extraprima",
                "defaultValue": "Con base en la información ingresada y el momento de vida en el que te encuentras, el costo del seguro se ha actualizado.",
                "key": "mensajeModalElegibleConExtraprima",
                "type": "hidden",
                "input": true,
                "tableView": false
            },
            {
                "label": "Mensaje modal - No Elegible",
                "defaultValue": "Con base en la información ingresada lamentamos informarle que no contamos con un seguro de vida que se adecue a tu perfil ",
                "key": "mensajeModalNoElegible",
                "type": "hidden",
                "input": true,
                "tableView": false
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }]
    },
    {
        "key_step": "step_pasarela_pago",
        "name": "Periodicidad de pago",
        "questions": [{
            "primary": {
                "associated_group": "step_pasarela_pago",
                "title": [{
                    "type": "heading6",
                    "text": "Periodicidad de pago",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/emit-insurance\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n   },\n  \"body\": {}\n}",
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/check-payment-status?referencia={referencia}\",\n  \"method\": \"GET\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n   },\n  \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Periodicidad",
                "optionsLabelPosition": "right",
                "customClass": "selectboxesPeriodicity",
                "inline": false,
                "tableView": false,
                "defaultValue": 12,
                "values": [{
                    "label": "Anual",
                    "value": "12",
                    "shortcut": ""
                },
                {
                    "label": "Semestral",
                    "value": "6",
                    "shortcut": ""
                },
                {
                    "label": "Trimestral",
                    "value": "3",
                    "shortcut": ""
                },
                {
                    "label": "Mensual",
                    "value": "1",
                    "shortcut": ""
                }
                ],
                "key": "periodicidadPagoId",
                "properties": {
                    "1": "0.5",
                    "3": "0.3",
                    "6": "0.2",
                    "12": "0"
                },
                "type": "radio",
                "input": true
            },
            {
                "label": "Pago",
                "optionsLabelPosition": "right",
                "customClass": "selectboxesPayment",
                "tableView": false,
                "defaultValue": {
                    "tarjetaCredito": false,
                    "tarjetaDebito": false,
                    "transferencia": false,
                    "tarjetaDeCredito": false,
                    "tarjetaDeD": false,
                    "tarjetaDeDe": false,
                    "tarjetaDeDeb": false,
                    "tarjetaDeDebi": false,
                    "tarjetaDeDebito": false,
                    "t": false,
                    "tra": false,
                    "trans": false,
                    "transfer": false,
                    "transfere": false,
                    "transferenc": false
                },
                "values": [{
                    "label": "Tarjeta de crédito",
                    "value": "tarjetaDeCredito",
                    "shortcut": ""
                },
                {
                    "label": "Tarjeta de débito",
                    "value": "tarjetaDeDebito",
                    "shortcut": ""
                },
                {
                    "label": "Transferencia",
                    "value": "transferencia",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "pago",
                "properties": {
                    "tarjetaDeCredito": "https://images.prismic.io/cotizadores-suramex-qa/be18891d-6696-4503-a3b6-62469ae7ed8f_payment-1.png?auto=compress,format",
                    "tarjetaDeDebito": "https://images.prismic.io/cotizadores-suramex-qa/7cdf2b05-d3fe-41ee-a281-47a27627dd9d_payment-2.png?auto=compress,format",
                    "transferencia": "https://images.prismic.io/cotizadores-suramex-qa/6808a94b-47ee-4964-b113-d78383a19727_payment-3.png?auto=compress,format"
                },
                "type": "selectboxes",
                "input": true,
                "inputType": "checkbox"
            },
            {
                "label": "Acepto recibir la póliza al correo electrónico registrado.",
                "customClass": "checkClassic",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true
                },
                "key": "aceptOne",
                "type": "checkbox",
                "input": true
            },
            {
                "label": "Acepto el Aviso de Privacidad y los Términos y Condiciones de uso de medios electrónicos.",
                "customClass": "checkClassic",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true
                },
                "key": "aceptTwo",
                "type": "checkbox",
                "input": true
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }]
    }
    ],
    currentStep: 0,
    currentQuestion: 0,
    numberQuestionsStep: 1,
    isGoToBack: false,
};

export const formStatusBeneficiarios = {
    steps: [{
        "key_step": "step_personales",
        "name": "Algunos datos",
        "questions": [{
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Hola, para iniciar ingresa algunos datos personales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "No",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "80-20",
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/validaciones/suscripciones-previas?fechaNacimiento=value&peso=value&talla=value&claveOcupacion=value\",\n  \"method\": \"GET\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "FECHA DE NACIMIENTO",
                "format": "DD/MM/YYYY",
                "tableView": false,
                "enableMinDateInput": false,
                "datePicker": {
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "maxDate": "2021-01-01T12:00:00-05:00",
                    "disableWeekends": false,
                    "disableWeekdays": false
                },
                "enableMaxDateInput": false,
                "validate": {
                    "required": true,
                    "customMessage": "INGRESA UNA FECHA VÁLIDA"
                },
                "key": "beneficiarios",
                "type": "datetime",
                "input": true,
                "widget": {
                    "type": "calendar",
                    "displayInTimezone": "viewer",
                    "locale": "en",
                    "useLocaleSettings": false,
                    "allowInput": true,
                    "mode": "single",
                    "enableTime": true,
                    "noCalendar": false,
                    "format": "DD/MM/YYYY",
                    "hourIncrement": 1,
                    "minuteIncrement": 1,
                    "time_24hr": false,
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "disableWeekends": false,
                    "disableWeekdays": false,
                    "maxDate": "2021-01-01T12:00:00-05:00"
                },
                "value": "1990-01-01"
            },
            {
                "label": "OCUPACIÓN",
                "widget": "choicesjs",
                "placeholder": "Elige tu ocupación ",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/catalogos/ocupaciones",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "claveOcupacion",
                "type": "select",
                "input": true,
                "valuesResponse": [{
                    "clave": "A001",
                    "descripcion": "ABOGADO"
                }],
                "value": "A001"
            },
            {
                "label": "PESO EN KILOGRAMOS",
                "placeholder": "Ej: 00.000 Kg",
                "suffix": "Kg",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "[0-9]{1,3}\\.[0-9][0-9][0-9]",
                    "customMessage": "Ingrese un peso correcto Ej: 99.999",
                    "minLength": 1,
                    "maxLength": 7
                },
                "key": "peso",
                "properties": {
                    "fixed": "3"
                },
                "type": "textfield",
                "input": true,
                "value": "80.000"
            },
            {
                "label": "ALTURA EN METROS",
                "placeholder": "Ej: 0.00 m",
                "suffix": "m",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "(?:(2.)([0-5])|(?:(1.)([0-9])))[0-9]",
                    "customMessage": "Ingrese una altura correcta Ej: 1.80",
                    "minLength": 1,
                    "maxLength": 4
                },
                "key": "talla",
                "type": "textfield",
                "input": true,
                "value": "1.70"
            },
            {
                "label": "MI IMC ES DE",
                "placeholder": "0.0 m",
                "tooltip": "Índice de Masa Corporal",
                "suffix": "m",
                "spellcheck": false,
                "disabled": true,
                "tableView": false,
                "calculateValue": {
                    "operation": "peso/(talla*talla)",
                    "fields": [
                        "peso",
                        "talla"
                    ]
                },
                "validate": {
                    "required": true,
                    "minLength": 1,
                    "maxLength": 6
                },
                "key": "imc",
                "properties": {
                    "fixed": "3"
                },
                "type": "textfield",
                "input": true,
                "value": "27.682"
            },
            {
                "label": "¿Eres fumador?",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true,
                    "customMessage": "Error"
                },
                "key": "esFumador",
                "type": "checkbox",
                "input": true,
                "value": false
            },
            {
                "label": "Aliado",
                "defaultValue": "COTIZADORES_SURA",
                "key": "claveAliado",
                "type": "hidden",
                "input": true,
                "tableView": false,
                "value": "COTIZADORES_SURA"
            },
            {
                "label": "Status",
                "defaultValue": "ACEPTAR",
                "key": "status",
                "type": "hidden",
                "input": true,
                "tableView": false,
                "value": "ACEPTAR"
            },
            {
                "label": "Url Cuestionarios Medicos",
                "key": "urlCuestionariosMedicos",
                "type": "hidden",
                "input": true,
                "tableView": false
            },
            {
                "label": "Folio",
                "key": "folio",
                "type": "hidden",
                "input": true,
                "tableView": false,
                "value": 407416
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Selecciona tu género",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Genero",
                "optionsLabelPosition": "right",
                "customClass": "radioImage",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "Femenino",
                    "value": "M",
                    "shortcut": ""
                },
                {
                    "label": "Masculino",
                    "value": "H",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "genero",
                "properties": {
                    "H": "https://images.prismic.io/portal-cotizacion-suramex/0399ebf0-3ec8-4cf6-9f70-0f1105be2022_men.png?auto=compress,format",
                    "M": "https://images.prismic.io/portal-cotizacion-suramex/4cb0207a-34b8-41c3-b8f0-1c94de47c94e_women.png?auto=compress,format"
                },
                "type": "radio",
                "input": true,
                "value": "M"
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "¿Cómo es tu familia?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Familia",
                "optionsLabelPosition": "right",
                "customClass": "radioImage",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "Soltero(a)",
                    "value": "T",
                    "shortcut": ""
                },
                {
                    "label": "Pareja sin hijos",
                    "value": "C",
                    "shortcut": ""
                },
                {
                    "label": "Pareja con hijos",
                    "value": "F",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "claveTipoFamilia",
                "properties": {
                    "T": "https://images.prismic.io/portal-cotizacion-suramex/a81f3af0-a49a-4a1b-b4d4-b3f5cc367095_solteros.png?auto=compress,format",
                    "C": "https://images.prismic.io/portal-cotizacion-suramex/ffe662ac-b650-430a-9750-7c2d6b612171_parejasinhijos.png?auto=compress,format",
                    "F": "https://images.prismic.io/portal-cotizacion-suramex/5144744e-ff1e-4825-ae75-b5d54c1bc20a_parejaconhijos.png?auto=compress,format"
                },
                "type": "radio",
                "input": true,
                "value": "T"
            },
            {
                "label": "¿Tienes mascotas?",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true
                },
                "key": "incluyeMascotas",
                "type": "checkbox",
                "input": true,
                "value": false
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "¿Qué tipo de mascota tienes?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Mascotas",
                "optionsLabelPosition": "right",
                "customClass": "radioImage",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "Perro",
                    "value": "perro",
                    "shortcut": ""
                },
                {
                    "label": "Gato",
                    "value": "gato",
                    "shortcut": ""
                },
                {
                    "label": "Ambos",
                    "value": "ambos",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "mascotas",
                "properties": {
                    "perro": "https://images.prismic.io/portal-cotizacion-suramex/7bc9b6ae-f3d1-4b56-ad93-85983d859890_perro.png?auto=compress,format",
                    "gato": "https://images.prismic.io/portal-cotizacion-suramex/14ee12a7-307e-4915-b35f-a245477d8c27_gato.png?auto=compress,format",
                    "ambos": "https://images.prismic.io/portal-cotizacion-suramex/972369e9-eff7-479e-978b-38673d903ca5_ambos.png?auto=compress,format"
                },
                "conditional": {
                    "show": true,
                    "when": "incluyeMascotas",
                    "eq": "true"
                },
                "type": "radio",
                "input": true
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_personales",
                "title": [{
                    "type": "heading6",
                    "text": "Selecciona la temporalidad y moneda de tu póliza:",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "50-50",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "¿POR CUANTO TIEMPO QUIERES CONTRATAR TU SEGURO?",
                "widget": "choicesjs",
                "placeholder": "años",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "1 año",
                        "value": "1"
                    },
                    {
                        "label": "5 años",
                        "value": "5"
                    },
                    {
                        "label": "10 años",
                        "value": "10"
                    },
                    {
                        "label": "15 años",
                        "value": "15"
                    },
                    {
                        "label": "20 años",
                        "value": "20"
                    },
                    {
                        "label": "25 años",
                        "value": "25"
                    }
                    ]
                },
                "validate": {
                    "required": true
                },
                "key": "atrTipoTemporalidad",
                "type": "select",
                "input": true,
                "value": "1"
            },
            {
                "label": "¿En qué monedas quieres tus coberturas?",
                "widget": "choicesjs",
                "placeholder": "Ej: pesos",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "USD - Dólares",
                        "value": "USD"
                    },
                    {
                        "label": "MXN - Pesos",
                        "value": "MXN"
                    }
                    ]
                },
                "validate": {
                    "required": true
                },
                "key": "monedaId",
                "type": "select",
                "input": true,
                "value": "USD"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }
        ]
    },
    {
        "key_step": "step_configura_tu_poliza",
        "name": "Configura tu póliza",
        "questions": [{
            "primary": {
                "associated_group": "step_configura_tu_poliza",
                "title": [{
                    "type": "heading6",
                    "text": "Elige tus coberturas y sumas aseguradas",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Coberturas",
                "optionsLabelPosition": "right",
                "tableView": false,
                "defaultValue": {
                    "1": false,
                    "": false,
                    "{": false
                },
                "values": [{
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/coberturas?fechaNacimiento=value&claveTipoFamilia=value&claveOcupacion=value&claveAliado=value&atrTipoTemporalidad=value&incluyeMascotas=value&page=1\",   \"method\": \"GET\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"   },   \"body\": {} }",
                    "shortcut": ""
                }],
                "validate": {
                    "required": true
                },
                "key": "coberturas",
                "type": "selectboxes",
                "input": true,
                "inputType": "checkbox",
                "value": [{
                    "nombre": "COBERTURA BÁSICA POR FALLECIMIENTO",
                    "claveCobertura": "9190",
                    "obligatorio": true,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 50,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 700000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 35000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 107692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "BÁSICA",
                    "asegurados": [],
                    "page": "1",
                    "img": "be8d7cbd-4fbe-473d-972c-1444d267104c_fallecimiento.png",
                    "descripcion": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada",
                    "criterios": {
                        "igualdad": [
                            "9194"
                        ],
                        "nuevoMaximo": [{
                            "coberturas": [
                                "9191",
                                "9192",
                                "9193",
                                "9195"
                            ],
                            "formula": {
                                "operador": "*",
                                "valor1": "sumaAseguradaSeleccionada",
                                "valor2": 1.5
                            }
                        },
                        {
                            "coberturas": [
                                "9197"
                            ],
                            "formula": {
                                "operador": "*",
                                "valor1": "sumaAseguradaSeleccionada",
                                "valor2": 0.5
                            }
                        }
                        ]
                    },
                    "value": 35000
                },
                {
                    "nombre": "GASTOS FUNERARIOS",
                    "claveCobertura": "9198",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 58,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 20000,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 1000,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 3076,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": null,
                    "tipo": "RECOMENDADA",
                    "asegurados": [{
                        "claveAsegurado": "T",
                        "dsAsegurado": "Para mí",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "H",
                        "dsAsegurado": "Para mí y mis hijos",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "C",
                        "dsAsegurado": "Para mí y mi cónyuge",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "F",
                        "dsAsegurado": "Para mí, mi cónyuge y mis hijos (menores de 18 años)",
                        "porcentajeExtraPrima": 0
                    }
                    ],
                    "page": "1",
                    "img": "6ed16477-76dd-42c5-9faa-93fee1fc6436_gastos-funerarios.png",
                    "descripcion": "En caso de que llegaran a faltar tú, tu cónyuge o alguno de tus hijos, tus beneficiarios recibirán la suma asegurada contratada",
                    "checks": "T",
                    "value": 2500
                }
                ],
                "valueResponse": [{
                    "nombre": "COBERTURA BÁSICA POR FALLECIMIENTO",
                    "claveCobertura": "9190",
                    "obligatorio": true,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 50,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 700000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 35000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 107692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "BÁSICA",
                    "asegurados": [],
                    "page": "1",
                    "img": "be8d7cbd-4fbe-473d-972c-1444d267104c_fallecimiento.png",
                    "descripcion": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada",
                    "criterios": {
                        "igualdad": [
                            "9194"
                        ],
                        "nuevoMaximo": [{
                            "coberturas": [
                                "9191",
                                "9192",
                                "9193",
                                "9195"
                            ],
                            "formula": {
                                "operador": "*",
                                "valor1": "sumaAseguradaSeleccionada",
                                "valor2": 1.5
                            }
                        },
                        {
                            "coberturas": [
                                "9197"
                            ],
                            "formula": {
                                "operador": "*",
                                "valor1": "sumaAseguradaSeleccionada",
                                "valor2": 0.5
                            }
                        }
                        ]
                    },
                    "value": 35000
                },
                {
                    "nombre": "MUERTE ACCIDENTAL",
                    "claveCobertura": "9191",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 51,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "6efe56e5-8e7f-4002-9281-d49670c7bec8_fallecimiento-accidental.png",
                    "descripcion": "Pagamos a los beneficiarios una suma asegurada adicional en caso de que el fallecimiento del asegurado ocurra en un accidente."
                },
                {
                    "nombre": "MUERTE ACCIDENTAL COLECTIVA",
                    "claveCobertura": "9192",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 52,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": null,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "89c178b5-61e7-4132-9f7e-d75c4d638eea_exencionpagos-primas-invalidez.png",
                    "descripcion": "Pagamos a los beneficiarios una suma asegurada adicional en caso de que el fallecimiento del asegurado ocurra a causa de un accidente como pasajero en transporte terrestre público."
                },
                {
                    "nombre": "INVALIDEZ TOTAL Y PERMANENTE",
                    "claveCobertura": "9193",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 53,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 1500000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 75000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 230769,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "89c178b5-61e7-4132-9f7e-d75c4d638eea_exencionpagos-primas-invalidez.png",
                    "descripcion": null
                },
                {
                    "nombre": "PÉRDIDAS ORGÁNICAS",
                    "claveCobertura": "9195",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 55,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 1500000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 250000,
                            "sumaAseguradaPredeterminada": 75000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 230769,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "b5331ca7-35f7-4dfa-b2f5-35e39683d1c8_perdidas-organicas.png",
                    "descripcion": "Indemnizamos al asegurado en caso de sufrir la pérdida de alguna parte del cuerpo a consecuencia de un accidente, de acuerdo al tipo de pérdida sufrida"
                },
                {
                    "nombre": "INDEMNIZACIÓN DIARIA POR HOSPITALIZACIÓN",
                    "claveCobertura": "9196",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 56,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 120,
                            "sumaAseguradaMaxima": 1500,
                            "sumaAseguradaPredeterminada": 1000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 6,
                            "sumaAseguradaMaxima": 75,
                            "sumaAseguradaPredeterminada": 50,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 19,
                            "sumaAseguradaMaxima": 230,
                            "sumaAseguradaPredeterminada": 154,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "a8b46c2b-5211-415b-af7b-32d4b31107de_indemnizacion-diaria-hospitaliza.png",
                    "descripcion": "En caso de estar hospitalizado a causa de una enfermedad o accidente, contarás con un apoyo económico."
                },
                {
                    "nombre": "ENFERMEDADES GRAVES",
                    "claveCobertura": "9197",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 57,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 100000,
                            "sumaAseguradaMaxima": 5000000,
                            "sumaAseguradaPredeterminada": 375000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 5000,
                            "sumaAseguradaMaxima": 150000,
                            "sumaAseguradaPredeterminada": 18750,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 15385,
                            "sumaAseguradaMaxima": 769231,
                            "sumaAseguradaPredeterminada": 57692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "RECOMENDADA",
                    "asegurados": [],
                    "page": "1",
                    "img": "136b5425-92b5-458f-9427-5dc01bed3bb4_enfermedades-graves.png",
                    "descripcion": "Si eres diagnosticado por primera vez con alguna de las 9 enfermedades graves cubiertas, se te pagará la suma asegurada contratada para esta cobertura."
                },
                {
                    "nombre": "GASTOS FUNERARIOS",
                    "claveCobertura": "9198",
                    "obligatorio": false,
                    "dependencia": "",
                    "claveSumaAseguradaCapital": 58,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": 20000,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "USD": {
                            "sumaAseguradaMinima": 1000,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": null
                        },
                        "UDI": {
                            "sumaAseguradaMinima": 3076,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": null
                        }
                    },
                    "porcentajeExtraPrima": null,
                    "tipo": "RECOMENDADA",
                    "asegurados": [{
                        "claveAsegurado": "T",
                        "dsAsegurado": "Para mí",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "H",
                        "dsAsegurado": "Para mí y mis hijos",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "C",
                        "dsAsegurado": "Para mí y mi cónyuge",
                        "porcentajeExtraPrima": null
                    },
                    {
                        "claveAsegurado": "F",
                        "dsAsegurado": "Para mí, mi cónyuge y mis hijos (menores de 18 años)",
                        "porcentajeExtraPrima": 0
                    }
                    ],
                    "page": "1",
                    "img": "6ed16477-76dd-42c5-9faa-93fee1fc6436_gastos-funerarios.png",
                    "descripcion": "En caso de que llegaran a faltar tú, tu cónyuge o alguno de tus hijos, tus beneficiarios recibirán la suma asegurada contratada",
                    "checks": "T",
                    "value": 2500
                }
                ]
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_configura_tu_poliza",
                "title": [{
                    "type": "heading6",
                    "text": "¿Te gustaría personalizar tu experiencia con estas coberturas adicionales?",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": "80-20",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Coberturas adicionales",
                "optionsLabelPosition": "right",
                "tableView": false,
                "defaultValue": {
                    "1": false,
                    "": false,
                    "{": false
                },
                "values": [{
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/coberturas?fechaNacimiento=value&claveTipoFamilia=value&claveOcupacion=value&claveAliado=value&incluyeMascotas=value&page=2\",   \"method\": \"GET\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"   },   \"body\": {} }",
                    "shortcut": ""
                }],
                "validate": {
                    "required": true
                },
                "key": "coberturasAdicionales",
                "type": "selectboxes",
                "input": true,
                "inputType": "checkbox",
                "value": [],
                "valueResponse": [{
                    "nombre": "PROTECCIÓN ADICIONAL POR FALLECIMIENTO",
                    "claveCobertura": "9202",
                    "obligatorio": false,
                    "dependencia": "9190",
                    "claveSumaAseguradaCapital": 60,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "USD": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "UDI": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": 20
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "OPCIONAL",
                    "asegurados": [],
                    "page": "2",
                    "img": "6fb25117-e9fd-4351-bb97-e3f61b16151b_proteccion-adicional-fallecimiento.png",
                    "descripcion": "En caso de que llegues a faltar, tus beneficiarios contarán con un bono adicional que podrán utilizar para fines como: gastos del hogar, etc."
                },
                {
                    "nombre": "PROTECCIÓN ADICIONAL POR INVALIDEZ",
                    "claveCobertura": "9203",
                    "obligatorio": false,
                    "dependencia": "9193",
                    "claveSumaAseguradaCapital": 61,
                    "rangoValoresPorMoneda": {
                        "MXN": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 100000,
                            "sumaAseguradaPredeterminada": 50000,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "USD": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 5000,
                            "sumaAseguradaPredeterminada": 2500,
                            "porcentajeSumAseguradaMinDependencia": 20
                        },
                        "UDI": {
                            "sumaAseguradaMinima": null,
                            "sumaAseguradaMaxima": 15385,
                            "sumaAseguradaPredeterminada": 7692,
                            "porcentajeSumAseguradaMinDependencia": 20
                        }
                    },
                    "porcentajeExtraPrima": 0,
                    "tipo": "OPCIONAL",
                    "asegurados": [],
                    "page": "2",
                    "img": "1d81a23f-a339-4a52-b092-9105eec4b628_proteccion-adicional-invalidez.png",
                    "descripcion": "En caso de sufrir algún accidente o enfermedad que te provoque una invalidez total y permanente, recibirás la suma asegurada contratada."
                }
                ]
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }
        ]
    },
    {
        "key_step": "step_cotizacion",
        "name": "Cotización",
        "questions": [{
            "primary": {
                "associated_group": "step_cotizacion",
                "title": [],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "2",
                "relationship_columns": "50-50",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Nombre",
                "placeholder": "Ej. Diana",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Ingresa un nombre valido",
                    "minLength": 1,
                    "maxLength": 100
                },
                "key": "nombre",
                "type": "textfield",
                "input": true,
                "value": "dfgdfgf"
            },
            {
                "label": "INGRESA TU E-MAIL",
                "placeholder": "ejemplo@gmail.com",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                    "customMessage": "Ingrese un correo electrónico valido",
                    "minLength": 1,
                    "maxLength": 100
                },
                "key": "email",
                "type": "textfield",
                "input": true,
                "value": "dfgdfg@gmail.com"
            },
            {
                "label": "TELÉFONO CELULAR",
                "placeholder": "Ej. 555723799",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^(?!.*?([1234567890])\\1{9,}|(1234567890))[0-9]*$",
                    "customMessage": "Ingresa un número telefónico valido",
                    "minLength": 10,
                    "maxLength": 10
                },
                "key": "telefono",
                "type": "textfield",
                "input": true,
                "value": "6346546546"
            },
            {
                "label": "No soy un robot",
                "customClass": "recaptcha",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true
                },
                "key": "noSoyUnRobot",
                "properties": {
                    "sitekey": "6LdCNUMaAAAAAM3W7I7d9dsG9WXPb-0W0v7f9n9G"
                },
                "type": "checkbox",
                "input": true,
                "value": true
            },
            {
                "label": "Aceptar aviso de privacidad",
                "customClass": "readonly",
                "defaultValue": "Al continuar estas aceptando el <A HREF=\"https://invierteyahorra.suramexico.com/suramexico/aviso-de-privacidad-SUAM.html\" target=\"_blank\">aviso de privacidad</A>",
                "key": "avisoPrivacidad",
                "type": "hidden",
                "input": true,
                "tableView": false,
                "value": "Al continuar estas aceptando el <A HREF=\"https://invierteyahorra.suramexico.com/suramexico/aviso-de-privacidad-SUAM.html\" target=\"_blank\">aviso de privacidad</A>"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_cotizacion",
                "title": [{
                    "type": "heading6",
                    "text": "Planes",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "No",
                "returnbutton": "Si",
                "sidebar": "No",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",

                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Planes",
                "optionsLabelPosition": "right",
                "customClass": "selectboxesPlans",
                "tableView": false,
                "defaultValue": {
                    "api": false,
                    "apiService": false,
                    "{": false
                },
                "values": [{
                    "label": "api_service",
                    "value": "{   \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/cotizacion\",   \"method\": \"POST\",   \"headers\": {     \"Content-Type\": \"application/json\",     \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"   },   \"body\": {} }",
                    "shortcut": ""
                }],
                "validate": {
                    "required": true
                },
                "key": "planes",
                "type": "selectboxes",
                "input": true,
                "inputType": "checkbox",
                "value": [{
                    "paquete": "Mi Plan Vive",
                    "valor": 53.92,
                    "asistencias": "Asistencia básica (legal, médica, funeraria y repatriación)",
                    "tooltip": "En caso de que llegaras a faltar, tus beneficiarios recibirán la suma asegurada contratada.",
                    "descripcion": "Tu seguro de vida personalizado con las Coberturas que elegiste.",
                    "coberturas": [{
                        "claveCobertura": "9190",
                        "sumaAsegurada": 35000,
                        "atrRecargoCobertura": 0,
                        "porcentajeExtraPrima": "0",
                        "claveSumaAseguradaCapital": 50
                    },
                    {
                        "claveCobertura": "9198",
                        "sumaAsegurada": 2500,
                        "atrRecargoCobertura": 0,
                        "porcentajeExtraPrima": "0",
                        "claveSumaAseguradaCapital": 58
                    },
                    {
                        "claveCobertura": "9206",
                        "sumaAsegurada": 0,
                        "atrRecargoCobertura": 0,
                        "porcentajeExtraPrima": "0",
                        "claveSumaAseguradaCapital": 64
                    }
                    ]
                }]
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }
        ]
    },
    {
        "key_step": "step_emision_asegurado",
        "name": "Emisión Asegurado",
        "questions": [{
            "primary": {
                "associated_group": "step_emision_asegurado",
                "title": [{
                    "type": "heading6",
                    "text": "Información del asegurado titular",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "60-40",
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "RFC",
                "placeholder": "Ingresa el número de RFC",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[A-Z0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 13,
                    "maxLength": 13
                },
                "key": "identificadorPersona",
                "type": "textfield",
                "input": true,
                "value": "5465465465465"
            },
            {
                "label": "Validar RFC",
                "showValidations": false,
                "tableView": false,
                "key": "validarRfc",
                "logic": [{
                    "name": "api_service",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/personas?tipoIdentificadorPersona=1&identificadorPersona=value",
                            "method": "GET",
                            "headers": {
                                "Content-Type": "application/json",
                                "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                            },
                            "body": {},
                            "action": "autocomplete"
                        }
                    },
                    "actions": [],
                    "isRowSelected": true
                }],
                "type": "button",
                "input": true,
                "saveOnEnter": false
            },
            {
                "type": "fakeField"
            },
            {
                "label": "Nombre",
                "placeholder": "Ej. Juan",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "primerNombre",
                "type": "textfield",
                "input": true,
                "value": "dfg"
            },
            {
                "label": "Apellido paterno",
                "placeholder": "Ej. Pérez",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "primerApellido",
                "type": "textfield",
                "input": true,
                "value": "dfdf"
            },
            {
                "label": "Apellido materno",
                "placeholder": "Ej. Rodríguez",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "segundoApellido",
                "type": "textfield",
                "input": true,
                "value": "dfgfd"
            },
            {
                "label": "CURP",
                "placeholder": "Digita Clave Única de Registro de Población",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-Z0-9]+$",
                    "customMessage": "Tu CURP debe tener longitud de 18 caracteres",
                    "minLength": 18,
                    "maxLength": 18
                },
                "key": "curp",
                "type": "textfield",
                "input": true,
                "value": "546546546546546546"
            },
            {
                "label": "Género",
                "widget": "choicesjs",
                "placeholder": "Elige género",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Femenino",
                        "value": "M"
                    },
                    {
                        "label": "Masculino",
                        "value": "H"
                    }
                    ]
                },
                "validate": {
                    "required": true
                },
                "key": "sexo",
                "type": "select",
                "input": true,
                "value": "M"
            },
            {
                "label": "Fecha de nacimiento",
                "format": "DD/MM/YYYY",
                "tableView": false,
                "enableMinDateInput": false,
                "datePicker": {
                    "minDate": "1870-01-01T11:59:00-04:56",
                    "maxDate": "2021-01-01T12:00:00-05:00",
                    "disableWeekends": false,
                    "disableWeekdays": false
                },
                "enableMaxDateInput": false,
                "customDefaultValue": "fechaNacimiento",
                "validate": {
                    "required": true
                },
                "key": "fechaDeNacimientoAsegurado",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "datetime",
                "input": true,
                "widget": {
                    "type": "calendar",
                    "displayInTimezone": "viewer",
                    "locale": "en",
                    "useLocaleSettings": false,
                    "allowInput": true,
                    "mode": "single",
                    "enableTime": true,
                    "noCalendar": false,
                    "format": "DD/MM/YYYY",
                    "hourIncrement": 1,
                    "minuteIncrement": 1,
                    "time_24hr": false,
                    "minDate": "1870-01-01T11:59:00-04:56",
                    "disableWeekends": false,
                    "disableWeekdays": false,
                    "maxDate": "2021-01-01T12:00:00-05:00"
                },
                "value": "1990-01-01"
            },
            {
                "label": "Estado Civil",
                "widget": "choicesjs",
                "placeholder": "Elige estado civil",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Soltero/a.",
                        "value": "S"
                    },
                    {
                        "label": "Casado/a.",
                        "value": "C"
                    }
                    ]
                },
                "validate": {
                    "required": true
                },
                "key": "estadoCivil",
                "type": "select",
                "input": true,
                "value": "C"
            },
            {
                "label": "País de Nacimiento",
                "widget": "choicesjs",
                "placeholder": "Elige país de nacimiento",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/paises",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "pais",
                "type": "select",
                "input": true,
                "valuesResponse": [
                    {
                        "clave": "001",
                        "descripcion": "AFGANISTAN"
                    }
                ],
                "value": "002"
            },
            {
                "label": "Lugar de Nacimiento",
                "placeholder": "Lugar de Nacimiento",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 40
                },
                "key": "lugarNacimiento",
                "type": "textfield",
                "input": true,
                "value": "dfgfd"
            },
            {
                "label": "Nacionalidad",
                "widget": "choicesjs",
                "placeholder": "Elige tu nacionalidad",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/nacionalidades",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "nacionalidad",
                "type": "select",
                "input": true,
                "valuesResponse": [
                    {
                        "clave": "001",
                        "descripcion": "AFGANO"
                    }
                ],
                "value": "002"
            },
            {
                "label": "Ocupación o profesión",
                "widget": "choicesjs",
                "placeholder": "Elige ocupación o profesión",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/catalogos/ocupaciones",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "claveOcupacion",
                "key": "ocupacionProfesion",
                "type": "select",
                "input": true,
                "value": "A001",
                "valuesResponse": [
                    {
                        "clave": "A001",
                        "descripcion": "ABOGADO"
                    }
                ]
            },
            {
                "label": "Ingresos mensuales",
                "placeholder": "Ej. 113434",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 7
                },
                "key": "ingresosMensuales",
                "type": "textfield",
                "input": true,
                "value": "6546546"
            },
            {
                "label": "INGRESA TU E-MAIL",
                "placeholder": "ejemplo@gmail.com",
                "tableView": true,
                "customDefaultValue": "email",
                "validate": {
                    "required": true,
                    "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                    "customMessage": "Ingrese un correo electrónico valido",
                    "minLength": 1,
                    "maxLength": 100
                },
                "key": "email1",
                "type": "textfield",
                "input": true,
                "value": "dfgdfg@gmail.com"
            },
            {
                "label": "TELÉFONO CELULAR",
                "placeholder": "Ej. 55 5723 799",
                "tableView": true,
                "customDefaultValue": "telefono",
                "validate": {
                    "required": true,
                    "pattern": "^(?!.*?([1234567890])\\1{9,}|(1234567890))[0-9]*$",
                    "customMessage": "Ingresa un número telefónico valido",
                    "minLength": 10,
                    "maxLength": 10
                },
                "key": "telefonoCelular",
                "type": "textfield",
                "input": true,
                "value": "6346546546"
            },
            {
                "label": "Tipo de identificación entregada",
                "widget": "choicesjs",
                "placeholder": "Elige tipo de identificación entregada",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Credencial para votar vigente",
                        "value": "credencialParaVotarVigente"
                    },
                    {
                        "label": "Pasaporte vigente",
                        "value": "pasaporteVigente"
                    }
                    ]
                },
                "validate": {
                    "required": true
                },
                "key": "tipoDeIdentificacionEntregada",
                "type": "select",
                "input": true,
                "value": "credencialParaVotarVigente"
            },
            {
                "label": "Folio de identificación entregada",
                "placeholder": "Ej. 788120155J",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 30
                },
                "key": "folioDeIdentificacionEntregada",
                "type": "textfield",
                "input": true,
                "value": "65465465465465"
            },
            {
                "label": "¿Residente fiscal en el extranjero?",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "customMessage": "Error"
                },
                "key": "residenteFiscalExtranjero",
                "conditional": {
                    "show": false,
                    "when": "pais",
                    "eq": "052"
                },
                "type": "checkbox",
                "input": true,
                "value": true
            },
            {
                "label": "País donde es residente fiscal",
                "widget": "choicesjs",
                "placeholder": "Elige país donde es residente fiscal",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/paises",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "paisResidenteFiscal",
                "conditional": {
                    "show": true,
                    "when": "residenteFiscalExtranjero",
                    "eq": "true"
                },
                "type": "select",
                "input": true,
                "valuesResponse": [
                    {
                        "clave": "004",
                        "descripcion": "AFGANISTAN"
                    }
                ],
                "value": "004"
            },
            {
                "label": "N° Identificación en el extranjero",
                "placeholder": "Ej. 1034388456",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 30
                },
                "key": "nIdentificacionEnElExtranjero",
                "conditional": {
                    "show": true,
                    "when": "residenteFiscalExtranjero",
                    "eq": "true"
                },
                "type": "textfield",
                "input": true,
                "value": "465465465465465465"
            },
            {
                "label": "Dirección",
                "placeholder": "Digita la dirección",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 50
                },
                "key": "direccion",
                "type": "textfield",
                "input": true,
                "value": "dfgf"
            },
            {
                "label": "No. Exterior",
                "placeholder": "Ej. 2214",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^(0|[1-9][0-9]*)$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 6
                },
                "key": "nExterior",
                "type": "textfield",
                "input": true,
                "value": "534654"
            },
            {
                "label": "No. interior",
                "placeholder": "Ej. 0121",
                "tableView": true,
                "validate": {
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 6
                },
                "key": "nIterior",
                "type": "textfield",
                "input": true
            },
            {
                "label": "Código postal",
                "placeholder": "Ej. 43540",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 5,
                    "maxLength": 5
                },
                "key": "codigoPostal",
                "type": "textfield",
                "input": true,
                "value": "97100"
            },
            {
                "label": "Estado",
                "widget": "choicesjs",
                "placeholder": "Elige el estado",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostal=value&catalogo=ESTADO",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true
                },
                "key": "estadoAsegurado",
                "type": "select",
                "input": true,
                "valuesResponse": [{
                    "clave": "31",
                    "descripcion": "YUCATAN"
                }],
                "value": "31"
            },
            {
                "label": "Colonia",
                "widget": "choicesjs",
                "placeholder": "Elige la colonia",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostal=value&catalogo=COLONIA",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "coloniaAsegurado",
                "type": "select",
                "input": true,
                "valuesResponse": [{
                    "clave": "003RB",
                    "descripcion": "ITZIMNA PRIVADA PEREZ"
                },
                {
                    "clave": "003RC",
                    "descripcion": "ITZIMNA PRIVADA PEREZ PF"
                },
                {
                    "clave": "31094",
                    "descripcion": "RINCONADA ITZMINA"
                },
                {
                    "clave": "31A28",
                    "descripcion": "ITZIMNA"
                },
                {
                    "clave": "31A29",
                    "descripcion": "ITZIMNA 2"
                }
                ],
                "value": "31094"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_emision_asegurado",
                "title": [{
                    "type": "heading6",
                    "text": "Identificación y conocimiento del cliente",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Cuénta con otro seguro de vida contratado de forma voluntaria?",
                "optionsLabelPosition": "right",
                "customClass": "radioText",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "Si",
                    "value": "si",
                    "shortcut": ""
                },
                {
                    "label": "No",
                    "value": "no",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "cuentaConOtroSeguroDeVidaContratadoDeFormaVoluntaria",
                "type": "radio",
                "input": true,
                "value": "no"
            },
            {
                "label": "Le han rechazado, limitado o extra-primado alguna solicitud?",
                "optionsLabelPosition": "right",
                "customClass": "radioText",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "Si",
                    "value": "si",
                    "shortcut": ""
                },
                {
                    "label": "No",
                    "value": "no",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "leHanRechazadoLimitadoOExtraPrimadoAlgunaSolicitud",
                "type": "radio",
                "input": true,
                "value": "no"
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }
        ]
    },
    {
        "key_step": "step_asegurados",
        "name": "Asegurados",
        "questions": [{
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de los asegurados adicionales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "heading3",
                    "text": "Cobertura de gastos funerarios",
                    "spans": [{
                        "start": 0,
                        "end": 30,
                        "type": "strong"
                    }]
                },
                {
                    "type": "paragraph",
                    "text": "La designación de beneficiarios para esta cobertura es recíproca, es decir, en caso de fallecimiento del cónyuge, se entrega el 100% de la suma asegurada al titular.",
                    "spans": []
                }
                ],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "title": "Asegurados",
                "breadcrumbClickable": true,
                "buttonSettings": {
                    "previous": true,
                    "cancel": true,
                    "next": true
                },
                "scrollToTop": false,
                "customClass": "repeatableContent",
                "collapsible": false,
                "key": "asegurados",
                "properties": {
                    "nameRelatedProperty": "coberturas",
                    "valueRelatedKey": "9198"
                },
                "type": "panel",
                "label": "Asegurados",
                "input": false,
                "tableView": false,
                "components": [{
                    "label": "Nombre",
                    "placeholder": "Ej. Juan",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un nombre valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "nombreAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Apellido paterno",
                    "placeholder": "Ej. Rodríguez",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un apellido valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "apellidoPaternoAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Apellido materno",
                    "placeholder": "Ej. Pérez",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un apellido valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "apellidoMaternoAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Fecha de nacimiento",
                    "format": "DD/MM/YYYY",
                    "tableView": false,
                    "enableMinDateInput": false,
                    "datePicker": {
                        "minDate": "1870-01-01T11:59:00-04:56",
                        "disableWeekends": false,
                        "disableWeekdays": false
                    },
                    "enableMaxDateInput": false,
                    "validate": {
                        "required": true,
                        "customMessage": "Ingresa una fecha válida"
                    },
                    "key": "fechaNacimientoAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "datetime",
                    "input": true,
                    "widget": {
                        "type": "calendar",
                        "displayInTimezone": "viewer",
                        "locale": "en",
                        "useLocaleSettings": false,
                        "allowInput": true,
                        "mode": "single",
                        "enableTime": true,
                        "noCalendar": false,
                        "format": "DD/MM/YYYY",
                        "hourIncrement": 1,
                        "minuteIncrement": 1,
                        "time_24hr": false,
                        "minDate": "1870-01-01T11:59:00-04:56",
                        "disableWeekends": false,
                        "disableWeekdays": false,
                        "maxDate": null
                    }
                },
                {
                    "label": "Parentesco",
                    "widget": "choicesjs",
                    "placeholder": "Elige el parentesco",
                    "tableView": true,
                    "data": {
                        "values": [{
                            "label": "CÓNYUGE",
                            "value": "C"
                        },
                        {
                            "label": "HIJO(A)",
                            "value": "H"
                        }
                        ]
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "parentescoAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Género",
                    "widget": "choicesjs",
                    "placeholder": "Elige el género",
                    "tableView": true,
                    "data": {
                        "values": [{
                            "label": "Femenino",
                            "value": "M"
                        },
                        {
                            "label": "Masculino",
                            "value": "H"
                        }
                        ]
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "generoAsegurado",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Acciones",
                    "key": "acciones-asegurados",
                    "type": "hidden",
                    "input": true,
                    "tableView": false
                }
                ]
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de los asegurados adicionales",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "heading3",
                    "text": "Asegurados adicionales para mascotas",
                    "spans": [{
                        "start": 0,
                        "end": 36,
                        "type": "strong"
                    }]
                },
                {
                    "type": "paragraph",
                    "text": "La designación de beneficiarios para esta cobertura es recíproca, es decir, en caso de fallecimiento del cónyuge, se entrega el 100% de la suma asegurada al titular.",
                    "spans": []
                }
                ],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "title": "Mascotas",
                "breadcrumbClickable": true,
                "buttonSettings": {
                    "previous": true,
                    "cancel": true,
                    "next": true
                },
                "scrollToTop": false,
                "customClass": "repeatableContent",
                "collapsible": false,
                "key": "mascotas",
                "properties": {
                    "nameRelatedProperty": "coberturas",
                    "valueRelatedKey": "9204"
                },
                "type": "panel",
                "label": "Mascotas",
                "input": false,
                "tableView": false,
                "components": [{
                    "label": "Tipo de mascota",
                    "widget": "choicesjs",
                    "placeholder": "Elige tipo de mascota",
                    "tableView": true,
                    "data": {
                        "values": [{
                            "label": "Perro",
                            "value": "P"
                        },
                        {
                            "label": "Gato",
                            "value": "G"
                        }
                        ]
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "tipoDeMascota",
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Nombre",
                    "placeholder": "Ej. Rocky",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un nombre valido",
                        "minLength": 1,
                        "maxLength": 20
                    },
                    "key": "nombreMascota",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Raza",
                    "placeholder": "Digita raza de tu mascota",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingrese una raza valida",
                        "minLength": 1,
                        "maxLength": 20
                    },
                    "key": "raza",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Edad",
                    "placeholder": "Digita edad de tu mascota",
                    "tooltip": "No se puede registrar una mascota de más de 15 años",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^([1-9]|[0-1][0-5])$",
                        "customMessage": "Dato no válido",
                        "minLength": 1,
                        "maxLength": 2
                    },
                    "key": "edad",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Genero",
                    "widget": "choicesjs",
                    "placeholder": "Elige el género de tu mascota",
                    "tableView": true,
                    "data": {
                        "values": [{
                            "label": "Hembra",
                            "value": "M"
                        },
                        {
                            "label": "Macho",
                            "value": "H"
                        }
                        ]
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "generoMascota",
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Acciones",
                    "key": "acciones-mascotas",
                    "type": "hidden",
                    "input": true,
                    "tableView": false
                }
                ]
            }],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        },
        {
            "primary": {
                "associated_group": "step_asegurados",
                "title": [{
                    "type": "heading6",
                    "text": "Información de el o los beneficiarios",
                    "spans": []
                }],
                "collapse_description": true,
                "description": [{
                    "type": "paragraph",
                    "text": "Si estás considerando renombrar a un menor de edad como beneficiario es importante que consideres la siguiente información.",
                    "spans": []
                }],
                "collapsable_text": [{
                    "type": "paragraph",
                    "text": "Al nombrar beneficiarios menores de edad no se debe señalar a un mayor de edad como representante del menor, para que en su representación cobre la indemnización; ya que la legislación señala la forma en que deben designarse tutores, albaceas u otros cargos similares y no consideran al contrato de seguro como el instrumento adecuando para tal designación. Si designas a un mayor de edad como representante del menor beneficiario durante su minoría de edad, legalmente puede implicar que se nombra como beneficiario al mayor de edad, quien solo tendrá una obligación moral, pues la designación que se hace de beneficiarios en un contrato de seguro le concede el derecho incondicionado de disponer de la suma asegurada.",
                    "spans": []
                }],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "Si",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "title": "Beneficiarios",
                "breadcrumbClickable": true,
                "buttonSettings": {
                    "previous": true,
                    "cancel": true,
                    "next": true
                },
                "scrollToTop": false,
                "customClass": "repeatableContent",
                "collapsible": false,
                "key": "beneficiarios",
                "type": "panel",
                "label": "Panel",
                "input": false,
                "tableView": false,
                "components": [{
                    "label": "Nombre",
                    "placeholder": "Ej. Juan",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un nombre valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "nombreBeneficiario",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Apellido paterno",
                    "placeholder": "Ej. Rodríguez",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un apellido valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "apellidoPaternoBeneficiario",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Apellido materno",
                    "placeholder": "Ej. Martínez",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                        "customMessage": "Ingresa un apellido valido",
                        "minLength": 1,
                        "maxLength": 100
                    },
                    "key": "apellidoMaternoBeneficiario",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Fecha de nacimiento",
                    "format": "DD/MM/YYYY",
                    "tableView": false,
                    "enableMinDateInput": false,
                    "datePicker": {
                        "minDate": "1870-01-01T11:59:00-04:56",
                        "disableWeekends": false,
                        "disableWeekdays": false
                    },
                    "enableMaxDateInput": false,
                    "validate": {
                        "required": true,
                        "customMessage": "Ingresa una fecha válida"
                    },
                    "key": "fechaNacimientoBeneficiario",
                    "properties": {
                        "parentContainer": "asegurados"
                    },
                    "type": "datetime",
                    "input": true,
                    "widget": {
                        "type": "calendar",
                        "displayInTimezone": "viewer",
                        "locale": "en",
                        "useLocaleSettings": false,
                        "allowInput": true,
                        "mode": "single",
                        "enableTime": true,
                        "noCalendar": false,
                        "format": "DD/MM/YYYY",
                        "hourIncrement": 1,
                        "minuteIncrement": 1,
                        "time_24hr": false,
                        "minDate": "1870-01-01T11:59:00-04:56",
                        "disableWeekends": false,
                        "disableWeekdays": false,
                        "maxDate": null
                    }
                },
                {
                    "label": "Parentesco",
                    "widget": "choicesjs",
                    "placeholder": "Elige parentesco",
                    "tableView": true,
                    "dataSrc": "json",
                    "data": {
                        "json": {
                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/parentescos",
                            "method": "GET",
                            "headers": {
                                "Content-Type": "application/json",
                                "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                            },
                            "body": {}
                        }
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "parentescoBeneficiario",
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Genero",
                    "widget": "choicesjs",
                    "placeholder": "Elige género",
                    "tableView": true,
                    "data": {
                        "values": [{
                            "label": "Femenino ",
                            "value": "M"
                        },
                        {
                            "label": "Masculino",
                            "value": "H"
                        }
                        ]
                    },
                    "validate": {
                        "required": true
                    },
                    "key": "generoBeneficiario",
                    "type": "select",
                    "input": true
                },
                {
                    "label": "Porcentaje",
                    "placeholder": "Ej. 100",
                    "tooltip": "Debes ingresar un valor entre 1 y 100, recuerda distribuir el 100% correctamente en todos tus beneficiarios.",
                    "tableView": true,
                    "validate": {
                        "required": true,
                        "pattern": "^[0-9]*$",
                        "customMessage": "Dato no válido",
                        "minLength": 1,
                        "maxLength": 3
                    },
                    "key": "porcentajeBeneficiario",
                    "type": "textfield",
                    "input": true
                },
                {
                    "label": "Acciones",
                    "key": "acciones-beneficiarios",
                    "type": "hidden",
                    "input": true,
                    "tableView": false
                }
                ]
            },
            {
                "label": "Mensaje modal - Error en porcentaje acumulado",
                "defaultValue": "Recuerda que el porcentaje acumulado debe sumar el 100%",
                "key": "mensajeErrorPorcentaje",
                "type": "hidden",
                "input": true,
                "tableView": false
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }
        ]
    },
    {
        "key_step": "step_emision_contratante",
        "name": "Emisión Contratante",
        "questions": [{
            "primary": {
                "associated_group": "step_emision_contratante",
                "title": [{
                    "type": "heading6",
                    "text": "Datos del contratante",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": "50-50",
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/find-form-medical\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Los datos del contratante son los mismos que los del asegurado",
                "customClass": "checkClassic",
                "tableView": false,
                "defaultValue": true,
                "key": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
                "properties": {
                    "autocomplete": "true"
                },
                "type": "checkbox",
                "input": true
            },
            {
                "label": "TIPO DE PERSONA",
                "optionsLabelPosition": "right",
                "customClass": "radioText",
                "inline": false,
                "tableView": false,
                "values": [{
                    "label": "PERSONA FÍSICA",
                    "value": "personaFisica",
                    "shortcut": ""
                },
                {
                    "label": "PERSONA MORAL",
                    "value": "personaMoral",
                    "shortcut": ""
                }
                ],
                "customDefaultValue": "tipoDePersona",
                "validate": {
                    "required": true
                },
                "key": "tipoDePersonaContratante",
                "conditional": {
                    "show": true,
                    "when": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
                    "eq": "false"
                },
                "type": "radio",
                "input": true,
                "defaultValue": "personaFisica"
            },
            {
                "label": "RFC",
                "placeholder": "Digita el RFC",
                "tableView": true,
                "customDefaultValue": "identificadorPersona",
                "validate": {
                    "required": true,
                    "pattern": "^[A-Z0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 13,
                    "maxLength": 13
                },
                "key": "identificadorPersonaContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "RFC",
                "placeholder": "Digita el RFC",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[A-Z0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 12,
                    "maxLength": 12
                },
                "key": "identificadorPersonaContratanteMoral",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaMoral"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Validar RFC",
                "showValidations": false,
                "tableView": false,
                "key": "validarRfcContratante",
                "conditional": {
                    "show": true,
                    "when": "losDatosDelContratanteSonLosMismosQueLosDelAsegurado",
                    "eq": "false"
                },
                "logic": [{
                    "name": "api_service",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/personas?tipoIdentificadorPersona=1&identificadorPersonaContratante=value",
                            "method": "GET",
                            "headers": {
                                "Content-Type": "application/json",
                                "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                            },
                            "body": {},
                            "action": "autocomplete",
                            "key": "Contratante"
                        }
                    },
                    "actions": [],
                    "isRowSelected": true
                }],
                "type": "button",
                "input": true,
                "saveOnEnter": false
            },
            {
                "type": "fakeField"
            },
            {
                "label": "Nombre",
                "placeholder": "Ej. Juan",
                "tableView": true,
                "customDefaultValue": "nombre",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "primerNombreContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Apellido paterno",
                "placeholder": "Ej. Rodriguez",
                "tableView": true,
                "customDefaultValue": "primerApellido",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "primerApellidoContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Apellido materno",
                "placeholder": "Ej. Martínez",
                "tableView": true,
                "customDefaultValue": "segundoApellido",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido"
                },
                "key": "segundoApellidoContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "CURP",
                "placeholder": "Digita el CURP",
                "tableView": true,
                "customDefaultValue": "curp",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-Z0-9]+$",
                    "customMessage": "Tu CURP debe tener longitud de 18 caracteres",
                    "minLength": 18,
                    "maxLength": 18
                },
                "key": "curpContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Género",
                "widget": "choicesjs",
                "placeholder": "Elige el género",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Femenino",
                        "value": "M"
                    },
                    {
                        "label": "Masculino",
                        "value": "H"
                    }
                    ]
                },
                "customDefaultValue": "genero",
                "validate": {
                    "required": true
                },
                "key": "sexoContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "select",
                "input": true
            },
            {
                "label": "Fecha de nacimiento",
                "format": "DD/MM/YYYY",
                "tableView": false,
                "enableMinDateInput": false,
                "datePicker": {
                    "minDate": "1870-01-01T11:59:00-04:56",
                    "maxDate": "2021-01-01T12:00:00-05:00",
                    "disableWeekends": false,
                    "disableWeekdays": false
                },
                "enableMaxDateInput": false,
                "customDefaultValue": "fechaNacimiento",
                "validate": {
                    "required": true
                },
                "key": "fechaNacimientoContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "datetime",
                "input": true,
                "widget": {
                    "type": "calendar",
                    "displayInTimezone": "viewer",
                    "locale": "en",
                    "useLocaleSettings": false,
                    "allowInput": true,
                    "mode": "single",
                    "enableTime": true,
                    "noCalendar": false,
                    "format": "DD/MM/YYYY",
                    "hourIncrement": 1,
                    "minuteIncrement": 1,
                    "time_24hr": false,
                    "minDate": "1870-01-01T11:59:00-04:56",
                    "disableWeekends": false,
                    "disableWeekdays": false,
                    "maxDate": "2021-01-01T12:00:00-05:00"
                }
            },
            {
                "label": "Estado Civil",
                "widget": "choicesjs",
                "placeholder": "Elige estado civil",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Soltero/a.",
                        "value": "S"
                    },
                    {
                        "label": "Casado/a.",
                        "value": "C"
                    }
                    ]
                },
                "customDefaultValue": "estadoCivil",
                "validate": {
                    "required": true
                },
                "key": "estadoCivilContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "select",
                "input": true
            },
            {
                "label": "País de Nacimiento",
                "widget": "choicesjs",
                "placeholder": "Elige tu país de nacimiento",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/paises",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "pais",
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "paisNacimientoContratante",
                "type": "select",
                "input": true
            },
            {
                "label": "Lugar de Nacimiento",
                "placeholder": "Lugar de Nacimiento",
                "tableView": true,
                "customDefaultValue": "lugarNacimiento",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 40
                },
                "key": "lugarNacimientoContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Nacionalidad",
                "widget": "choicesjs",
                "placeholder": "Elige tu nacionalidad",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/nacionalidades",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "pais",
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "nacionalidadContratante",
                "type": "select",
                "input": true
            },
            {
                "label": "Ocupación o profesión",
                "widget": "choicesjs",
                "placeholder": "Elige ocupación",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/catalogos/ocupaciones",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "claveOcupacion",
                "validate": {
                    "required": true
                },
                "key": "ocupacionProfesionContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "select",
                "input": true
            },
            {
                "label": "Ingresos mensuales",
                "placeholder": "Ej. 8599",
                "tableView": true,
                "customDefaultValue": "ingresosMensuales",
                "validate": {
                    "required": true,
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 7
                },
                "key": "ingresosMensualesContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "INGRESA TU E-MAIL",
                "placeholder": "ejemplo@gmail.com",
                "tableView": true,
                "customDefaultValue": "email",
                "validate": {
                    "required": true,
                    "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                    "customMessage": "Ingrese un correo electrónico valido",
                    "minLength": 1,
                    "maxLength": 100
                },
                "key": "emailContratante",
                "type": "textfield",
                "input": true
            },
            {
                "label": "TELÉFONO CELULAR",
                "placeholder": "Ej. 55 5723 799",
                "tableView": true,
                "customDefaultValue": "telefono",
                "validate": {
                    "required": true,
                    "pattern": "^(?!.*?([1234567890])\\1{9,}|(1234567890))[0-9]*$",
                    "customMessage": "Ingresa un número telefónico valido",
                    "minLength": 10,
                    "maxLength": 10
                },
                "key": "telefonoCelularContratante",
                "type": "textfield",
                "input": true
            },
            {
                "label": "Nombre del apoderado legal ",
                "placeholder": "Ej. Juan Martínez Gil",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "maxLength": 60
                },
                "key": "nombreDelApoderadoLegalContratante",
                "conditional": {
                    "show": true,
                    "when": "anadirApoderadoLegalContratante",
                    "eq": "true"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Fecha de nacimiento del apoderado",
                "format": "DD/MM/YYYY",
                "tableView": false,
                "enableMinDateInput": false,
                "datePicker": {
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "maxDate": "2021-01-01T12:00:00-05:00",
                    "disableWeekends": false,
                    "disableWeekdays": false
                },
                "enableMaxDateInput": false,
                "validate": {
                    "required": true,
                    "customMessage": "INGRESA UNA FECHA VÁLIDA"
                },
                "key": "fechaDeNacimientoDelApoderadoContratante",
                "conditional": {
                    "show": true,
                    "when": "anadirApoderadoLegalContratante",
                    "eq": "true"
                },
                "type": "datetime",
                "input": true,
                "widget": {
                    "type": "calendar",
                    "displayInTimezone": "viewer",
                    "locale": "en",
                    "useLocaleSettings": false,
                    "allowInput": true,
                    "mode": "single",
                    "enableTime": true,
                    "noCalendar": false,
                    "format": "DD/MM/YYYY",
                    "hourIncrement": 1,
                    "minuteIncrement": 1,
                    "time_24hr": false,
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "disableWeekends": false,
                    "disableWeekdays": false,
                    "maxDate": "2021-01-01T12:00:00-05:00"
                }
            },
            {
                "label": "Añadir apoderado legal",
                "customClass": "checkClassic",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true
                },
                "key": "anadirApoderadoLegalContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaMoral"
                },
                "type": "checkbox",
                "input": true
            },
            {
                "label": "Tipo de identificación entregada",
                "widget": "choicesjs",
                "placeholder": "Elige tipo de identificación",
                "tableView": true,
                "data": {
                    "values": [{
                        "label": "Credencial para votar vigente",
                        "value": "credencialParaVotarVigente"
                    },
                    {
                        "label": "Pasaporte vigente",
                        "value": "pasaporteVigente"
                    }
                    ]
                },
                "customDefaultValue": "tipoDeIdentificacionEntregada",
                "validate": {
                    "required": true
                },
                "key": "tipoDeIdentificacionEntregadaContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "select",
                "input": true
            },
            {
                "label": "Folio de identificación entregada",
                "placeholder": "Digita folio de identificación",
                "tableView": true,
                "customDefaultValue": "folioDeIdentificacionEntregada",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 30
                },
                "key": "folioDeIdentificacionEntregadaContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaFisica"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "¿Residente fiscal en el extranjero?",
                "tableView": false,
                "defaultValue": false,
                "customDefaultValue": "residenteFiscalExtranjero",
                "validate": {
                    "required": true,
                    "customMessage": "Error"
                },
                "key": "residenteFiscalExtranjeroContratante",
                "conditional": {
                    "show": false,
                    "when": "paisNacimientoContratante",
                    "eq": "052"
                },
                "type": "checkbox",
                "input": true
            },
            {
                "label": "País donde es residente fiscal",
                "widget": "choicesjs",
                "placeholder": "Elija el país",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/locaciones/paises",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "paisResidenteFiscal",
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "paisResidenteFiscalContratante",
                "conditional": {
                    "show": true,
                    "when": "residenteFiscalExtranjeroContratante",
                    "eq": "true"
                },
                "type": "select",
                "input": true
            },
            {
                "label": "N° Identificación en el extranjero",
                "placeholder": "Ej SS1035439311",
                "tableView": true,
                "customDefaultValue": "nIdentificacionEnElExtranjero",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 30
                },
                "key": "nIdentificacionEnElExtranjeroContratante",
                "conditional": {
                    "show": true,
                    "when": "residenteFiscalExtranjeroContratante",
                    "eq": "true"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Dirección",
                "tableView": true,
                "customDefaultValue": "direccion",
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 50
                },
                "key": "direccionContratante",
                "type": "textfield",
                "input": true,
                "placeholder": "Ej. Av Benito J No 90"
            },
            {
                "label": "No. Exterior",
                "placeholder": "Ej. 451",
                "tableView": true,
                "customDefaultValue": "nExterior",
                "validate": {
                    "required": true,
                    "pattern": "^(0|[1-9][0-9]*)$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 6
                },
                "key": "nExteriorContratante",
                "type": "textfield",
                "input": true
            },
            {
                "label": "No. interior",
                "placeholder": "Ej. 102",
                "tableView": true,
                "customDefaultValue": "nIterior",
                "validate": {
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 1,
                    "maxLength": 6
                },
                "key": "nIteriorContratante",
                "type": "textfield",
                "input": true
            },
            {
                "label": "Código postal",
                "placeholder": "Ej. 43540",
                "tableView": true,
                "customDefaultValue": "codigoPostal",
                "validate": {
                    "required": true,
                    "pattern": "^[0-9]*$",
                    "customMessage": "Dato no válido",
                    "minLength": 5,
                    "maxLength": 5
                },
                "key": "codigoPostalContratante",
                "type": "textfield",
                "input": true
            },
            {
                "label": "Estado",
                "widget": "choicesjs",
                "placeholder": "Elige el estado",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostalContratante=value&catalogo=ESTADO",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "estadoAsegurado",
                "validate": {
                    "required": true
                },
                "key": "estadoContratante",
                "type": "select",
                "input": true
            },
            {
                "label": "Colonia",
                "widget": "choicesjs",
                "placeholder": "Elige la colonia",
                "tableView": true,
                "dataSrc": "json",
                "data": {
                    "json": {
                        "url": "https://apimanagement-devqa.azure-api.net/catalogos-qa/codigopostal?codigoPostalContratante=value&catalogo=COLONIA",
                        "method": "GET",
                        "headers": {
                            "Content-Type": "application/json",
                            "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                        },
                        "body": {}
                    }
                },
                "customDefaultValue": "coloniaAsegurado",
                "validate": {
                    "required": true,
                    "customMessage": "Este campo es requerido"
                },
                "key": "coloniaContratante",
                "type": "select",
                "input": true
            },
            {
                "label": "Razón social",
                "placeholder": "Digita razón social",
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                    "customMessage": "Dato no válido",
                    "maxLength": 60
                },
                "key": "razonSocialContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaMoral"
                },
                "type": "textfield",
                "input": true
            },
            {
                "label": "Fecha de constitución",
                "format": "DD/MM/YYYY",
                "tableView": false,
                "enableMinDateInput": false,
                "datePicker": {
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "maxDate": "2021-01-01T12:00:00-05:00",
                    "disableWeekends": false,
                    "disableWeekdays": false
                },
                "enableMaxDateInput": false,
                "validate": {
                    "customMessage": "INGRESA UNA FECHA VÁLIDA"
                },
                "key": "fechaDeConstitucionContratante",
                "conditional": {
                    "show": true,
                    "when": "tipoDePersonaContratante",
                    "eq": "personaMoral"
                },
                "type": "datetime",
                "input": true,
                "widget": {
                    "type": "calendar",
                    "displayInTimezone": "viewer",
                    "locale": "en",
                    "useLocaleSettings": false,
                    "allowInput": true,
                    "mode": "single",
                    "enableTime": true,
                    "noCalendar": false,
                    "format": "DD/MM/YYYY",
                    "hourIncrement": 1,
                    "minuteIncrement": 1,
                    "time_24hr": false,
                    "minDate": "1870-01-01T12:00:00-04:56",
                    "disableWeekends": false,
                    "disableWeekdays": false,
                    "maxDate": "2021-01-01T12:00:00-05:00"
                }
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }]
    },
    {
        "key_step": "step_cuestionario_medico",
        "name": "Cuestionario Médico",
        "questions": [{
            "primary": {
                "associated_group": "step_cuestionario_medico",
                "title": [{
                    "type": "heading6",
                    "text": "Cuestionario Médico",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [{
                    "type": "paragraph",
                    "text": "Para continuar con la contratación del seguro de vida Plan Vive, es necesario completar un breve cuestionario de salud. Ten a mano tu identificación oficial.",
                    "spans": []
                }],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "3",
                "relationship_columns": null,
                "opciones_servicio": null,
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": null,
                "service_btn": "{\n\"titleBtn\": \"Cotizar\",\n \"url\": \"https://6272e8776b04786a09fece26.mockapi.io/api/v1/cotizacion\",\n \"method\": \"POST\",\n \"headers\": {\n \"Content-Type\": \"application/json\",\n \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n },\n \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Estado",
                "hidden": true,
                "tableView": true,
                "validate": {
                    "required": true,
                    "pattern": "(Elegible)",
                    "customMessage": "Debes completar el cuestionario para continuar"
                },
                "key": "estadoCuestionario",
                "type": "textfield",
                "input": true
            },
            {
                "type": "fakeField"
            },
            {
                "type": "fakeField"
            },
            {
                "label": "Completar Cuestionario",
                "action": "event",
                "showValidations": false,
                "tableView": false,
                "key": "completarCuestionario",
                "logic": [{
                    "name": "logic",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "field": "urlCuestionariosMedicos",
                            "action": "redirect"
                        }
                    },
                    "actions": []
                }],
                "type": "button",
                "input": true
            },
            {
                "label": "Copiar enlace",
                "action": "event",
                "showValidations": false,
                "tableView": false,
                "key": "copiarEnlace",
                "type": "button",
                "input": true,
                "logic": [{
                    "name": "logic",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "field": "urlCuestionariosMedicos",
                            "action": "copy"
                        }
                    },
                    "actions": []
                }]
            },
            {
                "label": "Enviar enlace",
                "action": "event",
                "showValidations": false,
                "tableView": false,
                "key": "enviarEnlace",
                "logic": [{
                    "name": "api_service",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "url": "https://apimanagement-devqa.azure-api.net/utilerias-qa/send/mail",
                            "method": "POST",
                            "headers": {
                                "Content-Type": "application/json",
                                "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589",
                                "apiKeySendGrid": "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"
                            },
                            "body": {
                                "to": "",
                                "from": "noe.santiago@segurossura.com.mx",
                                "templateId": "d-d703cc789cbf47d098faeace09bc14f3",
                                "dynamicTemplateData": {
                                    "NOMBRE_COMPLETO": "Juanito Banana",
                                    "URL": "http://google.com"
                                }
                            },
                            "action": "send",
                            "field": "urlCuestionariosMedicos"
                        }
                    },
                    "actions": []
                }],
                "type": "button",
                "input": true
            },
            {
                "label": "Actualizar",
                "showValidations": false,
                "tableView": false,
                "key": "actualizar",
                "logic": [{
                    "name": "api_service",
                    "trigger": {
                        "type": "json",
                        "json": {
                            "url": "https://apimanagement-devqa.azure-api.net/cuestionariosmedicos-qa/status",
                            "method": "POST",
                            "headers": {
                                "Content-Type": "application/json",
                                "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                            },
                            "body": {},
                            "action": "update",
                            "fieldBody": "urlCuestionariosMedicos",
                            "fieldUpdate": "estadoCuestionario"
                        }
                    },
                    "actions": [],
                    "isRowSelected": true
                }],
                "type": "button",
                "input": true,
                "saveOnEnter": false
            },
            {
                "label": "Mensaje modal - Elegible con extraprima",
                "defaultValue": "Con base en la información ingresada y el momento de vida en el que te encuentras, el costo del seguro se ha actualizado.",
                "key": "mensajeModalElegibleConExtraprima",
                "type": "hidden",
                "input": true,
                "tableView": false
            },
            {
                "label": "Mensaje modal - No Elegible",
                "defaultValue": "Con base en la información ingresada lamentamos informarle que no contamos con un seguro de vida que se adecue a tu perfil ",
                "key": "mensajeModalNoElegible",
                "type": "hidden",
                "input": true,
                "tableView": false
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }]
    },
    {
        "key_step": "step_pasarela_pago",
        "name": "Periodicidad de pago",
        "questions": [{
            "primary": {
                "associated_group": "step_pasarela_pago",
                "title": [{
                    "type": "heading6",
                    "text": "Periodicidad de pago",
                    "spans": []
                }],
                "collapse_description": false,
                "description": [],
                "collapsable_text": [],
                "buttonnext": "Si",
                "returnbutton": "Si",
                "sidebar": "Si",
                "enable_email": "No",
                "columns": "1",
                "relationship_columns": null,
                "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/emit-insurance\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n   },\n  \"body\": {}\n}",
                "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {\n\"oficina\": 1,\n\"ramo\": 901,\n\"estado\": \"\",\n\"poliza\": \"\",\n\"suplemento\": 0,\n\"rfc\": \"XXXXXXX\"\n}\n}",
                "opciones_servicio_segundo_plano": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-qa/plan-vive/check-payment-status?referencia={referencia}\",\n  \"method\": \"GET\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n   },\n  \"body\": {}\n}"
            },
            "newItems": [{
                "label": "Periodicidad",
                "optionsLabelPosition": "right",
                "customClass": "selectboxesPeriodicity",
                "inline": false,
                "tableView": false,
                "defaultValue": 12,
                "values": [{
                    "label": "Anual",
                    "value": "12",
                    "shortcut": ""
                },
                {
                    "label": "Semestral",
                    "value": "6",
                    "shortcut": ""
                },
                {
                    "label": "Trimestral",
                    "value": "3",
                    "shortcut": ""
                },
                {
                    "label": "Mensual",
                    "value": "1",
                    "shortcut": ""
                }
                ],
                "key": "periodicidadPagoId",
                "properties": {
                    "1": "0.5",
                    "3": "0.3",
                    "6": "0.2",
                    "12": "0"
                },
                "type": "radio",
                "input": true
            },
            {
                "label": "Pago",
                "optionsLabelPosition": "right",
                "customClass": "selectboxesPayment",
                "tableView": false,
                "defaultValue": {
                    "tarjetaCredito": false,
                    "tarjetaDebito": false,
                    "transferencia": false,
                    "tarjetaDeCredito": false,
                    "tarjetaDeD": false,
                    "tarjetaDeDe": false,
                    "tarjetaDeDeb": false,
                    "tarjetaDeDebi": false,
                    "tarjetaDeDebito": false,
                    "t": false,
                    "tra": false,
                    "trans": false,
                    "transfer": false,
                    "transfere": false,
                    "transferenc": false
                },
                "values": [{
                    "label": "Tarjeta de crédito",
                    "value": "tarjetaDeCredito",
                    "shortcut": ""
                },
                {
                    "label": "Tarjeta de débito",
                    "value": "tarjetaDeDebito",
                    "shortcut": ""
                },
                {
                    "label": "Transferencia",
                    "value": "transferencia",
                    "shortcut": ""
                }
                ],
                "validate": {
                    "required": true
                },
                "key": "pago",
                "properties": {
                    "tarjetaDeCredito": "https://images.prismic.io/cotizadores-suramex-qa/be18891d-6696-4503-a3b6-62469ae7ed8f_payment-1.png?auto=compress,format",
                    "tarjetaDeDebito": "https://images.prismic.io/cotizadores-suramex-qa/7cdf2b05-d3fe-41ee-a281-47a27627dd9d_payment-2.png?auto=compress,format",
                    "transferencia": "https://images.prismic.io/cotizadores-suramex-qa/6808a94b-47ee-4964-b113-d78383a19727_payment-3.png?auto=compress,format"
                },
                "type": "selectboxes",
                "input": true,
                "inputType": "checkbox"
            },
            {
                "label": "Acepto recibir la póliza al correo electrónico registrado.",
                "customClass": "checkClassic",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true
                },
                "key": "aceptOne",
                "type": "checkbox",
                "input": true
            },
            {
                "label": "Acepto el Aviso de Privacidad y los Términos y Condiciones de uso de medios electrónicos.",
                "customClass": "checkClassic",
                "tableView": false,
                "defaultValue": false,
                "validate": {
                    "required": true
                },
                "key": "aceptTwo",
                "type": "checkbox",
                "input": true
            }
            ],
            "slice_type": "step__grupopregunta",
            "slice_label": null
        }]
    }
    ],
    currentStep: 0,
    currentQuestion: 0,
    numberQuestionsStep: 1,
    isGoToBack: false,
};

export const formStatusInsureds = {
    steps: [
        {
            "key_step": "step_personales",
            "name": "Algunos datos",
            "questions": [
                {
                    "primary": {
                        "associated_group": "step_personales",
                        "title": [
                            {
                                "type": "heading6",
                                "text": "Hola, para iniciar ingresa algunos datos personales",
                                "spans": []
                            }
                        ],
                        "collapse_description": false,
                        "description": [],
                        "collapsable_text": [],
                        "buttonnext": "Si",
                        "returnbutton": "Si",
                        "sidebar": "Contenido",
                        "barrainfosuperior": "No",
                        "enable_email": "No",
                        "columns": "2",
                        "relationship_columns": "50-50",
                        "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/hogar/validate-form\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                        "sidebar_service": null,
                        "service_btn": null,
                        "opciones_servicio_segundo_plano": null,
                        "finalmodal": null,
                        "sidebarimg": {
                            "dimensions": {
                                "width": 249,
                                "height": 144
                            },
                            "alt": "Nuevo texto",
                            "copyright": null,
                            "url": "https://portal-cotizacion-suramex.cdn.prismic.io/portal-cotizacion-suramex/9f1e57b9-61db-491f-8d6b-6d98d2f7443f_card-recuperar.svg"
                        }
                    },
                    "newItems": [
                        {
                            "label": "FECHA DE NACIMIENTO",
                            "format": "DD/MM/YYYY",
                            "tableView": false,
                            "datePicker": {
                                "disableWeekends": false,
                                "disableWeekdays": false,
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "maxDate": "2022-01-06T12:00:00-05:00"
                            },
                            "enableTime": false,
                            "timePicker": {
                                "showMeridian": false
                            },
                            "validate": {
                                "required": true,
                                "customMessage": "INGRESA UNA FECHA VÁLIDA"
                            },
                            "enableMinDateInput": false,
                            "enableMaxDateInput": false,
                            "key": "fechaNacimiento",
                            "type": "datetime",
                            "input": true,
                            "widget": {
                                "type": "calendar",
                                "displayInTimezone": "viewer",
                                "locale": "en",
                                "useLocaleSettings": false,
                                "allowInput": true,
                                "mode": "single",
                                "enableTime": false,
                                "noCalendar": false,
                                "format": "DD/MM/YYYY",
                                "hourIncrement": 1,
                                "minuteIncrement": 1,
                                "time_24hr": true,
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "disableWeekends": false,
                                "disableWeekdays": false,
                                "maxDate": "2022-01-06T12:00:00-05:00"
                            }
                        },
                        {
                            "label": "CÓDIGO POSTAL",
                            "placeholder": "Ej. 43540",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 5,
                                "maxLength": 5,
                                "pattern": "^[0-9]*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "codigoPostal",
                            "type": "textfield",
                            "input": true,
                            "keyModified": true
                        },
                        {
                            "label": "Folio",
                            "key": "folio",
                            "type": "hidden",
                            "input": true,
                            "tableView": false
                        },
                        {
                            "label": "Status",
                            "key": "status",
                            "type": "hidden",
                            "input": true,
                            "tableView": false,
                            "defaultValue": "ACEPTAR"
                        },
                        {
                            "label": "Aliado",
                            "defaultValue": "COTIZADORES_SURA",
                            "key": "claveAliado",
                            "type": "hidden",
                            "input": true,
                            "tableView": false
                        }
                    ],
                    "slice_type": "step__grupopregunta",
                    "slice_label": null
                },
                {
                    "primary": {
                        "associated_group": "step_personales",
                        "title": [
                            {
                                "type": "heading6",
                                "text": "Selecciona tu género",
                                "spans": []
                            }
                        ],
                        "collapse_description": false,
                        "description": [],
                        "collapsable_text": [],
                        "buttonnext": "Si",
                        "returnbutton": "Si",
                        "sidebar": "Contenido",
                        "barrainfosuperior": "No",
                        "enable_email": "No",
                        "columns": "1",
                        "relationship_columns": null,
                        "opciones_servicio": null,
                        "sidebar_service": null,
                        "service_btn": null,
                        "opciones_servicio_segundo_plano": null,
                        "finalmodal": null,
                        "sidebarimg": {
                            "dimensions": {
                                "width": 247,
                                "height": 315
                            },
                            "alt": "Recuerda que tu información esta protegida con SURA",
                            "copyright": null,
                            "url": "https://images.prismic.io/portal-cotizacion-suramex/f63088e8-27ac-4e9c-81e9-c3cecf935dab_sidebar.jpg?auto=compress,format"
                        }
                    },
                    "newItems": [
                        {
                            "label": "Genero",
                            "optionsLabelPosition": "right",
                            "customClass": "radioImage",
                            "inline": false,
                            "tableView": false,
                            "values": [
                                {
                                    "label": "Femenino",
                                    "value": "M",
                                    "shortcut": ""
                                },
                                {
                                    "label": "Masculino",
                                    "value": "H",
                                    "shortcut": ""
                                }
                            ],
                            "validate": {
                                "required": true
                            },
                            "key": "genero",
                            "properties": {
                                "H": "https://images.prismic.io/portal-cotizacion-suramex/a78811dd-60d4-4924-9ec2-87820d889191_hombre.gif",
                                "M": "https://images.prismic.io/portal-cotizacion-suramex/8234458f-0287-4fe3-9491-e9d5058131e0_mujer.gif"
                            },
                            "type": "radio",
                            "input": true
                        }
                    ],
                    "slice_type": "step__grupopregunta",
                    "slice_label": null
                },
                {
                    "primary": {
                        "associated_group": "step_personales",
                        "title": [
                            {
                                "type": "heading6",
                                "text": "¿A quién quieres proteger?",
                                "spans": []
                            }
                        ],
                        "collapse_description": false,
                        "description": [],
                        "collapsable_text": [],
                        "buttonnext": "Si",
                        "returnbutton": "Si",
                        "sidebar": "Contenido",
                        "barrainfosuperior": "No",
                        "enable_email": "No",
                        "columns": "1",
                        "relationship_columns": null,
                        "opciones_servicio": null,
                        "sidebar_service": null,
                        "service_btn": null,
                        "opciones_servicio_segundo_plano": null,
                        "finalmodal": null,
                        "sidebarimg": {
                            "dimensions": {
                                "width": 247,
                                "height": 315
                            },
                            "alt": "Recuerda que tu información esta protegida con SURA",
                            "copyright": null,
                            "url": "https://images.prismic.io/portal-cotizacion-suramex/f63088e8-27ac-4e9c-81e9-c3cecf935dab_sidebar.jpg?auto=compress,format"
                        }
                    },
                    "newItems": [
                        {
                            "label": "Tipo asegurados",
                            "optionsLabelPosition": "right",
                            "customClass": "radioImage",
                            "inline": false,
                            "tableView": false,
                            "values": [
                                {
                                    "label": "Solo a ti",
                                    "value": "T",
                                    "shortcut": ""
                                },
                                {
                                    "label": "A ti y tu familia",
                                    "value": "F",
                                    "shortcut": ""
                                }
                            ],
                            "validate": {
                                "required": true
                            },
                            "key": "claveTipoAsegurados",
                            "properties": {
                                "T": "https://images.prismic.io/portal-cotizacion-suramex/a78811dd-60d4-4924-9ec2-87820d889191_hombre.gif",
                                "F": "https://images.prismic.io/portal-cotizacion-suramex/87e48b13-3d31-4233-b0f4-6d2e277de70f_familia.gif"
                            },
                            "type": "radio",
                            "input": true
                        }
                    ],
                    "slice_type": "step__grupopregunta",
                    "slice_label": null
                }
            ]
        },
        {
            "key_step": "step_asegurados",
            "name": "Asegurados",
            "questions": [
                {
                    "primary": {
                        "associated_group": "step_asegurados",
                        "title": [
                            {
                                "type": "heading6",
                                "text": "Agrega asegurados a tu cobertura",
                                "spans": []
                            }
                        ],
                        "collapse_description": false,
                        "description": [],
                        "collapsable_text": [],
                        "buttonnext": "Si",
                        "returnbutton": "Si",
                        "sidebar": "Contenido",
                        "barrainfosuperior": "No",
                        "enable_email": "No",
                        "columns": "1",
                        "relationship_columns": null,
                        "opciones_servicio": null,
                        "sidebar_service": null,
                        "service_btn": null,
                        "opciones_servicio_segundo_plano": null,
                        "finalmodal": null,
                        "sidebarimg": {
                            "dimensions": {
                                "width": 247,
                                "height": 315
                            },
                            "alt": "Recuerda que tu información esta protegida con SURA",
                            "copyright": null,
                            "url": "https://images.prismic.io/portal-cotizacion-suramex/f63088e8-27ac-4e9c-81e9-c3cecf935dab_sidebar.jpg?auto=compress,format"
                        }
                    },
                    "newItems": [
                        {
                            "title": "Asegurados",
                            "customClass": "insuredCards",
                            "collapsible": false,
                            "key": "asegurados",
                            "conditional": {
                                "show": true,
                                "when": "claveTipoAsegurados",
                                "eq": "F"
                            },
                            "type": "panel",
                            "label": "Panel",
                            "input": false,
                            "tableView": false,
                            "components": [
                                {
                                    "label": "Parentesco",
                                    "widget": "choicesjs",
                                    "placeholder": "Elige el parentesco",
                                    "tableView": true,
                                    "data": {
                                        "values": [
                                            {
                                                "label": "Cónyuge",
                                                "value": "C"
                                            },
                                            {
                                                "label": "Hijo(a)",
                                                "value": "H"
                                            }
                                        ]
                                    },
                                    "validate": {
                                        "required": true
                                    },
                                    "key": "parentescoAsegurado",
                                    "type": "select",
                                    "input": true,
                                    "keyModified": true
                                },
                                {
                                    "label": "Imágenes",
                                    "optionsLabelPosition": "right",
                                    "tableView": false,
                                    "values": [
                                        {
                                            "label": "Masculino",
                                            "value": "https://images.prismic.io/portal-cotizacion-suramex/a78811dd-60d4-4924-9ec2-87820d889191_hombre.gif",
                                            "shortcut": ""
                                        },
                                        {
                                            "label": "Femenino",
                                            "value": "https://images.prismic.io/portal-cotizacion-suramex/8234458f-0287-4fe3-9491-e9d5058131e0_mujer.gif",
                                            "shortcut": ""
                                        },
                                        {
                                            "label": "Hijo",
                                            "value": "https://images.prismic.io/portal-cotizacion-suramex/a56d3da6-83e3-4d03-9968-2fc644e31cc5_ninio.gif",
                                            "shortcut": ""
                                        },
                                        {
                                            "label": "Hija",
                                            "value": "https://images.prismic.io/portal-cotizacion-suramex/8aeb8aed-a96d-4246-9dad-f8aec46f5db8_ninia.gif",
                                            "shortcut": ""
                                        }
                                    ],
                                    "key": "img",
                                    "type": "selectboxes",
                                    "input": true,
                                    "inputType": "checkbox"
                                },
                                {
                                    "label": "Género",
                                    "widget": "choicesjs",
                                    "placeholder": "Elige el género",
                                    "tableView": true,
                                    "data": {
                                        "values": [
                                            {
                                                "label": "Femenino",
                                                "value": "M"
                                            },
                                            {
                                                "label": "Masculino",
                                                "value": "H"
                                            }
                                        ]
                                    },
                                    "validate": {
                                        "required": true
                                    },
                                    "key": "generoAsegurado",
                                    "properties": {
                                        "parentContainer": "asegurados"
                                    },
                                    "type": "select",
                                    "input": true,
                                    "keyModified": true
                                },
                                {
                                    "label": "Fecha de nacimiento",
                                    "format": "DD/MM/YYYY",
                                    "tableView": false,
                                    "datePicker": {
                                        "disableWeekends": false,
                                        "disableWeekdays": false,
                                        "minDate": "1870-01-01T12:00:00-04:56",
                                        "maxDate": "2022-01-06T12:00:00-05:00"
                                    },
                                    "enableTime": false,
                                    "timePicker": {
                                        "showMeridian": false
                                    },
                                    "validate": {
                                        "required": true,
                                        "customMessage": "Ingresa una fecha válida"
                                    },
                                    "enableMinDateInput": false,
                                    "enableMaxDateInput": false,
                                    "key": "fechaNacimientoAsegurado",
                                    "properties": {
                                        "C": "18-60",
                                        "H": "1-36",
                                        "difference": "10"
                                    },
                                    "type": "datetime",
                                    "input": true,
                                    "widget": {
                                        "type": "calendar",
                                        "displayInTimezone": "viewer",
                                        "locale": "en",
                                        "useLocaleSettings": false,
                                        "allowInput": true,
                                        "mode": "single",
                                        "enableTime": false,
                                        "noCalendar": false,
                                        "format": "DD/MM/YYYY",
                                        "hourIncrement": 1,
                                        "minuteIncrement": 1,
                                        "time_24hr": true,
                                        "minDate": "1870-01-01T12:00:00-04:56",
                                        "disableWeekends": false,
                                        "disableWeekdays": false,
                                        "maxDate": "2022-01-06T12:00:00-05:00"
                                    },
                                    "keyModified": true
                                }
                            ]
                        }
                    ],
                    "slice_type": "step__grupopregunta",
                    "slice_label": null
                }
            ]
        },
        {
            "key_step": "step_cotizacion",
            "name": "Cotización",
            "questions": [
                {
                    "primary": {
                        "associated_group": "step_cotizacion",
                        "title": [],
                        "collapse_description": false,
                        "description": [],
                        "collapsable_text": [],
                        "buttonnext": "Si",
                        "returnbutton": "Si",
                        "sidebar": "No",
                        "barrainfosuperior": "No",
                        "enable_email": "No",
                        "columns": "2",
                        "relationship_columns": "50-50",
                        "opciones_servicio": null,
                        "sidebar_service": null,
                        "service_btn": null,
                        "opciones_servicio_segundo_plano": null,
                        "finalmodal": null,
                        "sidebarimg": {}
                    },
                    "newItems": [
                        {
                            "label": "Nombre",
                            "placeholder": "Ej. Diana",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 100,
                                "pattern": "^[a-zA-Z]+$",
                                "customMessage": "Ingresa un nombre valido"
                            },
                            "key": "nombre",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "INGRESA TU E-MAIL",
                            "placeholder": "ejemplo@gmail.com",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                                "customMessage": "Ingrese un correo electrónico valido",
                                "minLength": 1,
                                "maxLength": 100
                            },
                            "key": "email",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "TELÉFONO CELULAR",
                            "placeholder": "00 0000 0000",
                            "inputMask": "99 9999 9999",
                            "customClass": "textMask",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 10,
                                "pattern": "^(?!.*?([1234567890])\\1{4,}|(1234567890))[0-9]*$",
                                "customMessage": "Teléfono inválido"
                            },
                            "key": "telefono",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "No soy un robot",
                            "customClass": "recaptcha",
                            "tableView": false,
                            "defaultValue": false,
                            "validate": {
                                "required": true
                            },
                            "key": "noSoyUnRobot",
                            "type": "checkbox",
                            "input": true
                        },
                        {
                            "label": "Aceptar aviso de privacidad",
                            "customClass": "readonly",
                            "defaultValue": "Al continuar estás aceptando el <A HREF=\"https://invierteyahorra.suramexico.com/suramexico/aviso-de-privacidad-SUAM.html\" target=\"_blank\">aviso de privacidad</A>",
                            "key": "avisoPrivacidad",
                            "type": "hidden",
                            "input": true,
                            "tableView": false
                        }
                    ],
                    "slice_type": "step__grupopregunta",
                    "slice_label": null
                },
                {
                    "primary": {
                        "associated_group": "step_cotizacion",
                        "title": [
                            {
                                "type": "heading6",
                                "text": "Un seguro que te protege en cada etapa de tu vida",
                                "spans": []
                            }
                        ],
                        "collapse_description": false,
                        "description": [
                            {
                                "type": "paragraph",
                                "text": "Estarás siempre protegido con el respaldo económico necesario en caso de sufrir algún accidente o enfermedad.",
                                "spans": []
                            }
                        ],
                        "collapsable_text": [],
                        "buttonnext": "Si",
                        "returnbutton": "Si",
                        "sidebar": "Resumen",
                        "barrainfosuperior": "No",
                        "enable_email": "No",
                        "columns": "1",
                        "relationship_columns": null,
                        "opciones_servicio": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/hogar/coverages-quotation\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                        "sidebar_service": null,
                        "service_btn": null,
                        "opciones_servicio_segundo_plano": null,
                        "finalmodal": null,
                        "sidebarimg": {}
                    },
                    "newItems": [
                        {
                            "label": "Coberturas",
                            "tag": "json",
                            "attrs": [
                                {
                                    "attr": "",
                                    "value": ""
                                }
                            ],
                            "content": "{\r\n\t\"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/hogar/coverages-quotation\",\r\n\t\"method\": \"POST\",\r\n\t\"headers\": {\r\n\t\t\"Content-Type\": \"application/json\",\r\n\t\t\"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\r\n\t},\r\n\t\"body\": {}\r\n}",
                            "refreshOnChange": false,
                            "customClass": "basicCard",
                            "key": "coberturas",
                            "type": "htmlelement",
                            "input": false,
                            "tableView": false
                        }
                    ],
                    "slice_type": "step__grupopregunta",
                    "slice_label": null
                }
            ]
        },
        {
            "key_step": "step_informacion_asegurados",
            "name": "Información asegurados",
            "questions": [
                {
                    "primary": {
                        "associated_group": "step_informacion_asegurados",
                        "title": [
                            {
                                "type": "heading6",
                                "text": "Información del o los asegurados",
                                "spans": []
                            }
                        ],
                        "collapse_description": false,
                        "description": [],
                        "collapsable_text": [],
                        "buttonnext": "Si",
                        "returnbutton": "Si",
                        "sidebar": "Resumen",
                        "barrainfosuperior": "Si",
                        "enable_email": "No",
                        "columns": "1",
                        "relationship_columns": null,
                        "opciones_servicio": null,
                        "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                        "service_btn": null,
                        "opciones_servicio_segundo_plano": null,
                        "finalmodal": null,
                        "sidebarimg": {}
                    },
                    "newItems": [
                        {
                            "title": "Info Asegurados",
                            "customClass": "InsuredInfo",
                            "collapsible": false,
                            "key": "infoAsegurados",
                            "type": "panel",
                            "label": "Panel",
                            "input": false,
                            "tableView": false,
                            "components": [
                                {
                                    "title": "Titular",
                                    "customClass": "insuredCards",
                                    "collapsible": false,
                                    "key": "titular",
                                    "type": "panel",
                                    "label": "Panel",
                                    "input": false,
                                    "tableView": false,
                                    "components": [
                                        {
                                            "label": "RFC",
                                            "placeholder": "Digita el RFC",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "minLength": 13,
                                                "maxLength": 13,
                                                "pattern": "^[a-zA-Z0-9]*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "identificadorPersonaTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Buscar",
                                            "showValidations": false,
                                            "tableView": false,
                                            "key": "validarRfcTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "datosContratanteIgualAsegurado",
                                                "eq": "false"
                                            },
                                            "logic": [
                                                {
                                                    "name": "api_service",
                                                    "trigger": {
                                                        "type": "json",
                                                        "json": {
                                                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/personas?tipoIdentificadorPersona=1&identificadorPersona=value",
                                                            "method": "GET",
                                                            "headers": {
                                                                "Content-Type": "application/json",
                                                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                                            },
                                                            "body": {},
                                                            "action": "autocomplete",
                                                            "key": "Contratante"
                                                        }
                                                    },
                                                    "actions": [],
                                                    "isRowSelected": true
                                                }
                                            ],
                                            "type": "button",
                                            "saveOnEnter": false,
                                            "input": true
                                        },
                                        {
                                            "label": "Nombre",
                                            "placeholder": "Ej. Juan",
                                            "tableView": true,
                                            "customDefaultValue": "nombre",
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "primerNombreTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Apellido paterno",
                                            "placeholder": "Ej. Rodriguez",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "primerApellidoTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Apellido materno",
                                            "placeholder": "Ej. Martinez",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "segundoApellidoTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Género",
                                            "widget": "choicesjs",
                                            "placeholder": "Elige género",
                                            "tableView": true,
                                            "data": {
                                                "values": [
                                                    {
                                                        "label": "Femenino",
                                                        "value": "M"
                                                    },
                                                    {
                                                        "label": "Masculino",
                                                        "value": "H"
                                                    }
                                                ]
                                            },
                                            "customDefaultValue": "genero",
                                            "validate": {
                                                "required": true
                                            },
                                            "key": "sexoTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "select",
                                            "input": true
                                        },
                                        {
                                            "label": "Fecha de Nacimiento",
                                            "format": "DD/MM/YYYY",
                                            "tableView": false,
                                            "datePicker": {
                                                "disableWeekends": false,
                                                "disableWeekdays": false,
                                                "minDate": "1870-01-01T12:00:00-04:56",
                                                "maxDate": "2021-01-01T12:00:00-05:00"
                                            },
                                            "customDefaultValue": "fechaNacimiento",
                                            "validate": {
                                                "required": true,
                                                "customMessage": "INGRESA UNA FECHA VÁLIDA"
                                            },
                                            "enableMinDateInput": false,
                                            "enableMaxDateInput": false,
                                            "key": "fechaNacimientoTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "datetime",
                                            "input": true,
                                            "widget": {
                                                "type": "calendar",
                                                "displayInTimezone": "viewer",
                                                "locale": "en",
                                                "useLocaleSettings": false,
                                                "allowInput": true,
                                                "mode": "single",
                                                "enableTime": true,
                                                "noCalendar": false,
                                                "format": "DD/MM/YYYY",
                                                "hourIncrement": 1,
                                                "minuteIncrement": 1,
                                                "time_24hr": false,
                                                "minDate": "1870-01-01T12:00:00-04:56",
                                                "disableWeekends": false,
                                                "disableWeekdays": false,
                                                "maxDate": "2021-01-01T12:00:00-05:00"
                                            }
                                        },
                                        {
                                            "label": "TELÉFONO CELULAR",
                                            "placeholder": "00 0000 0000",
                                            "inputMask": "99 9999 9999",
                                            "customClass": "textMask",
                                            "tableView": true,
                                            "customDefaultValue": "telefono",
                                            "validate": {
                                                "required": true,
                                                "minLength": 1,
                                                "maxLength": 10,
                                                "pattern": "^(?!.*?([1234567890])\\1{4,}|(1234567890))[0-9]*$",
                                                "customMessage": "Teléfono inválido"
                                            },
                                            "key": "telefonoCelularTitular",
                                            "type": "textfield",
                                            "input": true,
                                            "keyModified": true
                                        },
                                        {
                                            "label": "CORREO ELECTRÓNICO",
                                            "placeholder": "ejemplo@gmail.com",
                                            "tableView": true,
                                            "customDefaultValue": "email",
                                            "validate": {
                                                "required": true,
                                                "minLength": 1,
                                                "maxLength": 100,
                                                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                                                "customMessage": "Ingrese un correo electrónico valido"
                                            },
                                            "key": "emailTitular",
                                            "type": "textfield",
                                            "input": true
                                        }
                                    ]
                                },
                                {
                                    "title": "Adicional",
                                    "customClass": "insuredCards",
                                    "collapsible": false,
                                    "key": "adicional",
                                    "type": "panel",
                                    "label": "Panel",
                                    "input": false,
                                    "tableView": false,
                                    "components": [
                                        {
                                            "label": "RFC",
                                            "placeholder": "Digita el RFC",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "minLength": 13,
                                                "maxLength": 13,
                                                "pattern": "^[a-zA-Z0-9]*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "identificadorPersonaAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Buscar",
                                            "showValidations": false,
                                            "tableView": false,
                                            "key": "validarRfcAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "datosContratanteIgualAsegurado",
                                                "eq": "false"
                                            },
                                            "logic": [
                                                {
                                                    "name": "api_service",
                                                    "trigger": {
                                                        "type": "json",
                                                        "json": {
                                                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/personas?tipoIdentificadorPersona=1&identificadorPersona=value",
                                                            "method": "GET",
                                                            "headers": {
                                                                "Content-Type": "application/json",
                                                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                                            },
                                                            "body": {},
                                                            "action": "autocomplete",
                                                            "key": "Contratante"
                                                        }
                                                    },
                                                    "actions": [],
                                                    "isRowSelected": true
                                                }
                                            ],
                                            "type": "button",
                                            "saveOnEnter": false,
                                            "input": true
                                        },
                                        {
                                            "label": "Nombre",
                                            "placeholder": "Ej. Juan",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "primerNombreAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Apellido paterno",
                                            "placeholder": "Ej. Rodriguez",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "primerApellidoAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Apellido materno",
                                            "placeholder": "Ej. Martinez",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "segundoApellidoAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Género",
                                            "widget": "choicesjs",
                                            "placeholder": "Elige género",
                                            "tableView": true,
                                            "data": {
                                                "values": [
                                                    {
                                                        "label": "Femenino",
                                                        "value": "M"
                                                    },
                                                    {
                                                        "label": "Masculino",
                                                        "value": "H"
                                                    }
                                                ]
                                            },
                                            "validate": {
                                                "required": true
                                            },
                                            "key": "sexoAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "select",
                                            "input": true
                                        },
                                        {
                                            "label": "Fecha de Nacimiento",
                                            "format": "DD/MM/YYYY",
                                            "tableView": false,
                                            "datePicker": {
                                                "disableWeekends": false,
                                                "disableWeekdays": false,
                                                "minDate": "1870-01-01T12:00:00-04:56",
                                                "maxDate": "2021-01-01T12:00:00-05:00"
                                            },
                                            "validate": {
                                                "required": true,
                                                "customMessage": "INGRESA UNA FECHA VÁLIDA"
                                            },
                                            "enableMinDateInput": false,
                                            "enableMaxDateInput": false,
                                            "key": "fechaNacimientoAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "datetime",
                                            "input": true,
                                            "widget": {
                                                "type": "calendar",
                                                "displayInTimezone": "viewer",
                                                "locale": "en",
                                                "useLocaleSettings": false,
                                                "allowInput": true,
                                                "mode": "single",
                                                "enableTime": true,
                                                "noCalendar": false,
                                                "format": "DD/MM/YYYY",
                                                "hourIncrement": 1,
                                                "minuteIncrement": 1,
                                                "time_24hr": false,
                                                "minDate": "1870-01-01T12:00:00-04:56",
                                                "disableWeekends": false,
                                                "disableWeekdays": false,
                                                "maxDate": "2021-01-01T12:00:00-05:00"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "slice_type": "step__grupopregunta",
                    "slice_label": null
                }
            ]
        },
        {
            "key_step": "step_emision_contratante",
            "name": "Emisión Contratante",
            "questions": [
                {
                    "primary": {
                        "associated_group": "step_emision_contratante",
                        "title": [
                            {
                                "type": "heading6",
                                "text": "Información del contratante",
                                "spans": []
                            }
                        ],
                        "collapse_description": false,
                        "description": [],
                        "collapsable_text": [],
                        "buttonnext": "Si",
                        "returnbutton": "Si",
                        "sidebar": "Resumen",
                        "barrainfosuperior": "Si",
                        "enable_email": "No",
                        "columns": "3",
                        "relationship_columns": "50-50",
                        "opciones_servicio": null,
                        "sidebar_service": "{\n  \"url\": \"https://apimanagement-devqa.azure-api.net/documentos-qa/impresiones\",\n  \"method\": \"POST\",\n  \"headers\": {\n    \"Content-Type\": \"application/json\",\n    \"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\n  },\n  \"body\": {}\n}",
                        "service_btn": null,
                        "opciones_servicio_segundo_plano": null,
                        "finalmodal": null,
                        "sidebarimg": {}
                    },
                    "newItems": [
                        {
                            "label": "Los datos del contratante son los mismos que los del asegurado",
                            "customClass": "radioButton",
                            "tableView": false,
                            "defaultValue": true,
                            "key": "datosContratanteIgualAsegurado",
                            "properties": {
                                "autocomplete": "true"
                            },
                            "type": "checkbox",
                            "input": true
                        },
                        {
                            "label": "TIPO DE PERSONA",
                            "optionsLabelPosition": "right",
                            "customClass": "noMap",
                            "inline": false,
                            "tableView": false,
                            "defaultValue": "personaFisica",
                            "values": [
                                {
                                    "label": "PERSONA FÍSICA",
                                    "value": "personaFisica",
                                    "shortcut": ""
                                },
                                {
                                    "label": "PERSONA MORAL",
                                    "value": "personaMoral",
                                    "shortcut": ""
                                }
                            ],
                            "customDefaultValue": "tipoDePersona",
                            "validate": {
                                "required": true
                            },
                            "key": "tipoDePersonaContratante",
                            "conditional": {
                                "show": true,
                                "when": "datosContratanteIgualAsegurado",
                                "eq": "false"
                            },
                            "type": "radio",
                            "input": true
                        },
                        {
                            "label": "RFC",
                            "placeholder": "Digita el RFC",
                            "tableView": true,
                            "customDefaultValue": "identificadorPersonaTitular",
                            "validate": {
                                "required": true,
                                "minLength": 13,
                                "maxLength": 13,
                                "pattern": "^[a-zA-Z0-9]*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "identificadorPersonaContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "RFC",
                            "placeholder": "Digita el RFC",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 12,
                                "maxLength": 12,
                                "pattern": "^[a-zA-Z0-9]*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "identificadorPersonaContratanteMoral",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaMoral"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Buscar",
                            "showValidations": false,
                            "tableView": false,
                            "key": "validarRfcContratante",
                            "conditional": {
                                "show": true,
                                "when": "datosContratanteIgualAsegurado",
                                "eq": "false"
                            },
                            "logic": [
                                {
                                    "name": "api_service",
                                    "trigger": {
                                        "type": "json",
                                        "json": {
                                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/personas?tipoIdentificadorPersona=1&identificadorPersonaContratante=value&identificadorPersonaContratanteMoral=value",
                                            "method": "GET",
                                            "headers": {
                                                "Content-Type": "application/json",
                                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                            },
                                            "body": {},
                                            "action": "autocomplete",
                                            "key": "Contratante"
                                        }
                                    },
                                    "actions": [],
                                    "isRowSelected": true
                                }
                            ],
                            "type": "button",
                            "saveOnEnter": false,
                            "input": true
                        },
                        {
                            "type": "fakeField"
                        },
                        {
                            "label": "Razón social",
                            "placeholder": "Digita razón social",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "maxLength": 60
                            },
                            "key": "razonSocialContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaMoral"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Fecha de constitución",
                            "format": "DD/MM/YYYY",
                            "tableView": false,
                            "datePicker": {
                                "disableWeekends": false,
                                "disableWeekdays": false,
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "maxDate": "2021-01-01T12:00:00-05:00"
                            },
                            "validate": {
                                "required": true,
                                "customMessage": "INGRESA UNA FECHA VÁLIDA"
                            },
                            "enableMinDateInput": false,
                            "enableMaxDateInput": false,
                            "key": "fechaDeConstitucionContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaMoral"
                            },
                            "type": "datetime",
                            "input": true,
                            "widget": {
                                "type": "calendar",
                                "displayInTimezone": "viewer",
                                "locale": "en",
                                "useLocaleSettings": false,
                                "allowInput": true,
                                "mode": "single",
                                "enableTime": true,
                                "noCalendar": false,
                                "format": "DD/MM/YYYY",
                                "hourIncrement": 1,
                                "minuteIncrement": 1,
                                "time_24hr": false,
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "disableWeekends": false,
                                "disableWeekdays": false,
                                "maxDate": "2021-01-01T12:00:00-05:00"
                            }
                        },
                        {
                            "label": "Nombre",
                            "placeholder": "Ej. Juan",
                            "tableView": true,
                            "customDefaultValue": "primerNombreTitular",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "primerNombreContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Apellido paterno",
                            "placeholder": "Ej. Rodriguez",
                            "tableView": true,
                            "customDefaultValue": "primerApellidoTitular",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "primerApellidoContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Apellido materno",
                            "placeholder": "Ej. Martinez",
                            "tableView": true,
                            "customDefaultValue": "segundoApellidoTitular",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "segundoApellidoContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Género",
                            "widget": "choicesjs",
                            "placeholder": "Elige género",
                            "tableView": true,
                            "data": {
                                "values": [
                                    {
                                        "label": "Femenino",
                                        "value": "M"
                                    },
                                    {
                                        "label": "Masculino",
                                        "value": "H"
                                    }
                                ]
                            },
                            "customDefaultValue": "genero",
                            "validate": {
                                "required": true
                            },
                            "key": "sexoContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "Fecha de Nacimiento",
                            "format": "DD/MM/YYYY",
                            "tableView": false,
                            "enableMinDateInput": false,
                            "datePicker": {
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "maxDate": "2021-01-01T12:00:00-05:00",
                                "disableWeekends": false,
                                "disableWeekdays": false
                            },
                            "enableMaxDateInput": false,
                            "customDefaultValue": "fechaNacimiento",
                            "validate": {
                                "required": true,
                                "customMessage": "INGRESA UNA FECHA VÁLIDA"
                            },
                            "key": "fechaNacimientoContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "datetime",
                            "input": true,
                            "widget": {
                                "type": "calendar",
                                "displayInTimezone": "viewer",
                                "locale": "en",
                                "useLocaleSettings": false,
                                "allowInput": true,
                                "mode": "single",
                                "enableTime": true,
                                "noCalendar": false,
                                "format": "DD/MM/YYYY",
                                "hourIncrement": 1,
                                "minuteIncrement": 1,
                                "time_24hr": false,
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "disableWeekends": false,
                                "disableWeekdays": false,
                                "maxDate": "2021-01-01T12:00:00-05:00"
                            }
                        },
                        {
                            "label": "TELÉFONO CELULAR",
                            "placeholder": "00 0000 0000",
                            "inputMask": "99 9999 9999",
                            "customClass": "textMask",
                            "tableView": true,
                            "customDefaultValue": "telefono",
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 10,
                                "pattern": "^(?!.*?([1234567890])\\1{4,}|(1234567890))[0-9]*$",
                                "customMessage": "Teléfono inválido"
                            },
                            "key": "telefonoCelularContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Dirección",
                            "placeholder": "Digita la dirección",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 50,
                                "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "direccionContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "No. Exterior",
                            "placeholder": "Digita número exterior",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 6,
                                "pattern": "^(0|[1-9][0-9]*)$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "nExteriorContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "No. interior",
                            "placeholder": "Ej. 2236",
                            "tableView": true,
                            "validate": {
                                "minLength": 1,
                                "maxLength": 6,
                                "pattern": "^[0-9]*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "calleNumInteriorContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Código postal",
                            "placeholder": "Ej. 43540",
                            "tableView": true,
                            "customDefaultValue": "codigoPostal",
                            "validate": {
                                "required": true,
                                "pattern": "^[0-9]*$",
                                "customMessage": "Dato no válido",
                                "minLength": 5,
                                "maxLength": 5
                            },
                            "key": "codigoPostalContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Estado",
                            "widget": "choicesjs",
                            "placeholder": "Elige el Estado",
                            "tableView": true,
                            "dataSrc": "json",
                            "data": {
                                "json": {
                                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/codigopostal?codigoPostalContratante=value&catalogo=ESTADO",
                                    "method": "GET",
                                    "headers": {
                                        "Content-Type": "application/json",
                                        "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                    },
                                    "body": {}
                                }
                            },
                            "validate": {
                                "required": true
                            },
                            "key": "estadoContratante",
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "Colonia",
                            "widget": "choicesjs",
                            "placeholder": "Elige la colonia",
                            "tableView": true,
                            "dataSrc": "json",
                            "data": {
                                "json": {
                                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/codigopostal?codigoPostalContratante=value&catalogo=COLONIA",
                                    "method": "GET",
                                    "headers": {
                                        "Content-Type": "application/json",
                                        "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                    },
                                    "body": {}
                                }
                            },
                            "validate": {
                                "required": true,
                                "customMessage": "Este campo es requerido"
                            },
                            "key": "coloniaContratante",
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "E-MAIL",
                            "placeholder": "ejemplo@gmail.com",
                            "tableView": true,
                            "customDefaultValue": "email",
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 100,
                                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                                "customMessage": "Ingrese un correo electrónico valido"
                            },
                            "key": "emailContratante",
                            "type": "textfield",
                            "input": true
                        }
                    ],
                    "slice_type": "step__grupopregunta",
                    "slice_label": null
                }
            ]
        }
    ],
    currentStep: 1,
    currentQuestion: 0,
    numberQuestionsStep: 1,
    isGoToBack: true,
};

export const dataFormInsureds = {
    data: {
        "formDefinition": {
            "_id": "628d271cc1b9330a4b62ae1c",
            "name": "formAlaAzulDev",
            "_vid": 0,
            "access": [
                {
                    "roles": [
                        "614e68a500a3577144caff4a",
                        "614e68a500a35755ddcaff4f",
                        "614e68a500a3570e18caff54"
                    ],
                    "type": "read_all"
                }
            ],
            "components": [
                {
                    "title": "step_personales",
                    "breadcrumbClickable": true,
                    "buttonSettings": {
                        "previous": true,
                        "cancel": true,
                        "next": true
                    },
                    "navigateOnEnter": false,
                    "saveOnEnter": false,
                    "scrollToTop": false,
                    "collapsible": false,
                    "key": "step_personales",
                    "type": "panel",
                    "label": "Page 2",
                    "input": false,
                    "tableView": false,
                    "components": [
                        {
                            "label": "FECHA DE NACIMIENTO",
                            "format": "DD/MM/YYYY",
                            "tableView": false,
                            "datePicker": {
                                "disableWeekends": false,
                                "disableWeekdays": false,
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "maxDate": "2022-01-06T12:00:00-05:00"
                            },
                            "enableTime": false,
                            "timePicker": {
                                "showMeridian": false
                            },
                            "validate": {
                                "required": true,
                                "customMessage": "INGRESA UNA FECHA VÁLIDA"
                            },
                            "enableMinDateInput": false,
                            "enableMaxDateInput": false,
                            "key": "fechaNacimiento",
                            "type": "datetime",
                            "input": true,
                            "widget": {
                                "type": "calendar",
                                "displayInTimezone": "viewer",
                                "locale": "en",
                                "useLocaleSettings": false,
                                "allowInput": true,
                                "mode": "single",
                                "enableTime": false,
                                "noCalendar": false,
                                "format": "DD/MM/YYYY",
                                "hourIncrement": 1,
                                "minuteIncrement": 1,
                                "time_24hr": true,
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "disableWeekends": false,
                                "disableWeekdays": false,
                                "maxDate": "2022-01-06T12:00:00-05:00"
                            }
                        },
                        {
                            "label": "CÓDIGO POSTAL",
                            "placeholder": "Ej. 43540",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 5,
                                "maxLength": 5,
                                "pattern": "^[0-9]*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "codigoPostal",
                            "type": "textfield",
                            "input": true,
                            "keyModified": true
                        },
                        {
                            "label": "Genero",
                            "optionsLabelPosition": "right",
                            "customClass": "radioImage",
                            "inline": false,
                            "tableView": false,
                            "values": [
                                {
                                    "label": "Femenino",
                                    "value": "M",
                                    "shortcut": ""
                                },
                                {
                                    "label": "Masculino",
                                    "value": "H",
                                    "shortcut": ""
                                }
                            ],
                            "validate": {
                                "required": true
                            },
                            "key": "genero",
                            "properties": {
                                "H": "https://images.prismic.io/portal-cotizacion-suramex/a78811dd-60d4-4924-9ec2-87820d889191_hombre.gif",
                                "M": "https://images.prismic.io/portal-cotizacion-suramex/8234458f-0287-4fe3-9491-e9d5058131e0_mujer.gif"
                            },
                            "type": "radio",
                            "input": true
                        },
                        {
                            "label": "Tipo asegurados",
                            "optionsLabelPosition": "right",
                            "customClass": "radioImage",
                            "inline": false,
                            "tableView": false,
                            "values": [
                                {
                                    "label": "Solo a ti",
                                    "value": "T",
                                    "shortcut": ""
                                },
                                {
                                    "label": "A ti y tu familia",
                                    "value": "F",
                                    "shortcut": ""
                                }
                            ],
                            "validate": {
                                "required": true
                            },
                            "key": "claveTipoAsegurados",
                            "properties": {
                                "T": "https://images.prismic.io/portal-cotizacion-suramex/a78811dd-60d4-4924-9ec2-87820d889191_hombre.gif",
                                "F": "https://images.prismic.io/portal-cotizacion-suramex/87e48b13-3d31-4233-b0f4-6d2e277de70f_familia.gif"
                            },
                            "type": "radio",
                            "input": true
                        },
                        {
                            "label": "Aliado",
                            "defaultValue": "COTIZADORES_SURA",
                            "key": "claveAliado",
                            "type": "hidden",
                            "input": true,
                            "tableView": false
                        },
                        {
                            "label": "Status",
                            "key": "status",
                            "type": "hidden",
                            "input": true,
                            "tableView": false,
                            "defaultValue": "ACEPTAR"
                        },
                        {
                            "label": "Folio",
                            "key": "folio",
                            "type": "hidden",
                            "input": true,
                            "tableView": false
                        }
                    ],
                    "keyModified": true
                },
                {
                    "title": "step_asegurados",
                    "breadcrumbClickable": true,
                    "buttonSettings": {
                        "previous": true,
                        "cancel": true,
                        "next": true
                    },
                    "navigateOnEnter": false,
                    "saveOnEnter": false,
                    "scrollToTop": false,
                    "collapsible": false,
                    "key": "step_asegurados",
                    "type": "panel",
                    "label": "Page 3",
                    "input": false,
                    "tableView": false,
                    "components": [
                        {
                            "title": "Asegurados",
                            "customClass": "insuredCards",
                            "collapsible": false,
                            "key": "asegurados",
                            "conditional": {
                                "show": true,
                                "when": "claveTipoAsegurados",
                                "eq": "F"
                            },
                            "type": "panel",
                            "label": "Panel",
                            "input": false,
                            "tableView": false,
                            "components": [
                                {
                                    "label": "Parentesco",
                                    "widget": "choicesjs",
                                    "placeholder": "Elige el parentesco",
                                    "tableView": true,
                                    "data": {
                                        "values": [
                                            {
                                                "label": "Cónyuge",
                                                "value": "C"
                                            },
                                            {
                                                "label": "Hijo(a)",
                                                "value": "H"
                                            }
                                        ]
                                    },
                                    "validate": {
                                        "required": true
                                    },
                                    "key": "parentescoAsegurado",
                                    "type": "select",
                                    "input": true,
                                    "keyModified": true
                                },
                                {
                                    "label": "Imágenes",
                                    "optionsLabelPosition": "right",
                                    "tableView": false,
                                    "values": [
                                        {
                                            "label": "Masculino",
                                            "value": "https://images.prismic.io/portal-cotizacion-suramex/a78811dd-60d4-4924-9ec2-87820d889191_hombre.gif",
                                            "shortcut": ""
                                        },
                                        {
                                            "label": "Femenino",
                                            "value": "https://images.prismic.io/portal-cotizacion-suramex/8234458f-0287-4fe3-9491-e9d5058131e0_mujer.gif",
                                            "shortcut": ""
                                        },
                                        {
                                            "label": "Hijo",
                                            "value": "https://images.prismic.io/portal-cotizacion-suramex/a56d3da6-83e3-4d03-9968-2fc644e31cc5_ninio.gif",
                                            "shortcut": ""
                                        },
                                        {
                                            "label": "Hija",
                                            "value": "https://images.prismic.io/portal-cotizacion-suramex/8aeb8aed-a96d-4246-9dad-f8aec46f5db8_ninia.gif",
                                            "shortcut": ""
                                        }
                                    ],
                                    "key": "img",
                                    "type": "selectboxes",
                                    "input": true,
                                    "inputType": "checkbox"
                                },
                                {
                                    "label": "Género",
                                    "widget": "choicesjs",
                                    "placeholder": "Elige el género",
                                    "tableView": true,
                                    "data": {
                                        "values": [
                                            {
                                                "label": "Femenino",
                                                "value": "M"
                                            },
                                            {
                                                "label": "Masculino",
                                                "value": "H"
                                            }
                                        ]
                                    },
                                    "validate": {
                                        "required": true
                                    },
                                    "key": "generoAsegurado",
                                    "properties": {
                                        "parentContainer": "asegurados"
                                    },
                                    "type": "select",
                                    "input": true,
                                    "keyModified": true
                                },
                                {
                                    "label": "Fecha de nacimiento",
                                    "format": "DD/MM/YYYY",
                                    "tableView": false,
                                    "datePicker": {
                                        "disableWeekends": false,
                                        "disableWeekdays": false,
                                        "minDate": "1870-01-01T12:00:00-04:56",
                                        "maxDate": "2022-01-06T12:00:00-05:00"
                                    },
                                    "enableTime": false,
                                    "timePicker": {
                                        "showMeridian": false
                                    },
                                    "validate": {
                                        "required": true,
                                        "customMessage": "Ingresa una fecha válida"
                                    },
                                    "enableMinDateInput": false,
                                    "enableMaxDateInput": false,
                                    "key": "fechaNacimientoAsegurado",
                                    "properties": {
                                        "C": "18-60",
                                        "H": "1-36",
                                        "difference": "10"
                                    },
                                    "type": "datetime",
                                    "input": true,
                                    "widget": {
                                        "type": "calendar",
                                        "displayInTimezone": "viewer",
                                        "locale": "en",
                                        "useLocaleSettings": false,
                                        "allowInput": true,
                                        "mode": "single",
                                        "enableTime": false,
                                        "noCalendar": false,
                                        "format": "DD/MM/YYYY",
                                        "hourIncrement": 1,
                                        "minuteIncrement": 1,
                                        "time_24hr": true,
                                        "minDate": "1870-01-01T12:00:00-04:56",
                                        "disableWeekends": false,
                                        "disableWeekdays": false,
                                        "maxDate": "2022-01-06T12:00:00-05:00"
                                    },
                                    "keyModified": true
                                }
                            ]
                        }
                    ]
                },
                {
                    "title": "step_cotizacion",
                    "breadcrumbClickable": true,
                    "buttonSettings": {
                        "previous": true,
                        "cancel": true,
                        "next": true
                    },
                    "navigateOnEnter": false,
                    "saveOnEnter": false,
                    "scrollToTop": false,
                    "collapsible": false,
                    "key": "step_cotizacion",
                    "type": "panel",
                    "label": "Page 3",
                    "input": false,
                    "tableView": false,
                    "components": [
                        {
                            "label": "Nombre",
                            "placeholder": "Ej. Diana",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 100,
                                "pattern": "^[a-zA-Z]+$",
                                "customMessage": "Ingresa un nombre valido"
                            },
                            "key": "nombre",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "INGRESA TU E-MAIL",
                            "placeholder": "ejemplo@gmail.com",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                                "customMessage": "Ingrese un correo electrónico valido",
                                "minLength": 1,
                                "maxLength": 100
                            },
                            "key": "email",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "TELÉFONO CELULAR",
                            "placeholder": "00 0000 0000",
                            "inputMask": "99 9999 9999",
                            "customClass": "textMask",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 10,
                                "pattern": "^(?!.*?([1234567890])\\1{4,}|(1234567890))[0-9]*$",
                                "customMessage": "Teléfono inválido"
                            },
                            "key": "telefono",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "No soy un robot",
                            "customClass": "recaptcha",
                            "tableView": false,
                            "defaultValue": false,
                            "validate": {
                                "required": true
                            },
                            "key": "noSoyUnRobot",
                            "type": "checkbox",
                            "input": true
                        },
                        {
                            "label": "Aceptar aviso de privacidad",
                            "customClass": "readonly",
                            "defaultValue": "Al continuar estás aceptando el <A HREF=\"https://invierteyahorra.suramexico.com/suramexico/aviso-de-privacidad-SUAM.html\" target=\"_blank\">aviso de privacidad</A>",
                            "key": "avisoPrivacidad",
                            "type": "hidden",
                            "input": true,
                            "tableView": false
                        },
                        {
                            "label": "Coberturas",
                            "tag": "json",
                            "attrs": [
                                {
                                    "attr": "",
                                    "value": ""
                                }
                            ],
                            "content": "{\r\n\t\"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/hogar/coverages-quotation\",\r\n\t\"method\": \"POST\",\r\n\t\"headers\": {\r\n\t\t\"Content-Type\": \"application/json\",\r\n\t\t\"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\r\n\t},\r\n\t\"body\": {}\r\n}",
                            "refreshOnChange": false,
                            "customClass": "basicCard",
                            "key": "coberturas",
                            "type": "htmlelement",
                            "input": false,
                            "tableView": false
                        }
                    ],
                    "keyModified": true
                },
                {
                    "title": "step_informacion_asegurados",
                    "breadcrumbClickable": true,
                    "buttonSettings": {
                        "previous": true,
                        "cancel": true,
                        "next": true
                    },
                    "navigateOnEnter": false,
                    "saveOnEnter": false,
                    "scrollToTop": false,
                    "collapsible": false,
                    "key": "step_informacion_asegurados",
                    "type": "panel",
                    "label": "Page 3",
                    "input": false,
                    "tableView": false,
                    "components": [
                        {
                            "title": "Info Asegurados",
                            "customClass": "InsuredInfo",
                            "collapsible": false,
                            "key": "infoAsegurados",
                            "type": "panel",
                            "label": "Panel",
                            "input": false,
                            "tableView": false,
                            "components": [
                                {
                                    "title": "Titular",
                                    "customClass": "insuredCards",
                                    "collapsible": false,
                                    "key": "titular",
                                    "type": "panel",
                                    "label": "Panel",
                                    "input": false,
                                    "tableView": false,
                                    "components": [
                                        {
                                            "label": "RFC",
                                            "placeholder": "Digita el RFC",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "minLength": 13,
                                                "maxLength": 13,
                                                "pattern": "^[a-zA-Z0-9]*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "identificadorPersonaTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Buscar",
                                            "showValidations": false,
                                            "tableView": false,
                                            "key": "validarRfcTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "datosContratanteIgualAsegurado",
                                                "eq": "false"
                                            },
                                            "logic": [
                                                {
                                                    "name": "api_service",
                                                    "trigger": {
                                                        "type": "json",
                                                        "json": {
                                                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/personas?tipoIdentificadorPersona=1&identificadorPersona=value",
                                                            "method": "GET",
                                                            "headers": {
                                                                "Content-Type": "application/json",
                                                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                                            },
                                                            "body": {},
                                                            "action": "autocomplete",
                                                            "key": "Contratante"
                                                        }
                                                    },
                                                    "actions": [],
                                                    "isRowSelected": true
                                                }
                                            ],
                                            "type": "button",
                                            "saveOnEnter": false,
                                            "input": true
                                        },
                                        {
                                            "label": "Nombre",
                                            "placeholder": "Ej. Juan",
                                            "tableView": true,
                                            "customDefaultValue": "nombre",
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "primerNombreTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Apellido paterno",
                                            "placeholder": "Ej. Rodriguez",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "primerApellidoTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Apellido materno",
                                            "placeholder": "Ej. Martinez",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "segundoApellidoTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Género",
                                            "widget": "choicesjs",
                                            "placeholder": "Elige género",
                                            "tableView": true,
                                            "data": {
                                                "values": [
                                                    {
                                                        "label": "Femenino",
                                                        "value": "M"
                                                    },
                                                    {
                                                        "label": "Masculino",
                                                        "value": "H"
                                                    }
                                                ]
                                            },
                                            "customDefaultValue": "genero",
                                            "validate": {
                                                "required": true
                                            },
                                            "key": "sexoTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "select",
                                            "input": true
                                        },
                                        {
                                            "label": "Fecha de Nacimiento",
                                            "format": "DD/MM/YYYY",
                                            "tableView": false,
                                            "datePicker": {
                                                "disableWeekends": false,
                                                "disableWeekdays": false,
                                                "minDate": "1870-01-01T12:00:00-04:56",
                                                "maxDate": "2021-01-01T12:00:00-05:00"
                                            },
                                            "customDefaultValue": "fechaNacimiento",
                                            "validate": {
                                                "required": true,
                                                "customMessage": "INGRESA UNA FECHA VÁLIDA"
                                            },
                                            "enableMinDateInput": false,
                                            "enableMaxDateInput": false,
                                            "key": "fechaNacimientoTitular",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "datetime",
                                            "input": true,
                                            "widget": {
                                                "type": "calendar",
                                                "displayInTimezone": "viewer",
                                                "locale": "en",
                                                "useLocaleSettings": false,
                                                "allowInput": true,
                                                "mode": "single",
                                                "enableTime": true,
                                                "noCalendar": false,
                                                "format": "DD/MM/YYYY",
                                                "hourIncrement": 1,
                                                "minuteIncrement": 1,
                                                "time_24hr": false,
                                                "minDate": "1870-01-01T12:00:00-04:56",
                                                "disableWeekends": false,
                                                "disableWeekdays": false,
                                                "maxDate": "2021-01-01T12:00:00-05:00"
                                            }
                                        },
                                        {
                                            "label": "TELÉFONO CELULAR",
                                            "placeholder": "00 0000 0000",
                                            "inputMask": "99 9999 9999",
                                            "customClass": "textMask",
                                            "tableView": true,
                                            "customDefaultValue": "telefono",
                                            "validate": {
                                                "required": true,
                                                "minLength": 1,
                                                "maxLength": 10,
                                                "pattern": "^(?!.*?([1234567890])\\1{4,}|(1234567890))[0-9]*$",
                                                "customMessage": "Teléfono inválido"
                                            },
                                            "key": "telefonoCelularTitular",
                                            "type": "textfield",
                                            "input": true,
                                            "keyModified": true
                                        },
                                        {
                                            "label": "CORREO ELECTRÓNICO",
                                            "placeholder": "ejemplo@gmail.com",
                                            "tableView": true,
                                            "customDefaultValue": "email",
                                            "validate": {
                                                "required": true,
                                                "minLength": 1,
                                                "maxLength": 100,
                                                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                                                "customMessage": "Ingrese un correo electrónico valido"
                                            },
                                            "key": "emailTitular",
                                            "type": "textfield",
                                            "input": true
                                        }
                                    ]
                                },
                                {
                                    "title": "Adicional",
                                    "customClass": "insuredCards",
                                    "collapsible": false,
                                    "key": "adicional",
                                    "type": "panel",
                                    "label": "Panel",
                                    "input": false,
                                    "tableView": false,
                                    "components": [
                                        {
                                            "label": "RFC",
                                            "placeholder": "Digita el RFC",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "minLength": 13,
                                                "maxLength": 13,
                                                "pattern": "^[a-zA-Z0-9]*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "identificadorPersonaAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Buscar",
                                            "showValidations": false,
                                            "tableView": false,
                                            "key": "validarRfcAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "datosContratanteIgualAsegurado",
                                                "eq": "false"
                                            },
                                            "logic": [
                                                {
                                                    "name": "api_service",
                                                    "trigger": {
                                                        "type": "json",
                                                        "json": {
                                                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/personas?tipoIdentificadorPersona=1&identificadorPersona=value",
                                                            "method": "GET",
                                                            "headers": {
                                                                "Content-Type": "application/json",
                                                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                                            },
                                                            "body": {},
                                                            "action": "autocomplete",
                                                            "key": "Contratante"
                                                        }
                                                    },
                                                    "actions": [],
                                                    "isRowSelected": true
                                                }
                                            ],
                                            "type": "button",
                                            "saveOnEnter": false,
                                            "input": true
                                        },
                                        {
                                            "label": "Nombre",
                                            "placeholder": "Ej. Juan",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "primerNombreAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Apellido paterno",
                                            "placeholder": "Ej. Rodriguez",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "primerApellidoAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Apellido materno",
                                            "placeholder": "Ej. Martinez",
                                            "tableView": true,
                                            "validate": {
                                                "required": true,
                                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                                "customMessage": "Dato no válido"
                                            },
                                            "key": "segundoApellidoAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "textfield",
                                            "input": true
                                        },
                                        {
                                            "label": "Género",
                                            "widget": "choicesjs",
                                            "placeholder": "Elige género",
                                            "tableView": true,
                                            "data": {
                                                "values": [
                                                    {
                                                        "label": "Femenino",
                                                        "value": "M"
                                                    },
                                                    {
                                                        "label": "Masculino",
                                                        "value": "H"
                                                    }
                                                ]
                                            },
                                            "validate": {
                                                "required": true
                                            },
                                            "key": "sexoAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "select",
                                            "input": true
                                        },
                                        {
                                            "label": "Fecha de Nacimiento",
                                            "format": "DD/MM/YYYY",
                                            "tableView": false,
                                            "datePicker": {
                                                "disableWeekends": false,
                                                "disableWeekdays": false,
                                                "minDate": "1870-01-01T12:00:00-04:56",
                                                "maxDate": "2021-01-01T12:00:00-05:00"
                                            },
                                            "validate": {
                                                "required": true,
                                                "customMessage": "INGRESA UNA FECHA VÁLIDA"
                                            },
                                            "enableMinDateInput": false,
                                            "enableMaxDateInput": false,
                                            "key": "fechaNacimientoAdicional",
                                            "conditional": {
                                                "show": true,
                                                "when": "tipoDePersonaContratante",
                                                "eq": "personaFisica"
                                            },
                                            "type": "datetime",
                                            "input": true,
                                            "widget": {
                                                "type": "calendar",
                                                "displayInTimezone": "viewer",
                                                "locale": "en",
                                                "useLocaleSettings": false,
                                                "allowInput": true,
                                                "mode": "single",
                                                "enableTime": true,
                                                "noCalendar": false,
                                                "format": "DD/MM/YYYY",
                                                "hourIncrement": 1,
                                                "minuteIncrement": 1,
                                                "time_24hr": false,
                                                "minDate": "1870-01-01T12:00:00-04:56",
                                                "disableWeekends": false,
                                                "disableWeekdays": false,
                                                "maxDate": "2021-01-01T12:00:00-05:00"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "keyModified": true
                },
                {
                    "title": "step_emision_contratante",
                    "breadcrumbClickable": true,
                    "buttonSettings": {
                        "previous": true,
                        "cancel": true,
                        "next": true
                    },
                    "navigateOnEnter": false,
                    "saveOnEnter": false,
                    "scrollToTop": false,
                    "collapsible": false,
                    "key": "step_emision_contratante",
                    "type": "panel",
                    "label": "Page 5",
                    "input": false,
                    "tableView": false,
                    "components": [
                        {
                            "label": "Los datos del contratante son los mismos que los del asegurado",
                            "customClass": "radioButton",
                            "tableView": false,
                            "defaultValue": true,
                            "key": "datosContratanteIgualAsegurado",
                            "properties": {
                                "autocomplete": "true"
                            },
                            "type": "checkbox",
                            "input": true
                        },
                        {
                            "label": "TIPO DE PERSONA",
                            "optionsLabelPosition": "right",
                            "customClass": "noMap",
                            "inline": false,
                            "tableView": false,
                            "defaultValue": "personaFisica",
                            "values": [
                                {
                                    "label": "PERSONA FÍSICA",
                                    "value": "personaFisica",
                                    "shortcut": ""
                                },
                                {
                                    "label": "PERSONA MORAL",
                                    "value": "personaMoral",
                                    "shortcut": ""
                                }
                            ],
                            "customDefaultValue": "tipoDePersona",
                            "validate": {
                                "required": true
                            },
                            "key": "tipoDePersonaContratante",
                            "conditional": {
                                "show": true,
                                "when": "datosContratanteIgualAsegurado",
                                "eq": "false"
                            },
                            "type": "radio",
                            "input": true
                        },
                        {
                            "label": "RFC",
                            "placeholder": "Digita el RFC",
                            "tableView": true,
                            "customDefaultValue": "identificadorPersonaTitular",
                            "validate": {
                                "required": true,
                                "minLength": 13,
                                "maxLength": 13,
                                "pattern": "^[a-zA-Z0-9]*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "identificadorPersonaContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "RFC",
                            "placeholder": "Digita el RFC",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 12,
                                "maxLength": 12,
                                "pattern": "^[a-zA-Z0-9]*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "identificadorPersonaContratanteMoral",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaMoral"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Buscar",
                            "showValidations": false,
                            "tableView": false,
                            "key": "validarRfcContratante",
                            "conditional": {
                                "show": true,
                                "when": "datosContratanteIgualAsegurado",
                                "eq": "false"
                            },
                            "logic": [
                                {
                                    "name": "api_service",
                                    "trigger": {
                                        "type": "json",
                                        "json": {
                                            "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/personas?tipoIdentificadorPersona=1&identificadorPersonaContratante=value&identificadorPersonaContratanteMoral=value",
                                            "method": "GET",
                                            "headers": {
                                                "Content-Type": "application/json",
                                                "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                            },
                                            "body": {},
                                            "action": "autocomplete",
                                            "key": "Contratante"
                                        }
                                    },
                                    "actions": [],
                                    "isRowSelected": true
                                }
                            ],
                            "type": "button",
                            "saveOnEnter": false,
                            "input": true
                        },
                        {
                            "label": "Nombre",
                            "placeholder": "Ej. Juan",
                            "tableView": true,
                            "customDefaultValue": "primerNombreTitular",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "primerNombreContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Apellido paterno",
                            "placeholder": "Ej. Rodriguez",
                            "tableView": true,
                            "customDefaultValue": "primerApellidoTitular",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "primerApellidoContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Apellido materno",
                            "placeholder": "Ej. Martinez",
                            "tableView": true,
                            "customDefaultValue": "segundoApellidoTitular",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "segundoApellidoContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Fecha de constitución",
                            "format": "DD/MM/YYYY",
                            "tableView": false,
                            "datePicker": {
                                "disableWeekends": false,
                                "disableWeekdays": false,
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "maxDate": "2021-01-01T12:00:00-05:00"
                            },
                            "validate": {
                                "required": true,
                                "customMessage": "INGRESA UNA FECHA VÁLIDA"
                            },
                            "enableMinDateInput": false,
                            "enableMaxDateInput": false,
                            "key": "fechaDeConstitucionContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaMoral"
                            },
                            "type": "datetime",
                            "input": true,
                            "widget": {
                                "type": "calendar",
                                "displayInTimezone": "viewer",
                                "locale": "en",
                                "useLocaleSettings": false,
                                "allowInput": true,
                                "mode": "single",
                                "enableTime": true,
                                "noCalendar": false,
                                "format": "DD/MM/YYYY",
                                "hourIncrement": 1,
                                "minuteIncrement": 1,
                                "time_24hr": false,
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "disableWeekends": false,
                                "disableWeekdays": false,
                                "maxDate": "2021-01-01T12:00:00-05:00"
                            }
                        },
                        {
                            "label": "Razón social",
                            "placeholder": "Digita razón social",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "maxLength": 60
                            },
                            "key": "razonSocialContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaMoral"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "CURP",
                            "placeholder": "Digita el CURP",
                            "tableView": true,
                            "customDefaultValue": "curp",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-Z0-9]+$",
                                "customMessage": "Tu CURP debe tener longitud de 18 caracteres",
                                "minLength": 18,
                                "maxLength": 18
                            },
                            "key": "curpContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Género",
                            "widget": "choicesjs",
                            "placeholder": "Elige género",
                            "tableView": true,
                            "data": {
                                "values": [
                                    {
                                        "label": "Femenino",
                                        "value": "M"
                                    },
                                    {
                                        "label": "Masculino",
                                        "value": "H"
                                    }
                                ]
                            },
                            "customDefaultValue": "genero",
                            "validate": {
                                "required": true
                            },
                            "key": "sexoContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "Genero persona moral",
                            "defaultValue": "Empresa",
                            "key": "generoPersonaMoralContratante",
                            "type": "hidden",
                            "input": true,
                            "tableView": false
                        },
                        {
                            "label": "Fecha de Nacimiento",
                            "format": "DD/MM/YYYY",
                            "tableView": false,
                            "enableMinDateInput": false,
                            "datePicker": {
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "maxDate": "2021-01-01T12:00:00-05:00",
                                "disableWeekends": false,
                                "disableWeekdays": false
                            },
                            "enableMaxDateInput": false,
                            "customDefaultValue": "fechaNacimiento",
                            "validate": {
                                "required": true,
                                "customMessage": "INGRESA UNA FECHA VÁLIDA"
                            },
                            "key": "fechaNacimientoContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "datetime",
                            "input": true,
                            "widget": {
                                "type": "calendar",
                                "displayInTimezone": "viewer",
                                "locale": "en",
                                "useLocaleSettings": false,
                                "allowInput": true,
                                "mode": "single",
                                "enableTime": true,
                                "noCalendar": false,
                                "format": "DD/MM/YYYY",
                                "hourIncrement": 1,
                                "minuteIncrement": 1,
                                "time_24hr": false,
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "disableWeekends": false,
                                "disableWeekdays": false,
                                "maxDate": "2021-01-01T12:00:00-05:00"
                            }
                        },
                        {
                            "label": "Estado Civil",
                            "widget": "choicesjs",
                            "tableView": true,
                            "data": {
                                "values": [
                                    {
                                        "label": "Soltero/a.",
                                        "value": "S"
                                    },
                                    {
                                        "label": "Casado/a.",
                                        "value": "C"
                                    }
                                ]
                            },
                            "customDefaultValue": "estadoCivil",
                            "validate": {
                                "required": true
                            },
                            "key": "estadoCivilContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "select",
                            "input": true,
                            "placeholder": "Elige estado Civil"
                        },
                        {
                            "label": "País de Nacimiento",
                            "widget": "choicesjs",
                            "placeholder": "Elige tu país de nacimiento",
                            "tableView": true,
                            "dataSrc": "json",
                            "data": {
                                "json": {
                                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/locaciones/paises",
                                    "method": "GET",
                                    "headers": {
                                        "Content-Type": "application/json",
                                        "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                    },
                                    "body": {}
                                }
                            },
                            "customDefaultValue": "pais",
                            "validate": {
                                "required": true,
                                "customMessage": "Este campo es requerido"
                            },
                            "key": "paisNacimientoContratante",
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "Lugar de Nacimiento",
                            "placeholder": "Lugar de Nacimiento",
                            "tableView": true,
                            "customDefaultValue": "lugarNacimiento",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "minLength": 1,
                                "maxLength": 40
                            },
                            "key": "lugarNacimientoContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Nacionalidad",
                            "widget": "choicesjs",
                            "placeholder": "Elige tu nacionalidad",
                            "tableView": true,
                            "dataSrc": "json",
                            "data": {
                                "json": {
                                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/locaciones/nacionalidades",
                                    "method": "GET",
                                    "headers": {
                                        "Content-Type": "application/json",
                                        "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                    },
                                    "body": {}
                                }
                            },
                            "customDefaultValue": "nacionalidad",
                            "validate": {
                                "required": true,
                                "customMessage": "Este campo es requerido"
                            },
                            "key": "nacionalidadContratante",
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "Ocupación o profesión",
                            "widget": "choicesjs",
                            "placeholder": "Elige ocupación o profesión",
                            "tableView": true,
                            "dataSrc": "json",
                            "data": {
                                "json": {
                                    "url": "https://apimanagement-devqa.azure-api.net/api-dev/plan-vive/catalogos/ocupaciones",
                                    "method": "GET",
                                    "headers": {
                                        "Content-Type": "application/json",
                                        "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                    },
                                    "body": {}
                                }
                            },
                            "customDefaultValue": "claveOcupacion",
                            "validate": {
                                "required": true
                            },
                            "key": "ocupacionProfesionContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "Puesto",
                            "placeholder": "Ej. Director Ejecutivo",
                            "tableView": true,
                            "customDefaultValue": "puesto",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "minLength": 1,
                                "maxLength": 30
                            },
                            "key": "puestoContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Ingresos mensuales",
                            "placeholder": "Ej: 13350",
                            "tableView": true,
                            "customDefaultValue": "ingresosMensuales",
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 7,
                                "pattern": "^(0|[1-9][0-9]*)$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "ingresosMensualesContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "¿Empleado gubernamental?",
                            "tableView": false,
                            "defaultValue": false,
                            "customDefaultValue": "empleadoGubernamental",
                            "validate": {
                                "customMessage": "Error"
                            },
                            "key": "empleadoGubernamentalContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "checkbox",
                            "input": true
                        },
                        {
                            "label": "Descripción de actividades",
                            "placeholder": "Describe las actividades",
                            "tableView": true,
                            "customDefaultValue": "descripcionActividades",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "minLength": 1,
                                "maxLength": 70
                            },
                            "key": "descripcionActividadesContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Añadir apoderado legal",
                            "customClass": "checkClassic",
                            "tableView": false,
                            "defaultValue": false,
                            "validate": {
                                "required": true
                            },
                            "key": "anadirApoderadoLegalContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaMoral"
                            },
                            "type": "checkbox",
                            "input": true
                        },
                        {
                            "label": "Nombre del apoderado legal ",
                            "placeholder": "Digita nombre del apoderado legal",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "maxLength": 60
                            },
                            "key": "nombreDelApoderadoLegalContratante",
                            "conditional": {
                                "show": true,
                                "when": "anadirApoderadoLegalContratante",
                                "eq": "true"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Fecha de nacimiento del apoderado",
                            "format": "DD/MM/YYYY",
                            "tableView": false,
                            "enableMinDateInput": false,
                            "datePicker": {
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "maxDate": "2021-01-01T12:00:00-05:00",
                                "disableWeekends": false,
                                "disableWeekdays": false
                            },
                            "enableMaxDateInput": false,
                            "validate": {
                                "required": true,
                                "customMessage": "INGRESA UNA FECHA VÁLIDA"
                            },
                            "key": "fechaDeNacimientoDelApoderadoContratante",
                            "conditional": {
                                "show": true,
                                "when": "anadirApoderadoLegalContratante",
                                "eq": "true"
                            },
                            "type": "datetime",
                            "input": true,
                            "widget": {
                                "type": "calendar",
                                "displayInTimezone": "viewer",
                                "locale": "en",
                                "useLocaleSettings": false,
                                "allowInput": true,
                                "mode": "single",
                                "enableTime": true,
                                "noCalendar": false,
                                "format": "DD/MM/YYYY",
                                "hourIncrement": 1,
                                "minuteIncrement": 1,
                                "time_24hr": false,
                                "minDate": "1870-01-01T12:00:00-04:56",
                                "disableWeekends": false,
                                "disableWeekdays": false,
                                "maxDate": "2021-01-01T12:00:00-05:00"
                            }
                        },
                        {
                            "label": "E-MAIL",
                            "placeholder": "ejemplo@gmail.com",
                            "tableView": true,
                            "customDefaultValue": "email",
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 100,
                                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                                "customMessage": "Ingrese un correo electrónico valido"
                            },
                            "key": "emailContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Teléfono particular",
                            "placeholder": "Ej. 55 5723 799",
                            "tableView": true,
                            "customDefaultValue": "telefonoParticular",
                            "validate": {
                                "pattern": "^(?!.*?([1234567890])\\1{9,}|(1234567890))[0-9]*$",
                                "customMessage": "Ingresa un número telefónico valido",
                                "minLength": 1,
                                "maxLength": 10
                            },
                            "key": "telefonoParticularContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "TELÉFONO CELULAR",
                            "placeholder": "00 0000 0000",
                            "inputMask": "99 9999 9999",
                            "customClass": "textMask",
                            "tableView": true,
                            "customDefaultValue": "telefono",
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 10,
                                "pattern": "^(?!.*?([1234567890])\\1{4,}|(1234567890))[0-9]*$",
                                "customMessage": "Teléfono inválido"
                            },
                            "key": "telefonoCelularContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "E.Firma",
                            "placeholder": "Digita E.Firma",
                            "tableView": true,
                            "customDefaultValue": "eFirma",
                            "validate": {
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "minLength": 1,
                                "maxLength": 35
                            },
                            "key": "eFirmaContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Tipo de identificación entregada",
                            "widget": "choicesjs",
                            "placeholder": "Elige tipo identificación entregada",
                            "tableView": true,
                            "data": {
                                "values": [
                                    {
                                        "label": "Credencial para votar vigente",
                                        "value": "credencialParaVotarVigente"
                                    },
                                    {
                                        "label": "Pasaporte vigente",
                                        "value": "pasaporteVigente"
                                    },
                                    {
                                        "label": "Cedula profesional",
                                        "value": "cedulaProfesional"
                                    },
                                    {
                                        "label": "Cartilla de servicio militar",
                                        "value": "cartillaDeServicioMilitar"
                                    },
                                    {
                                        "label": "Certificado de matrícula consultar para extranjeros",
                                        "value": "certificadoDeMatriculaConsultarParaExtranjeros"
                                    },
                                    {
                                        "label": "Documento migratorio vigente",
                                        "value": "documentoMigratorioVigente"
                                    }
                                ]
                            },
                            "customDefaultValue": "tipoDeIdentificacionEntregada",
                            "validate": {
                                "required": true
                            },
                            "key": "tipoDeIdentificacionEntregadaContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "País y entidad que expide el documento",
                            "widget": "choicesjs",
                            "placeholder": "Elige País y entidad que expide el documento",
                            "tableView": true,
                            "dataSrc": "json",
                            "data": {
                                "json": {
                                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/locaciones/paises",
                                    "method": "GET",
                                    "headers": {
                                        "Content-Type": "application/json",
                                        "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                    },
                                    "body": {}
                                }
                            },
                            "customDefaultValue": "paisEntidadExpideDocumento",
                            "validate": {
                                "required": true,
                                "customMessage": "Este campo es requerido"
                            },
                            "key": "paisEntidadExpideDocumentoContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "Folio de identificación entregada",
                            "placeholder": "Digita Folio de identificación entregada",
                            "tableView": true,
                            "customDefaultValue": "folioDeIdentificacionEntregada",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "minLength": 1,
                                "maxLength": 30
                            },
                            "key": "folioDeIdentificacionEntregadaContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "¿Otras nacionalidades?",
                            "hidden": true,
                            "tableView": false,
                            "defaultValue": false,
                            "customDefaultValue": "otrasNacionalidades",
                            "validate": {
                                "required": true,
                                "customMessage": "Error"
                            },
                            "key": "otrasNacionalidadesContratante",
                            "conditional": {
                                "show": false,
                                "when": "paisNacimientoContratante",
                                "eq": "052"
                            },
                            "type": "checkbox",
                            "input": true
                        },
                        {
                            "label": "¿Cuáles?",
                            "placeholder": "¿Cuáles otras nacionalidades?",
                            "hidden": true,
                            "tableView": true,
                            "customDefaultValue": "cuales",
                            "calculateValue": "cuales",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "minLength": 1,
                                "maxLength": 100
                            },
                            "key": "cualesContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "¿Residente fiscal en el extranjero?",
                            "tableView": false,
                            "defaultValue": false,
                            "customDefaultValue": "residenteFiscalExtranjero",
                            "validate": {
                                "required": true,
                                "customMessage": "Error"
                            },
                            "key": "residenteFiscalExtranjeroContratante",
                            "conditional": {
                                "show": false,
                                "when": "paisNacimientoContratante",
                                "eq": "052"
                            },
                            "type": "checkbox",
                            "input": true
                        },
                        {
                            "label": "País donde es residente fiscal",
                            "widget": "choicesjs",
                            "placeholder": "Elige el país",
                            "tableView": true,
                            "dataSrc": "json",
                            "data": {
                                "json": {
                                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/locaciones/paises",
                                    "method": "GET",
                                    "headers": {
                                        "Content-Type": "application/json",
                                        "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                    },
                                    "body": {}
                                }
                            },
                            "customDefaultValue": "paisResidenteFiscal",
                            "validate": {
                                "required": true,
                                "customMessage": "Este campo es requerido"
                            },
                            "key": "paisResidenteFiscalContratante",
                            "conditional": {
                                "show": true,
                                "when": "residenteFiscalExtranjeroContratante",
                                "eq": "true"
                            },
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "N° Identificación en el extranjero",
                            "placeholder": "Ej. E0103543J",
                            "tableView": true,
                            "customDefaultValue": "nIdentificacionEnElExtranjero",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ0-9_  -\\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "minLength": 1,
                                "maxLength": 30
                            },
                            "key": "nIdentificacionEnElExtranjeroContratante",
                            "conditional": {
                                "show": true,
                                "when": "residenteFiscalExtranjeroContratante",
                                "eq": "true"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Dirección",
                            "placeholder": "Digita la dirección",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 50,
                                "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "direccionContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "No. Exterior",
                            "placeholder": "Digita número exterior",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "minLength": 1,
                                "maxLength": 6,
                                "pattern": "^(0|[1-9][0-9]*)$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "nExteriorContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "No. interior",
                            "placeholder": "Ej. 2236",
                            "tableView": true,
                            "validate": {
                                "minLength": 1,
                                "maxLength": 6,
                                "pattern": "^[0-9]*$",
                                "customMessage": "Dato no válido"
                            },
                            "key": "calleNumInteriorContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Código postal",
                            "placeholder": "Ej. 43540",
                            "tableView": true,
                            "customDefaultValue": "codigoPostal",
                            "validate": {
                                "required": true,
                                "pattern": "^[0-9]*$",
                                "customMessage": "Dato no válido",
                                "minLength": 5,
                                "maxLength": 5
                            },
                            "key": "codigoPostalContratante",
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Estado",
                            "widget": "choicesjs",
                            "placeholder": "Elige el Estado",
                            "tableView": true,
                            "dataSrc": "json",
                            "data": {
                                "json": {
                                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/codigopostal?codigoPostalContratante=value&catalogo=ESTADO",
                                    "method": "GET",
                                    "headers": {
                                        "Content-Type": "application/json",
                                        "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                    },
                                    "body": {}
                                }
                            },
                            "validate": {
                                "required": true
                            },
                            "key": "estadoContratante",
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "Colonia",
                            "widget": "choicesjs",
                            "placeholder": "Elige la colonia",
                            "tableView": true,
                            "dataSrc": "json",
                            "data": {
                                "json": {
                                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/codigopostal?codigoPostalContratante=value&catalogo=COLONIA",
                                    "method": "GET",
                                    "headers": {
                                        "Content-Type": "application/json",
                                        "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                    },
                                    "body": {}
                                }
                            },
                            "validate": {
                                "required": true,
                                "customMessage": "Este campo es requerido"
                            },
                            "key": "coloniaContratante",
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "Ciudad",
                            "widget": "choicesjs",
                            "placeholder": "Elige la ciudad",
                            "tableView": true,
                            "dataSrc": "json",
                            "data": {
                                "json": {
                                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/codigopostal?codigoPostalContratante=value&catalogo=CIUDAD",
                                    "method": "GET",
                                    "headers": {
                                        "Content-Type": "application/json",
                                        "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                    },
                                    "body": {}
                                }
                            },
                            "customDefaultValue": "ciudadAsegurado",
                            "validate": {
                                "required": true,
                                "customMessage": "Este campo es requerido"
                            },
                            "key": "ciudadContratante",
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "Municipio",
                            "widget": "choicesjs",
                            "placeholder": "Elige el municipio",
                            "tableView": true,
                            "dataSrc": "json",
                            "data": {
                                "json": {
                                    "url": "https://apimanagement-devqa.azure-api.net/catalogos-dev/codigopostal?codigoPostalContratante=value&catalogo=MUNICIPIO",
                                    "method": "GET",
                                    "headers": {
                                        "Content-Type": "application/json",
                                        "Subscription-Key": "09e5ece8bcbf4ff4b1d099fb45e7b3bc"
                                    },
                                    "body": {}
                                }
                            },
                            "customDefaultValue": "municipioAsegurado",
                            "validate": {
                                "required": true,
                                "customMessage": "Este campo es requerido"
                            },
                            "key": "municipioContratante",
                            "type": "select",
                            "input": true
                        },
                        {
                            "label": "Domicilio en el extranjero",
                            "placeholder": "Ej. Cra 50 #22-54 Medellín",
                            "tableView": true,
                            "customDefaultValue": "domicilioEnElExtranjero",
                            "validate": {
                                "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "minLength": 1,
                                "maxLength": 50
                            },
                            "key": "domicilioEnElExtranjeroContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Folio Mercantil ",
                            "placeholder": "Ej. 57526",
                            "tableView": true,
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "maxLength": 20
                            },
                            "key": "folioMercantil",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaMoral"
                            },
                            "type": "textfield",
                            "input": true
                        },
                        {
                            "label": "Teléfono (con clave lada)",
                            "placeholder": "Ej. 55 5723 799",
                            "tableView": true,
                            "customDefaultValue": "telefonoExtranjero",
                            "validate": {
                                "required": true,
                                "pattern": "^[a-zA-ZÀ-ÿ0-9_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                                "customMessage": "Dato no válido",
                                "minLength": 1,
                                "maxLength": 20
                            },
                            "key": "telefonoExtranjeroContratante",
                            "conditional": {
                                "show": true,
                                "when": "tipoDePersonaContratante",
                                "eq": "personaFisica"
                            },
                            "type": "textfield",
                            "input": true
                        }
                    ],
                    "keyModified": true
                }
            ],
            "controller": "",
            "created": "2022-05-24T18:42:36.598Z",
            "display": "wizard",
            "key": "formDefinition",
            "machineName": "lndyrsvmkeoqqty:formAlaAzulDev",
            "modified": "2022-07-12T16:28:36.901Z",
            "owner": "614a594a05adf633b0ef9ffb",
            "path": "formalaazuldev",
            "project": "614e68a500a3576962caff43",
            "properties": {},
            "revisions": "",
            "settings": {},
            "submissionAccess": [],
            "tags": [],
            "title": "form-AlaAzul-dev",
            "type": "form"
        },
        "modelConfig": {
            "_id": "628d478a1b96700007dd7175",
            "key": "modelConfig",
            "configuration": {
                "allyKey": "COTIZADORES_SURA",
                "product": "alaAzul",
                "status": "",
                "folio": 0
            },
            "policy": {
                "officeId": 0,
                "productId": 606,
                "status": "W",
                "policyNumberCotizer": 0,
                "currencyId": "MXN",
                "atrGroupId": "",
                "atrSubgroupId": "",
                "atrProfileRateId": "",
                "atrPointSaleId": "",
                "userId": "",
                "atrTypeTemporality": "1"
            },
            "situations": [
                {
                    "riskNumber": 0,
                    "kinship": "",
                    "rfc": "",
                    "name": "",
                    "secondName": "",
                    "surname": "",
                    "secondSurname": "",
                    "birthdate": "",
                    "gender": "",
                    "phoneNumber": "",
                    "email": "",
                    "birthPlace": "",
                    "zipCodeId": "0",
                    "stateId": "0",
                    "coverages": []
                }
            ],
            "coverages": {
                "6636": true,
                "6637": true
            },
            "formPayment": {
                "periodicityPaymentId": "12",
                "paymentMethodId": "3",
                "paymentMethodDescrip": "TARJETA"
            },
            "form": {
                "fechaNacimiento": "",
                "codigoPostal": ""
            },
            "polizaCotizacion": {
                "oficina": 72,
                "ramo": 606,
                "estado": "W",
                "poliza": 8293,
                "suplemento": 0,
                "rfc": "XXXXXXX"
            }
        },
        "persistenceModel": {
            "_id": "620d721c53d452000608561e",
            "key": "persistenceModel",
            "configuracion": {
                "folio": "",
                "estadoFlujo": "",
                "ultimaPersistencia": {},
                "estadoBarraProgreso": []
            },
            "componentes": [],
            "cuestionariosMedicos": {},
            "datosAgente": {},
            "cotizaciones": [],
            "emisiones": []
        },
        "infoRequote": {
            "res": {
                "tipo_estado": "exito",
                "respuesta": {
                    "coveragePeople": [
                        {
                            "coverageName": "Un seguro que te protege en cada etapa de tu vida",
                            "coverageKey": "6636",
                            "isRequired": true,
                            "parentCoverageKey": null,
                            "rangeOfValuesByCurrency": {
                                "mxn": {
                                    "minimumSumInsured": 1000000,
                                    "maximumSumInsured": 1000000,
                                    "defaultSumInsured": 1000000
                                }
                            },
                            "coverageType": "BÁSICA",
                            "image": "img1",
                            "description": "Tú y tu familia estarán siempre protegidos con el respaldo económico necesario en caso de sufrir algún accidente o enfermedad.",
                            "benefits": [
                                {
                                    "image": "99640ced-c677-4256-8ece-f9edea969465_HabitacionHospitalaria%402x.png",
                                    "title": "Habitación hospitalaria",
                                    "description": "Habitación estándar y cama del acompañante."
                                },
                                {
                                    "image": "fffb6c42-64e2-4408-a5ab-ec3c83cdb4b3_ServiciosmEdicosQuirurgicos%402x.png",
                                    "title": "Servicios médicos quirúrgicos",
                                    "description": "Honorarios por intervenciones quirúrgicas, sala de operación y recuperación, equipo de anestesia, aplicación y transfusión de plasma, sueros, radioterapia, quimioterapia y unidad de servicios coronarios, oxígeno y medicamentos dentro del hospital."
                                },
                                {
                                    "image": "5328ec80-9971-4cbc-877b-dfee8b1314e3_HonorariosConsultasMedicas%402x.png",
                                    "title": "Honorarios por consultas médicas",
                                    "description": "Las consultas postoperatorias se incluyen dentro de los honorarios del médico."
                                },
                                {
                                    "image": "5d310c59-35fd-428b-9484-a201d4907ce6_HonorariosEnfermeras%402x.png",
                                    "title": "Honorarios por enfermeras",
                                    "description": "Cuando sea indicado por el médico tratante, con un máximo de 30 días con tres turnos por día (8 horas cada turno)."
                                },
                                {
                                    "image": "9017708c-864d-4ec5-95de-17e07870ce92_UnidadCuidadoIntensivo%402x.png",
                                    "title": "Unidad de cuidado intensivo",
                                    "description": "Estancia en terapia intensiva e intermedia y unidad de cuidados coronarios."
                                },
                                {
                                    "image": "d06fb415-95a9-4537-b983-648894a18af3_PagoMedicamentos%402x.png",
                                    "title": "Pago de medicamentos",
                                    "description": "Indicados por un médico y adquiridos fuera del hospital."
                                },
                                {
                                    "image": "f780d23f-b633-4b5c-8956-d106bff0e00a_ExámenesLaboratorioGabinete%402x.png",
                                    "title": "Exámenes de laboratorio y gabinete",
                                    "description": "Los necesarios para el diagnóstico y/o control médico de enfermedades o accidentes cubiertos."
                                },
                                {
                                    "image": "34a26e8a-f8b4-4b5c-ae0f-af106e68c917_AmbulanciaTerrestreLocal%402x.png",
                                    "title": "Ambulancia terrestre y local",
                                    "description": "Traslado en caso de emergencia médica a un hospital, 2 eventos por vigencia."
                                },
                                {
                                    "image": "9041b562-89ed-41c5-acbd-7df9f8607a41_AparatosProtesis%402x.png",
                                    "title": "Aparatos de prótesis",
                                    "description": "Prótesis ortopédicas, mamarias (solo en caso de cáncer), globo ocular, valvulares o cualquier otro tipo de prótesis que se requieran."
                                },
                                {
                                    "image": "b1c7e770-2178-4d86-8456-44d1f7947df6_Terapias%402x.png",
                                    "title": "Terapias",
                                    "description": "De cualquier tipo (excepto de aprendizaje) que requiera el asegurado. Límite de 30 sesiones sujeto a evaluar que se puedan extender."
                                },
                                {
                                    "image": "1c609679-bffa-4a8c-9dbe-ede948c355a9_PracticaOcasionalAmateurCualquierDeporte%402x.png",
                                    "title": "Práctica ocasional o amateur de cualquier deporte",
                                    "description": "No ampara carreras o competencias, ni la práctica de forma profesional."
                                },
                                {
                                    "image": "70d6bf73-3616-46de-9c39-31016e3250a3_RentaCompraAparatos%402x.png",
                                    "title": "Renta o compra de aparatos",
                                    "description": "Muletas, sillas de ruedas, camas especiales para enfermos y otros aparatos semejantes para rehabilitar al asegurado."
                                }
                            ]
                        },
                        {
                            "coverageName": "También protegemos a tu familia contra una enfermedad grave",
                            "coverageKey": "6637",
                            "isRequired": false,
                            "parentCoverageKey": "6636",
                            "rangeOfValuesByCurrency": {
                                "mxn": {
                                    "minimumSumInsured": 100000,
                                    "maximumSumInsured": 100000,
                                    "defaultSumInsured": 100000
                                }
                            },
                            "coverageType": "ADICIONAL",
                            "image": "2597ec45-b4ed-4734-8212-6f0b6d91d528_img-35-35.png",
                            "description": "Si se diagnostica una enfermedad grave* como cáncer, accidente cerebrovascular, trasplante de órganos o insuficiencia renal crónica, recibes $100,000 como indemnización.",
                            "benefits": []
                        }
                    ],
                    "policy": {
                        "allyKey": "COTIZADORES_SURA",
                        "product": "alaAzul",
                        "folio": 1001144,
                        "policy": {
                            "officeId": 72,
                            "productId": 606,
                            "status": "W",
                            "numberPolicy": 8292,
                            "folio": 1001144
                        },
                        "quotationExpires": null,
                        "costs": {
                            "amount": 1983.06,
                            "netPremium": 1709.54,
                            "policyRights": 0,
                            "policySurcharges": 0,
                            "netPremiumTaxes": 273.52,
                            "policyRightsTaxes": 0,
                            "discountValue": 0,
                            "firstPayment": 1983.06,
                            "subsequentPayment": 0
                        },
                        "situations": [
                            {
                                "numberSituation": 1,
                                "coverages": [
                                    {
                                        "coverageId": "6637",
                                        "amountSumInsurance": 0,
                                        "insuredAmount": 100000,
                                        "surcharge": "0.00",
                                        "deductible": null,
                                        "coinsurance": null,
                                        "franchise": null,
                                        "totalAmount": 48.92,
                                        "discountValueCoverage": 0
                                    },
                                    {
                                        "coverageId": "6636",
                                        "amountSumInsurance": 0,
                                        "insuredAmount": 1000000,
                                        "surcharge": "0.00",
                                        "deductible": "10",
                                        "coinsurance": "0",
                                        "franchise": "1",
                                        "totalAmount": 1660.62,
                                        "discountValueCoverage": 0
                                    }
                                ]
                            },
                            {
                                "numberSituation": 2,
                                "coverages": [
                                    {
                                        "coverageId": "6636",
                                        "amountSumInsurance": 0,
                                        "insuredAmount": 1000000,
                                        "surcharge": "0.00",
                                        "deductible": "10",
                                        "coinsurance": "0",
                                        "franchise": "1",
                                        "totalAmount": 1660.62,
                                        "discountValueCoverage": 0
                                    },
                                    {
                                        "coverageId": "6637",
                                        "amountSumInsurance": 0,
                                        "insuredAmount": 100000,
                                        "surcharge": "0.00",
                                        "deductible": null,
                                        "coinsurance": null,
                                        "franchise": null,
                                        "totalAmount": 48.92,
                                        "discountValueCoverage": 0
                                    }
                                ]
                            }
                        ]
                    }
                },
                "mensaje_estado": "La respuesta es correcta",
                "success": true,
                "renderMessage": {}
            },
            "infoRequest": {
                "url": "https://apimanagement-devqa.azure-api.net/api-dev/hogar/coverages-quotation",
                "method": "POST",
                "headers": {
                    "Content-Type": "application/json",
                    "Subscription-Key": "b92a0e969a234cc0be7fdd8654aa2589"
                },
                "body": {}
            }
        }
    },
    formResponses: [
        {
            "label": "Folio",
            "key": "folio",
            "type": "hidden",
            "input": true,
            "tableView": false,
            "value": 1001144
        },
        {
            "label": "Status",
            "key": "status",
            "type": "hidden",
            "input": true,
            "tableView": false,
            "defaultValue": "ACEPTAR",
            "value": "ACEPTAR"
        },
        {
            "label": "Aliado",
            "defaultValue": "COTIZADORES_SURA",
            "key": "claveAliado",
            "type": "hidden",
            "input": true,
            "tableView": false,
            "value": "COTIZADORES_SURA"
        },
        {
            "label": "CÓDIGO POSTAL",
            "placeholder": "Ej. 43540",
            "tableView": true,
            "validate": {
                "required": true,
                "minLength": 5,
                "maxLength": 5,
                "pattern": "^[0-9]*$",
                "customMessage": "Dato no válido"
            },
            "key": "codigoPostal",
            "type": "textfield",
            "input": true,
            "keyModified": true,
            "value": "01500"
        },
        {
            "label": "FECHA DE NACIMIENTO",
            "format": "DD/MM/YYYY",
            "tableView": false,
            "datePicker": {
                "disableWeekends": false,
                "disableWeekdays": false,
                "minDate": "1870-01-01T12:00:00-04:56",
                "maxDate": "2022-01-06T12:00:00-05:00"
            },
            "enableTime": false,
            "timePicker": {
                "showMeridian": false
            },
            "validate": {
                "required": true,
                "customMessage": "INGRESA UNA FECHA VÁLIDA"
            },
            "enableMinDateInput": false,
            "enableMaxDateInput": false,
            "key": "fechaNacimiento",
            "type": "datetime",
            "input": true,
            "widget": {
                "type": "calendar",
                "displayInTimezone": "viewer",
                "locale": "en",
                "useLocaleSettings": false,
                "allowInput": true,
                "mode": "single",
                "enableTime": false,
                "noCalendar": false,
                "format": "DD/MM/YYYY",
                "hourIncrement": 1,
                "minuteIncrement": 1,
                "time_24hr": true,
                "minDate": "1870-01-01T12:00:00-04:56",
                "disableWeekends": false,
                "disableWeekdays": false,
                "maxDate": "2022-01-06T12:00:00-05:00"
            },
            "value": "1999-01-01"
        },
        {
            "label": "Genero",
            "optionsLabelPosition": "right",
            "customClass": "radioImage",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "Femenino",
                    "value": "M",
                    "shortcut": ""
                },
                {
                    "label": "Masculino",
                    "value": "H",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "genero",
            "properties": {
                "H": "https://images.prismic.io/portal-cotizacion-suramex/a78811dd-60d4-4924-9ec2-87820d889191_hombre.gif",
                "M": "https://images.prismic.io/portal-cotizacion-suramex/8234458f-0287-4fe3-9491-e9d5058131e0_mujer.gif"
            },
            "type": "radio",
            "input": true,
            "value": "H"
        },
        {
            "label": "Tipo asegurados",
            "optionsLabelPosition": "right",
            "customClass": "radioImage",
            "inline": false,
            "tableView": false,
            "values": [
                {
                    "label": "Solo a ti",
                    "value": "T",
                    "shortcut": ""
                },
                {
                    "label": "A ti y tu familia",
                    "value": "F",
                    "shortcut": ""
                }
            ],
            "validate": {
                "required": true
            },
            "key": "claveTipoAsegurados",
            "properties": {
                "T": "https://images.prismic.io/portal-cotizacion-suramex/a78811dd-60d4-4924-9ec2-87820d889191_hombre.gif",
                "F": "https://images.prismic.io/portal-cotizacion-suramex/87e48b13-3d31-4233-b0f4-6d2e277de70f_familia.gif"
            },
            "type": "radio",
            "input": true,
            "value": "F"
        },
        {
            "label": "Parentesco",
            "widget": "choicesjs",
            "placeholder": "Elige el parentesco",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Cónyuge",
                        "value": "C"
                    },
                    {
                        "label": "Hijo(a)",
                        "value": "H"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "parentescoAsegurado",
            "type": "select",
            "input": true,
            "keyModified": true,
            "value": "H"
        },
        {
            "label": "Género",
            "widget": "choicesjs",
            "placeholder": "Elige el género",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Femenino",
                        "value": "M"
                    },
                    {
                        "label": "Masculino",
                        "value": "H"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "generoAsegurado",
            "properties": {
                "parentContainer": "asegurados"
            },
            "type": "select",
            "input": true,
            "keyModified": true,
            "value": "H"
        },
        {
            "label": "Fecha de nacimiento",
            "format": "DD/MM/YYYY",
            "tableView": false,
            "datePicker": {
                "disableWeekends": false,
                "disableWeekdays": false,
                "minDate": "1870-01-01T12:00:00-04:56",
                "maxDate": "2022-01-06T12:00:00-05:00"
            },
            "enableTime": false,
            "timePicker": {
                "showMeridian": false
            },
            "validate": {
                "required": true,
                "customMessage": "Ingresa una fecha válida"
            },
            "enableMinDateInput": false,
            "enableMaxDateInput": false,
            "key": "fechaNacimientoAsegurado",
            "properties": {
                "C": "18-60",
                "H": "1-36",
                "difference": "10"
            },
            "type": "datetime",
            "input": true,
            "widget": {
                "type": "calendar",
                "displayInTimezone": "viewer",
                "locale": "en",
                "useLocaleSettings": false,
                "allowInput": true,
                "mode": "single",
                "enableTime": false,
                "noCalendar": false,
                "format": "DD/MM/YYYY",
                "hourIncrement": 1,
                "minuteIncrement": 1,
                "time_24hr": true,
                "minDate": "1870-01-01T12:00:00-04:56",
                "disableWeekends": false,
                "disableWeekdays": false,
                "maxDate": "2022-01-06T12:00:00-05:00"
            },
            "keyModified": true,
            "value": "2009-01-01"
        },
        {
            "label": "Aceptar aviso de privacidad",
            "customClass": "readonly",
            "defaultValue": "Al continuar estás aceptando el <A HREF=\"https://invierteyahorra.suramexico.com/suramexico/aviso-de-privacidad-SUAM.html\" target=\"_blank\">aviso de privacidad</A>",
            "key": "avisoPrivacidad",
            "type": "hidden",
            "input": true,
            "tableView": false,
            "value": "Al continuar estás aceptando el <A HREF=\"https://invierteyahorra.suramexico.com/suramexico/aviso-de-privacidad-SUAM.html\" target=\"_blank\">aviso de privacidad</A>"
        },
        {
            "label": "Nombre",
            "placeholder": "Ej. Diana",
            "tableView": true,
            "validate": {
                "required": true,
                "minLength": 1,
                "maxLength": 100,
                "pattern": "^[a-zA-Z]+$",
                "customMessage": "Ingresa un nombre valido"
            },
            "key": "nombre",
            "type": "textfield",
            "input": true,
            "value": "JESUS"
        },
        {
            "label": "INGRESA TU E-MAIL",
            "placeholder": "ejemplo@gmail.com",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                "customMessage": "Ingrese un correo electrónico valido",
                "minLength": 1,
                "maxLength": 100
            },
            "key": "email",
            "type": "textfield",
            "input": true,
            "value": "sa@g.com"
        },
        {
            "label": "TELÉFONO CELULAR",
            "placeholder": "00 0000 0000",
            "inputMask": "99 9999 9999",
            "customClass": "textMask",
            "tableView": true,
            "validate": {
                "required": true,
                "minLength": 1,
                "maxLength": 10,
                "pattern": "^(?!.*?([1234567890])\\1{4,}|(1234567890))[0-9]*$",
                "customMessage": "Teléfono inválido"
            },
            "key": "telefono",
            "type": "textfield",
            "input": true,
            "value": "2123123124"
        },
        {
            "label": "RFC",
            "placeholder": "Digita el RFC",
            "tableView": true,
            "validate": {
                "required": true,
                "minLength": 13,
                "maxLength": 13,
                "pattern": "^[a-zA-Z0-9]*$",
                "customMessage": "Dato no válido"
            },
            "key": "identificadorPersonaTitular-1657717711",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "AOMJ8308302W7"
        },
        {
            "label": "Nombre",
            "placeholder": "Ej. Juan",
            "tableView": true,
            "customDefaultValue": "nombre",
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "primerNombreTitular-1657717711",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "JESUS"
        },
        {
            "label": "Apellido paterno",
            "placeholder": "Ej. Rodriguez",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "primerApellidoTitular-1657717711",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "ACOSTA"
        },
        {
            "label": "Apellido materno",
            "placeholder": "Ej. Martinez",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "segundoApellidoTitular-1657717711",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "MAYA"
        },
        {
            "label": "Fecha de Nacimiento",
            "format": "DD/MM/YYYY",
            "tableView": false,
            "datePicker": {
                "disableWeekends": false,
                "disableWeekdays": false,
                "minDate": "1870-01-01T12:00:00-04:56",
                "maxDate": "2021-01-01T12:00:00-05:00"
            },
            "customDefaultValue": "fechaNacimiento",
            "validate": {
                "required": true,
                "customMessage": "INGRESA UNA FECHA VÁLIDA"
            },
            "enableMinDateInput": false,
            "enableMaxDateInput": false,
            "key": "fechaNacimientoTitular-1657717711",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "datetime",
            "input": true,
            "widget": {
                "type": "calendar",
                "displayInTimezone": "viewer",
                "locale": "en",
                "useLocaleSettings": false,
                "allowInput": true,
                "mode": "single",
                "enableTime": true,
                "noCalendar": false,
                "format": "DD/MM/YYYY",
                "hourIncrement": 1,
                "minuteIncrement": 1,
                "time_24hr": false,
                "minDate": "1870-01-01T12:00:00-04:56",
                "disableWeekends": false,
                "disableWeekdays": false,
                "maxDate": "2021-01-01T12:00:00-05:00"
            },
            "value": "1990-01-01"
        },
        {
            "label": "TELÉFONO CELULAR",
            "placeholder": "00 0000 0000",
            "inputMask": "99 9999 9999",
            "customClass": "textMask",
            "tableView": true,
            "customDefaultValue": "telefono",
            "validate": {
                "required": true,
                "minLength": 1,
                "maxLength": 10,
                "pattern": "^(?!.*?([1234567890])\\1{4,}|(1234567890))[0-9]*$",
                "customMessage": "Teléfono inválido"
            },
            "key": "telefonoCelularTitular-1657717711",
            "type": "textfield",
            "input": true,
            "keyModified": true,
            "value": "2123123124"
        },
        {
            "label": "CORREO ELECTRÓNICO",
            "placeholder": "ejemplo@gmail.com",
            "tableView": true,
            "customDefaultValue": "email",
            "validate": {
                "required": true,
                "minLength": 1,
                "maxLength": 100,
                "pattern": "^((\"[\\w-\\s]+\")|([\\w-]+(?:\\.[\\w-]+)*)|(\"[\\w-\\s]+\")([\\w-]+(?:\\.[\\w-]+)*))(@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$)|(@\\[?((25[0-5]\\.|2[0-4][0-9]\\.|1[0-9]{2}\\.|[0-9]{1,2}\\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\\]?$)",
                "customMessage": "Ingrese un correo electrónico valido"
            },
            "key": "emailTitular-1657717711",
            "type": "textfield",
            "input": true,
            "value": "sa@g.com"
        },
        {
            "label": "RFC",
            "placeholder": "Digita el RFC",
            "tableView": true,
            "validate": {
                "required": true,
                "minLength": 13,
                "maxLength": 13,
                "pattern": "^[a-zA-Z0-9]*$",
                "customMessage": "Dato no válido"
            },
            "key": "identificadorPersonaAdicional-1657717725",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "AOMJ8308302W7"
        },
        {
            "label": "Nombre",
            "placeholder": "Ej. Juan",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "primerNombreAdicional-1657717725",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "JESUS"
        },
        {
            "label": "Apellido paterno",
            "placeholder": "Ej. Rodriguez",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "primerApellidoAdicional-1657717725",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "ACOSTA"
        },
        {
            "label": "Apellido materno",
            "placeholder": "Ej. Martinez",
            "tableView": true,
            "validate": {
                "required": true,
                "pattern": "^[a-zA-ZÀ-ÿ_ \\u00f1\\u00d1]+(([',. -][a-zA-ZÀ-ÿ\\u00f1\\u00d1 ])?[a-zA-ZÀ-ÿ\\u00f1\\u00d1]*)*$",
                "customMessage": "Dato no válido"
            },
            "key": "segundoApellidoAdicional-1657717725",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "textfield",
            "input": true,
            "value": "MAYA"
        },
        {
            "label": "Fecha de Nacimiento",
            "format": "DD/MM/YYYY",
            "tableView": false,
            "datePicker": {
                "disableWeekends": false,
                "disableWeekdays": false,
                "minDate": "1870-01-01T12:00:00-04:56",
                "maxDate": "2021-01-01T12:00:00-05:00"
            },
            "validate": {
                "required": true,
                "customMessage": "INGRESA UNA FECHA VÁLIDA"
            },
            "enableMinDateInput": false,
            "enableMaxDateInput": false,
            "key": "fechaNacimientoAdicional-1657717725",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "datetime",
            "input": true,
            "widget": {
                "type": "calendar",
                "displayInTimezone": "viewer",
                "locale": "en",
                "useLocaleSettings": false,
                "allowInput": true,
                "mode": "single",
                "enableTime": true,
                "noCalendar": false,
                "format": "DD/MM/YYYY",
                "hourIncrement": 1,
                "minuteIncrement": 1,
                "time_24hr": false,
                "minDate": "1870-01-01T12:00:00-04:56",
                "disableWeekends": false,
                "disableWeekdays": false,
                "maxDate": "2021-01-01T12:00:00-05:00"
            },
            "value": "1990-01-01"
        },
        {
            "label": "Género",
            "widget": "choicesjs",
            "placeholder": "Elige género",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Femenino",
                        "value": "M"
                    },
                    {
                        "label": "Masculino",
                        "value": "H"
                    }
                ]
            },
            "customDefaultValue": "genero",
            "validate": {
                "required": true
            },
            "key": "sexoTitular-1657717711",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true,
            "value": "H"
        },
        {
            "label": "Género",
            "widget": "choicesjs",
            "placeholder": "Elige género",
            "tableView": true,
            "data": {
                "values": [
                    {
                        "label": "Femenino",
                        "value": "M"
                    },
                    {
                        "label": "Masculino",
                        "value": "H"
                    }
                ]
            },
            "validate": {
                "required": true
            },
            "key": "sexoAdicional-1657717725",
            "conditional": {
                "show": true,
                "when": "tipoDePersonaContratante",
                "eq": "personaFisica"
            },
            "type": "select",
            "input": true,
            "value": "M"
        },
        {
            "label": "Los datos del contratante son los mismos que los del asegurado",
            "customClass": "radioButton",
            "tableView": false,
            "defaultValue": true,
            "key": "datosContratanteIgualAsegurado",
            "properties": {
                "autocomplete": "true"
            },
            "type": "checkbox",
            "input": true,
            "value": false
        },
        {
            "label": "TIPO DE PERSONA",
            "optionsLabelPosition": "right",
            "customClass": "noMap",
            "inline": false,
            "tableView": false,
            "defaultValue": "personaFisica",
            "values": [
                {
                    "label": "PERSONA FÍSICA",
                    "value": "personaFisica",
                    "shortcut": ""
                },
                {
                    "label": "PERSONA MORAL",
                    "value": "personaMoral",
                    "shortcut": ""
                }
            ],
            "customDefaultValue": "tipoDePersona",
            "validate": {
                "required": true
            },
            "key": "tipoDePersonaContratante",
            "conditional": {
                "show": true,
                "when": "datosContratanteIgualAsegurado",
                "eq": "false"
            },
            "type": "radio",
            "input": true,
            "value": "personaFisica"
        },
        {
            "label": "No soy un robot",
            "customClass": "recaptcha",
            "tableView": false,
            "defaultValue": false,
            "validate": {
                "required": true
            },
            "key": "noSoyUnRobot",
            "type": "checkbox",
            "input": true,
            "value": false
        }
    ],
    hiddenFields: [],
    disabledFields: {}
};

export const responseNumSequence = {
    "status_type": "exito",
    "respuesta": {
        numFolio: "343443"
    }
};
export const responseServiceEmail = {
    "success": true,
    "messages": "Correo enviado",
    "mail": {
        "to": "storres@pratechgroup.com",
        "from": "Leonardo.Marcos@segurossura.com.mx"
    }
}

export const responseIsFinalScreen = {
    "tipo_estado": "exito",
    "respuesta": {
        "url": "https://suramericana.com.co"
    },
    "mensaje_estado": "La respuesta es correcta",
    "renderMessage": {
        isFinalScreen: true,
        title: "Lo sentimos...",
        body: "Desafortunadamente no contamos con un seguro de vida que se adecue a tu perfil.",
    }
}

export const response = {
    "tipo_estado": "exito",
    "respuesta": {
        "url": "https://suramericana.com.co"
    },
    "mensaje_estado": "La respuesta es correcta",
    "renderMessage": {
        isFinalScreen: true,
        title: "Lo sentimos...",
        body: "Desafortunadamente no contamos con un seguro de vida que se adecue a tu perfil.",
    }
}

export const responseWithDecline = {
    status: "DECLINAR",
    messages: ["El valor de IMC no se encuentra en el catálogo de IMC"],
    success: false,
    renderMessage: {
        title: "Lo sentimos...",
        body: "Desafortunadamente no contamos con un seguro de vida que se adecue a tu perfil.",
    },
};

export const responseNextStep = {
    status: "ACEPTAR",
    porcentajeExtraPrimaSituacion: null,
    messages: [],
    success: true,
};

export const responseNextStepFalse = {
    status: "ACEPTAR",
    porcentajeExtraPrimaSituacion: 0,
    messages: [],
    success: false,
    renderMessage: {
        title: "Lo sentimos...",
        body: "Desafortunadamente no contamos con un seguro de vida que se adecue a tu perfil.",
    },
};

export const responseSendRequest = {
    status: "ACEPTAR",
    porcentajeExtraPrimaSituacion: null,
    messages: [],
    success: true,
    respuesta: { data: { poliza: "36654" } }
};

export const responseBackgroundService = {
    status: "ACEPTAR",
    porcentajeExtraPrimaSituacion: 0,
    messages: [],
    success: true,
    respuesta: { url: "https://tuseguro-qa.segurossura.com.mx/plan-vive" }
};

export const customRequest = () => {
    return responseNextStep;
};


export const responseNumSequenceService = {
    tipo_estado: "exito",
    success: true,
    respuesta: {
        policy: { policy: { numberPolicy: '' }, costs: { amount: 4 } },
        configuracion: {
            estadoFlujo: 'Activo',
            ultimaPersistencia: [],
            estadoBarraProgreso: [
                {
                    key_step: 'step_informacion_asegurados',
                    name: 'Información asegurados',
                    current: 0,
                    quantity: 0,
                    active: true
                },
                {
                    key_step: 'step_emision_contratante',
                    name: 'Emisión Contratante',
                    current: 0,
                    quantity: 0,
                    active: false
                }
            ]
        },
        componentes: [{}],
        insureds: [{}],
        insuredsActive: {},
        urlPayment: [{ url: '', validity: '' }]
    }
};

export const newFormDefinition = [
    {
        "title": "step_cotizacion",
        "breadcrumbClickable": true,
        "buttonSettings": {
            "previous": true,
            "cancel": true,
            "next": true
        },
        "navigateOnEnter": false,
        "saveOnEnter": false,
        "scrollToTop": false,
        "collapsible": false,
        "key": "step_cotizacion",
        "type": "panel",
        "label": "Page 3",
        "input": false,
        "tableView": false,
        "components": [
            {
                "label": "Coberturas",
                "tag": "json",
                "attrs": [
                    {
                        "attr": "",
                        "value": ""
                    }
                ],
                "content": "{\r\n\t\"url\": \"https://apimanagement-devqa.azure-api.net/api-dev/hogar/coverages-quotation\",\r\n\t\"method\": \"POST\",\r\n\t\"headers\": {\r\n\t\t\"Content-Type\": \"application/json\",\r\n\t\t\"Subscription-Key\": \"b92a0e969a234cc0be7fdd8654aa2589\"\r\n\t},\r\n\t\"body\": {}\r\n}",
                "refreshOnChange": false,
                "customClass": "basicCard",
                "key": "coberturas",
                "type": "htmlelement",
                "input": false,
                "tableView": false
            }
        ],
        "keyModified": true
    }
]

export const insuredsError = [
    {
        "key": 1657717711,
        "type": "T",
        "img": "https://images.prismic.io/portal-cotizacion-suramex/a78811dd-60d4-4924-9ec2-87820d889191_hombre.gif",
        "gender": "H",
        "age": "1990-01-01",
        "name": "JESUS",
        "surname": "ACOSTA",
        "secondSurname": "MAYA",
        "rfc": "AOMJ8308302W7"
    },
    {
        "key": 1657717725,
        "type": "H",
        "img": "https://images.prismic.io/portal-cotizacion-suramex/8234458f-0287-4fe3-9491-e9d5058131e0_mujer.gif",
        "gender": "M",
        "age": "01/01/1990",
        "name": "JESUS",
        "surname": "ACOSTA",
        "secondSurname": "MAYA",
        "rfc": "AOMJ8308302W7"
    }
]
export const insured = [
    {
        "key": 1657717711,
        "type": "T",
        "img": "https://images.prismic.io/portal-cotizacion-suramex/a78811dd-60d4-4924-9ec2-87820d889191_hombre.gif",
        "gender": "H",
        "age": "1990-01-01",
        "name": "JESUS",
        "surname": "ACOSTA",
        "secondSurname": "MAYA",
        "rfc": "AOMJ8308302W7"
    }
]
export const insureds = [
    {
        "key": 1657717711,
        "type": "T",
        "img": "https://images.prismic.io/portal-cotizacion-suramex/a78811dd-60d4-4924-9ec2-87820d889191_hombre.gif",
        "gender": "H",
        "age": "1990-01-01",
        "name": "JESUS",
        "surname": "ACOSTA",
        "secondSurname": "MAYA",
        "rfc": "AOMJ8308302W7"
    },
    {
        "key": 1657717725,
        "type": "C",
        "img": "https://images.prismic.io/portal-cotizacion-suramex/8234458f-0287-4fe3-9491-e9d5058131e0_mujer.gif",
        "gender": "M",
        "age": "01/01/1990",
        "name": "JESUS",
        "surname": "ACOSTA",
        "secondSurname": "MAYA",
        "rfc": "AOMJ8308302W7"
    }
]

export const priceToShow = '';
export const disabledButtonContinue = false;
export const tokenInfo = {
    "usuarioId": "OPS$PRUEBCAL",
    "clavesAgente": null,
    "atrGrupoId": "04320",
    "name": "Neo testdd",
    "email": "rubera_x13@hotmail.com",
    "solucionId": "SOL004",
    "ramoId": "606",
    "atrPuntoVentaId": "103032",
    "oficinaId": "1",
    "oficinaDescripcion": "OFICINA MEXICO, D.F.",
    "atrSubgrupoId": "0432000001",
    "atrPerfilTarifaId": "6060000001",
    "agenteId": "003032",
    "nombreAgente": "JOSE CUAUHTEMOC AVALOS DIAZ",
    "nombrePromotor": "HOMERO RICARDO GONZALEZ CRUZ",
    "promotorId": "728",
    "iat": 1653601777,
    "exp": 1653688177
};
export const checkOption = "";
export const fileRequest = () => { };
export const setFolio = () => { };
export const setFormValues = () => { };
export const setTokenInfo = () => { };
export const setShowFinalMessage = () => { };
export const setBackgroundServiceResponse = () => { };
export const setShowAlert = () => { };
export const setHomePageData = () => { };
export const setIsSendForm = () => { };
export const setDataParam = () => { };
export const setDataForm = () => { };
export const setFormStatus = () => { };
export const setReturnButton = () => { };
export const setSkipCoverages = () => { };
export const setDisabledButtonContinue = () => { };
export const setShowHomePage = () => { };
export const setLoadingProcedure = () => { };
export const setResponseCotizacion = () => { };
export const setPriceToShow = () => { };
export const setPrice = () => { };
export const setProgressStep = () => { };
export const setResponsesRequest = () => { };